//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class AiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    transform(request: AiTransformRequest): Promise<AiTransformResponse> {
        let url_ = this.baseUrl + "/ai/transform";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTransform(_response);
        });
    }

    protected processTransform(response: Response): Promise<AiTransformResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AiTransformResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AiTransformResponse>(null as any);
    }
}

export class AuthClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    whoAmI(dnetUserName: string | null | undefined): Promise<WhoAmIResponse> {
        let url_ = this.baseUrl + "/auth/whoAmI?";
        if (dnetUserName !== undefined && dnetUserName !== null)
            url_ += "dnetUserName=" + encodeURIComponent("" + dnetUserName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWhoAmI(_response);
        });
    }

    protected processWhoAmI(response: Response): Promise<WhoAmIResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WhoAmIResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WhoAmIResponse>(null as any);
    }

    isNativeBc(): Promise<boolean> {
        let url_ = this.baseUrl + "/auth/isNativeBc";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIsNativeBc(_response);
        });
    }

    protected processIsNativeBc(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    refreshAuthToken(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/auth/refreshAuthToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRefreshAuthToken(_response);
        });
    }

    protected processRefreshAuthToken(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    login(request: LoginRequest): Promise<LoginResponse> {
        let url_ = this.baseUrl + "/auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<LoginResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoginResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginResponse>(null as any);
    }

    changeInstance(instance: SafeDatabaseInstance): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/auth/changeInstance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(instance);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangeInstance(_response);
        });
    }

    protected processChangeInstance(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getAntiforgeryToken(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/auth/xsrfToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAntiforgeryToken(_response);
        });
    }

    protected processGetAntiforgeryToken(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    logout(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/auth/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    changePassword(request: ChangePasswordRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/auth/changePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    forgotPassword(request: ForgotPasswordRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/auth/forgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processForgotPassword(_response);
        });
    }

    protected processForgotPassword(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    ssoLogin(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/auth/sso-login";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSsoLogin(_response);
        });
    }

    protected processSsoLogin(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    ssoLogout(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/auth/sso-logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSsoLogout(_response);
        });
    }

    protected processSsoLogout(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class CustomersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getCustomers(): Promise<GetCustomersResponse> {
        let url_ = this.baseUrl + "/customers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomers(_response);
        });
    }

    protected processGetCustomers(response: Response): Promise<GetCustomersResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCustomersResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCustomersResponse>(null as any);
    }

    getAvailableSysPrins(request: GetAvailableSysPrinsRequest): Promise<GetAvailableSysPrinsResponse> {
        let url_ = this.baseUrl + "/customers/availableSysPrins";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAvailableSysPrins(_response);
        });
    }

    protected processGetAvailableSysPrins(response: Response): Promise<GetAvailableSysPrinsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAvailableSysPrinsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAvailableSysPrinsResponse>(null as any);
    }

    getVantageQueriesForCustomer(request: GetVantageQueryForCustomerRequest): Promise<GetVantageQueryForCustomerResponse> {
        let url_ = this.baseUrl + "/customers/GetVantageQueries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVantageQueriesForCustomer(_response);
        });
    }

    protected processGetVantageQueriesForCustomer(response: Response): Promise<GetVantageQueryForCustomerResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetVantageQueryForCustomerResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetVantageQueryForCustomerResponse>(null as any);
    }
}

export class DiagnosticClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getDeploymentInfo(): Promise<DiagnosticResponse> {
        let url_ = this.baseUrl + "/diagnostics/deploymentInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDeploymentInfo(_response);
        });
    }

    protected processGetDeploymentInfo(response: Response): Promise<DiagnosticResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiagnosticResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiagnosticResponse>(null as any);
    }
}

export class DocTypesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getDocTypes(request: GetDocTypesRequest): Promise<GetDocTypesResponse> {
        let url_ = this.baseUrl + "/docTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDocTypes(_response);
        });
    }

    protected processGetDocTypes(response: Response): Promise<GetDocTypesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDocTypesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetDocTypesResponse>(null as any);
    }

    getDocTypesForTargetDB(request: GetCopyDestinationDocTypesForTargetDBRequest): Promise<GetCopyDestinationDocTypesForTargetDBResponse> {
        let url_ = this.baseUrl + "/docTypes/getDocTypesForTargetDB";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDocTypesForTargetDB(_response);
        });
    }

    protected processGetDocTypesForTargetDB(response: Response): Promise<GetCopyDestinationDocTypesForTargetDBResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCopyDestinationDocTypesForTargetDBResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCopyDestinationDocTypesForTargetDBResponse>(null as any);
    }
}

export class GraphicsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getGraphicsBySysPrins(request: GetGraphicsBySysPrinsRequest): Promise<GetGraphicsBySysPrinsResponse> {
        let url_ = this.baseUrl + "/graphics/getGraphicsBySysPrins";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetGraphicsBySysPrins(_response);
        });
    }

    protected processGetGraphicsBySysPrins(response: Response): Promise<GetGraphicsBySysPrinsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGraphicsBySysPrinsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGraphicsBySysPrinsResponse>(null as any);
    }

    getGraphicById(request: GetGraphicByIdRequest): Promise<GetGraphicByIdResponse> {
        let url_ = this.baseUrl + "/graphics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetGraphicById(_response);
        });
    }

    protected processGetGraphicById(response: Response): Promise<GetGraphicByIdResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGraphicByIdResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGraphicByIdResponse>(null as any);
    }
}

export class HeartbeatClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    reactHeartbeat(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/heartbeat/reactHeartbeat";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReactHeartbeat(_response);
        });
    }

    protected processReactHeartbeat(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    heartbeat(): Promise<string> {
        let url_ = this.baseUrl + "/heartbeat/heartbeat";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHeartbeat(_response);
        });
    }

    protected processHeartbeat(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class LocationsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getLocations(request: GetLocationsRequest): Promise<GetLocationsResponse> {
        let url_ = this.baseUrl + "/locations/locations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLocations(_response);
        });
    }

    protected processGetLocations(response: Response): Promise<GetLocationsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLocationsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetLocationsResponse>(null as any);
    }

    getLocationsWithDetails(request: GetLocationsWithDetailsRequest): Promise<GetLocationsWithDetailsResponse> {
        let url_ = this.baseUrl + "/locations/locationsWithDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLocationsWithDetails(_response);
        });
    }

    protected processGetLocationsWithDetails(response: Response): Promise<GetLocationsWithDetailsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLocationsWithDetailsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetLocationsWithDetailsResponse>(null as any);
    }

    getFirstUnusedRankForLocationAndSysPrin(request: GetFirstUnusedRankForLocationAndSysPrinRequest): Promise<GetFirstUnusedRankForLocationAndSysPrinResponse> {
        let url_ = this.baseUrl + "/locations/FirstUnusedRankForLocationAndSysPrin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFirstUnusedRankForLocationAndSysPrin(_response);
        });
    }

    protected processGetFirstUnusedRankForLocationAndSysPrin(response: Response): Promise<GetFirstUnusedRankForLocationAndSysPrinResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFirstUnusedRankForLocationAndSysPrinResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetFirstUnusedRankForLocationAndSysPrinResponse>(null as any);
    }
}

export class MessagesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getMessages(request: GetMessagesRequest): Promise<GetMessagesResponse> {
        let url_ = this.baseUrl + "/messages/getMessages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMessages(_response);
        });
    }

    protected processGetMessages(response: Response): Promise<GetMessagesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMessagesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetMessagesResponse>(null as any);
    }

    getTrashBinMessages(request: GetTrashBinMessagesRequest): Promise<GetTrashBinMessagesResponse> {
        let url_ = this.baseUrl + "/messages/getTrashBinMessages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTrashBinMessages(_response);
        });
    }

    protected processGetTrashBinMessages(response: Response): Promise<GetTrashBinMessagesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTrashBinMessagesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetTrashBinMessagesResponse>(null as any);
    }

    getExternalClientGroups(sysPrins: SysPrinDto[]): Promise<GetExternalClientGroupsResponse> {
        let url_ = this.baseUrl + "/messages/getExternalClientGroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sysPrins);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExternalClientGroups(_response);
        });
    }

    protected processGetExternalClientGroups(response: Response): Promise<GetExternalClientGroupsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExternalClientGroupsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetExternalClientGroupsResponse>(null as any);
    }

    restoreMessage(request: RestoreMessageRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/messages/restoreMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRestoreMessage(_response);
        });
    }

    protected processRestoreMessage(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getReplacementVariablesAvailableToMessage(request: GetReplacementVariablesAvailableToMessageRequest): Promise<GetReplacementVariablesAvailableToMessageResponse> {
        let url_ = this.baseUrl + "/messages/getReplacementVariablesAvailableToMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetReplacementVariablesAvailableToMessage(_response);
        });
    }

    protected processGetReplacementVariablesAvailableToMessage(response: Response): Promise<GetReplacementVariablesAvailableToMessageResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetReplacementVariablesAvailableToMessageResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetReplacementVariablesAvailableToMessageResponse>(null as any);
    }

    getDepartments(docTypePrimaryKey: number | undefined): Promise<GetDepartmentsResponse> {
        let url_ = this.baseUrl + "/messages/getDepartments?";
        if (docTypePrimaryKey === null)
            throw new Error("The parameter 'docTypePrimaryKey' cannot be null.");
        else if (docTypePrimaryKey !== undefined)
            url_ += "docTypePrimaryKey=" + encodeURIComponent("" + docTypePrimaryKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDepartments(_response);
        });
    }

    protected processGetDepartments(response: Response): Promise<GetDepartmentsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDepartmentsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetDepartmentsResponse>(null as any);
    }

    createDepartment(request: CreateDepartmentRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/messages/createDepartments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateDepartment(_response);
        });
    }

    protected processCreateDepartment(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    updateDepartment(request: UpdateDepartmentRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/messages/updateDepartments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateDepartment(_response);
        });
    }

    protected processUpdateDepartment(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    deleteDepartment(request: DeleteDepartmentRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/messages/deleteDepartments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteDepartment(_response);
        });
    }

    protected processDeleteDepartment(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getLanguages(request: GetLanguagesRequest): Promise<GetLanguagesResponse> {
        let url_ = this.baseUrl + "/messages/languages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLanguages(_response);
        });
    }

    protected processGetLanguages(response: Response): Promise<GetLanguagesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLanguagesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetLanguagesResponse>(null as any);
    }

    getMessageDetails(request: GetMessageDetailsRequest): Promise<GetMessageDetailsResponse> {
        let url_ = this.baseUrl + "/messages/messageDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMessageDetails(_response);
        });
    }

    protected processGetMessageDetails(response: Response): Promise<GetMessageDetailsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMessageDetailsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetMessageDetailsResponse>(null as any);
    }

    doesMessageExist(request: DoesMessageExistRequest): Promise<DoesMessageExistResponse> {
        let url_ = this.baseUrl + "/messages/doesMessageExist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDoesMessageExist(_response);
        });
    }

    protected processDoesMessageExist(response: Response): Promise<DoesMessageExistResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DoesMessageExistResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DoesMessageExistResponse>(null as any);
    }

    deleteMessages(request: DeleteMessagesRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/messages/deleteMessages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteMessages(_response);
        });
    }

    protected processDeleteMessages(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    moveMessagesToTrash(request: MoveMessagesToTrashRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/messages/moveMessagesToTrash";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMoveMessagesToTrash(_response);
        });
    }

    protected processMoveMessagesToTrash(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    createMessagesCopies(request: CreateMessageCopiesRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/messages/createMessagesCopies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateMessagesCopies(_response);
        });
    }

    protected processCreateMessagesCopies(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    emailCopyMessageErrors(request: EmailCopyMessageErrorsRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/messages/emailCopyMessageErrors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEmailCopyMessageErrors(_response);
        });
    }

    protected processEmailCopyMessageErrors(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    exportMassUpdateMessages(request: ExportMassUpdateMessagesRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/messages/exportMassUpdateMessages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportMassUpdateMessages(_response);
        });
    }

    protected processExportMassUpdateMessages(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    importMassUpdateMessages(request: ImportMassUpdateMessagesRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/messages/importMassUpdateMessages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImportMassUpdateMessages(_response);
        });
    }

    protected processImportMassUpdateMessages(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    changeRanks(request: ChangeRanksRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/messages/changeRanks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangeRanks(_response);
        });
    }

    protected processChangeRanks(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    changeMessageStatuses(request: ChangeMessageStatusesRequest): Promise<ChangeMessageStatusResponse> {
        let url_ = this.baseUrl + "/messages/changeMessageStatuses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangeMessageStatuses(_response);
        });
    }

    protected processChangeMessageStatuses(response: Response): Promise<ChangeMessageStatusResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangeMessageStatusResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangeMessageStatusResponse>(null as any);
    }

    changeMessageStatus(request: ChangeMessageStatusRequest): Promise<ChangeMessageStatusResponse> {
        let url_ = this.baseUrl + "/messages/changeMessageStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangeMessageStatus(_response);
        });
    }

    protected processChangeMessageStatus(response: Response): Promise<ChangeMessageStatusResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangeMessageStatusResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangeMessageStatusResponse>(null as any);
    }

    saveMessage(request: SaveMessageRequest): Promise<SaveMessageResponse> {
        let url_ = this.baseUrl + "/messages/saveNewMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveMessage(_response);
        });
    }

    protected processSaveMessage(response: Response): Promise<SaveMessageResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveMessageResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveMessageResponse>(null as any);
    }

    updateMessage(request: SaveMessageRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/messages/updateExistingMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateMessage(_response);
        });
    }

    protected processUpdateMessage(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getPDFPreview(request: GetPdfPreviewRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/messages/getPDFPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPDFPreview(_response);
        });
    }

    protected processGetPDFPreview(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getSinglePDFPreview(request: GetSinglePdfPreviewRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/messages/getSinglePDFPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSinglePDFPreview(_response);
        });
    }

    protected processGetSinglePDFPreview(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getFileStream(filePath: string | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/messages/getFileStream?";
        if (filePath === null)
            throw new Error("The parameter 'filePath' cannot be null.");
        else if (filePath !== undefined)
            url_ += "filePath=" + encodeURIComponent("" + filePath) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFileStream(_response);
        });
    }

    protected processGetFileStream(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    validateMessage(request: MessageValidationRequest): Promise<OlmMessageValidationResults> {
        let url_ = this.baseUrl + "/messages/ValidateMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processValidateMessage(_response);
        });
    }

    protected processValidateMessage(response: Response): Promise<OlmMessageValidationResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OlmMessageValidationResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OlmMessageValidationResults>(null as any);
    }

    getSecondaryMessagesAvailableForLinking(request: GetSecondaryMessagesAvailableForLinkingRequest): Promise<GetSecondaryMessagesAvailableForLinkingResponse> {
        let url_ = this.baseUrl + "/messages/getSecondaryMessagesAvailableForLinking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSecondaryMessagesAvailableForLinking(_response);
        });
    }

    protected processGetSecondaryMessagesAvailableForLinking(response: Response): Promise<GetSecondaryMessagesAvailableForLinkingResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSecondaryMessagesAvailableForLinkingResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetSecondaryMessagesAvailableForLinkingResponse>(null as any);
    }

    getAvailableMessageTypes(): Promise<GetAvailableMessageTypesResponse> {
        let url_ = this.baseUrl + "/messages/getAvailableMessageTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAvailableMessageTypes(_response);
        });
    }

    protected processGetAvailableMessageTypes(response: Response): Promise<GetAvailableMessageTypesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAvailableMessageTypesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAvailableMessageTypesResponse>(null as any);
    }

    getDuplicateRankWarningMessage(request: GetDuplicateRankWarningMessageRequest): Promise<GetDuplicateRankWarningMessageResponse> {
        let url_ = this.baseUrl + "/messages/getDuplicateRankWarningMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDuplicateRankWarningMessage(_response);
        });
    }

    protected processGetDuplicateRankWarningMessage(response: Response): Promise<GetDuplicateRankWarningMessageResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDuplicateRankWarningMessageResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetDuplicateRankWarningMessageResponse>(null as any);
    }

    getMessageSearchResults(request: GetMessageSearchResultRequest): Promise<GetMessageSearchResultResponse> {
        let url_ = this.baseUrl + "/messages/messageSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMessageSearchResults(_response);
        });
    }

    protected processGetMessageSearchResults(response: Response): Promise<GetMessageSearchResultResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMessageSearchResultResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetMessageSearchResultResponse>(null as any);
    }
}

export class ReportingClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    messageValidationReport(sysPrin: string | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/reporting/msgValidationReport?";
        if (sysPrin === null)
            throw new Error("The parameter 'sysPrin' cannot be null.");
        else if (sysPrin !== undefined)
            url_ += "sysPrin=" + encodeURIComponent("" + sysPrin) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMessageValidationReport(_response);
        });
    }

    protected processMessageValidationReport(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getAvailableSearchCriteriaForMessagesReport(request: GetAvailableSearchCriteriaForMessagesReportRequest): Promise<GetAvailableSearchCriteriaForMessagesReportResponse> {
        let url_ = this.baseUrl + "/reporting/getAvailableSearchCriteriaForMessagesReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAvailableSearchCriteriaForMessagesReport(_response);
        });
    }

    protected processGetAvailableSearchCriteriaForMessagesReport(response: Response): Promise<GetAvailableSearchCriteriaForMessagesReportResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAvailableSearchCriteriaForMessagesReportResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAvailableSearchCriteriaForMessagesReportResponse>(null as any);
    }

    validateUserSelectionsforMessageReport(request: ValidateUserSelectionsforMessageReportRequest): Promise<ValidateUserSelectionsforMessageReportResponse> {
        let url_ = this.baseUrl + "/reporting/validateUserSelectionsforMessageReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processValidateUserSelectionsforMessageReport(_response);
        });
    }

    protected processValidateUserSelectionsforMessageReport(response: Response): Promise<ValidateUserSelectionsforMessageReportResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidateUserSelectionsforMessageReportResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidateUserSelectionsforMessageReportResponse>(null as any);
    }

    exportMessageReport(request: ExportMessageReportRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/reporting/exportReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportMessageReport(_response);
        });
    }

    protected processExportMessageReport(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getAvailableSearchCriteriaForPostQualReport(request: GetAvailableSearchCriteriaForPostQualReportRequest): Promise<GetAvailableSearchCriteriaForPostQualReportResponse> {
        let url_ = this.baseUrl + "/reporting/getAvailableSearchCriteriaForPostQualReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAvailableSearchCriteriaForPostQualReport(_response);
        });
    }

    protected processGetAvailableSearchCriteriaForPostQualReport(response: Response): Promise<GetAvailableSearchCriteriaForPostQualReportResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAvailableSearchCriteriaForPostQualReportResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAvailableSearchCriteriaForPostQualReportResponse>(null as any);
    }

    validateUserSelectionsforPostQualReport(request: ValidateUserSelectionsforPostQualReportRequest): Promise<ValidateUserSelectionsforPostQualReportResponse> {
        let url_ = this.baseUrl + "/reporting/ValidateUserSelectionsforPostQualReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processValidateUserSelectionsforPostQualReport(_response);
        });
    }

    protected processValidateUserSelectionsforPostQualReport(response: Response): Promise<ValidateUserSelectionsforPostQualReportResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidateUserSelectionsforPostQualReportResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidateUserSelectionsforPostQualReportResponse>(null as any);
    }

    exportPostQualReport(request: ExportPostQualReportRequest): Promise<string> {
        let url_ = this.baseUrl + "/reporting/exportPostQualReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportPostQualReport(_response);
        });
    }

    protected processExportPostQualReport(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getNonQualifiedMessageReport(request: GetNonQualifiedMessageReportRequest): Promise<GetNonQualifiedMessageReportResponse> {
        let url_ = this.baseUrl + "/reporting/getNonQualifiedMessagesReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNonQualifiedMessageReport(_response);
        });
    }

    protected processGetNonQualifiedMessageReport(response: Response): Promise<GetNonQualifiedMessageReportResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNonQualifiedMessageReportResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetNonQualifiedMessageReportResponse>(null as any);
    }

    getNonQualifiedMessageChartData(request: GetNonQualifiedMessageChartDataRequest): Promise<GetNonQualifiedMessageChartDataResponse> {
        let url_ = this.baseUrl + "/reporting/getNonQualifiedMessagesChartData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNonQualifiedMessageChartData(_response);
        });
    }

    protected processGetNonQualifiedMessageChartData(response: Response): Promise<GetNonQualifiedMessageChartDataResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNonQualifiedMessageChartDataResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetNonQualifiedMessageChartDataResponse>(null as any);
    }

    getOlmStartEndMessageCountChartData(request: GetOlmStartEndMessageCountChartDataRequest): Promise<GetOlmStartEndMessageCountChartDataResponse> {
        let url_ = this.baseUrl + "/reporting/getOlmStartEndMessagesCountChartData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOlmStartEndMessageCountChartData(_response);
        });
    }

    protected processGetOlmStartEndMessageCountChartData(response: Response): Promise<GetOlmStartEndMessageCountChartDataResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOlmStartEndMessageCountChartDataResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetOlmStartEndMessageCountChartDataResponse>(null as any);
    }

    getQualifiedAppliedMessageChartData(request: GetQualifiedAppliedMessageChartDataRequest): Promise<GetQualifiedAppliedMessageChartDataResponse> {
        let url_ = this.baseUrl + "/reporting/getQualifiedAppliedMessagesChartData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQualifiedAppliedMessageChartData(_response);
        });
    }

    protected processGetQualifiedAppliedMessageChartData(response: Response): Promise<GetQualifiedAppliedMessageChartDataResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetQualifiedAppliedMessageChartDataResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetQualifiedAppliedMessageChartDataResponse>(null as any);
    }

    getSelectivityChangesReport(request: GetSelectivityChangesReportRequest): Promise<GetSelectivityChangesReportResponse> {
        let url_ = this.baseUrl + "/reporting/getMessagesWithSelectivityChangesReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSelectivityChangesReport(_response);
        });
    }

    protected processGetSelectivityChangesReport(response: Response): Promise<GetSelectivityChangesReportResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSelectivityChangesReportResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetSelectivityChangesReportResponse>(null as any);
    }

    getMessagesWithHardcopyFlagReport(request: GetMessagesWithHardcopyFlagReportRequest): Promise<GetMessagesWithHardcopyFlagReportResponse> {
        let url_ = this.baseUrl + "/reporting/getMessagesWithHardcopyFlagReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMessagesWithHardcopyFlagReport(_response);
        });
    }

    protected processGetMessagesWithHardcopyFlagReport(response: Response): Promise<GetMessagesWithHardcopyFlagReportResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMessagesWithHardcopyFlagReportResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetMessagesWithHardcopyFlagReportResponse>(null as any);
    }
}

export class SelectivityClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getSelectivitySources(request: GetSelectivitySourcesRequest): Promise<GetSelectivitySourcesResponse> {
        let url_ = this.baseUrl + "/selectivity/getSelectivitySources";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSelectivitySources(_response);
        });
    }

    protected processGetSelectivitySources(response: Response): Promise<GetSelectivitySourcesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSelectivitySourcesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetSelectivitySourcesResponse>(null as any);
    }

    getAvailableSelectivityCopyActions(request: GetAvailableSelectivityCopyActionsRequest): Promise<GetAvailableSelectivityCopyActionsResponse> {
        let url_ = this.baseUrl + "/selectivity/getAvailableSelectivityCopyActions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAvailableSelectivityCopyActions(_response);
        });
    }

    protected processGetAvailableSelectivityCopyActions(response: Response): Promise<GetAvailableSelectivityCopyActionsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAvailableSelectivityCopyActionsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAvailableSelectivityCopyActionsResponse>(null as any);
    }

    getAvailableSelectivityProfilesForMergeIntoMessage(request: GetAvailableSelectivityProfilesForMergeIntoMessageRequest): Promise<GetAvailableSelectivityProfilesForMergeIntoMessageResponse> {
        let url_ = this.baseUrl + "/selectivity/getAvailableSelectivityProfilesForMergeIntoMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAvailableSelectivityProfilesForMergeIntoMessage(_response);
        });
    }

    protected processGetAvailableSelectivityProfilesForMergeIntoMessage(response: Response): Promise<GetAvailableSelectivityProfilesForMergeIntoMessageResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAvailableSelectivityProfilesForMergeIntoMessageResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAvailableSelectivityProfilesForMergeIntoMessageResponse>(null as any);
    }

    copySelectivityIntoMessage(request: CopySelectivityIntoMessageRequest): Promise<CopySelectivityIntoMessageResponse> {
        let url_ = this.baseUrl + "/selectivity/copySelectivityIntoMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCopySelectivityIntoMessage(_response);
        });
    }

    protected processCopySelectivityIntoMessage(response: Response): Promise<CopySelectivityIntoMessageResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CopySelectivityIntoMessageResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CopySelectivityIntoMessageResponse>(null as any);
    }

    saveSelectivityProfileAsATemplate(request: SaveSelectivityProfileAsATemplateRequest): Promise<SaveSelectivityProfileAsATemplateResponse> {
        let url_ = this.baseUrl + "/selectivity/saveSelectivityProfileAsATemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveSelectivityProfileAsATemplate(_response);
        });
    }

    protected processSaveSelectivityProfileAsATemplate(response: Response): Promise<SaveSelectivityProfileAsATemplateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveSelectivityProfileAsATemplateResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveSelectivityProfileAsATemplateResponse>(null as any);
    }

    getSelectivityFieldsByDocType(request: GetSelectivityFieldsByDocTypeRequest): Promise<GetSelectivityFieldsByDocTypeResponse> {
        let url_ = this.baseUrl + "/selectivity/getSelectivityFieldsByDocType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSelectivityFieldsByDocType(_response);
        });
    }

    protected processGetSelectivityFieldsByDocType(response: Response): Promise<GetSelectivityFieldsByDocTypeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSelectivityFieldsByDocTypeResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetSelectivityFieldsByDocTypeResponse>(null as any);
    }

    getSelectivityOperandsForField(request: GetSelectivityOperandsRequest): Promise<GetSelectivityOperandsResponse> {
        let url_ = this.baseUrl + "/selectivity/getSelectivityOperands";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSelectivityOperandsForField(_response);
        });
    }

    protected processGetSelectivityOperandsForField(response: Response): Promise<GetSelectivityOperandsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSelectivityOperandsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetSelectivityOperandsResponse>(null as any);
    }

    assignCombinedCriteriaIds(request: AssignCombinedCriteriaIdsRequest): Promise<AssignCombinedCriteriaIdsResponse> {
        let url_ = this.baseUrl + "/selectivity/assignCombinedCriteriaIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAssignCombinedCriteriaIds(_response);
        });
    }

    protected processAssignCombinedCriteriaIds(response: Response): Promise<AssignCombinedCriteriaIdsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignCombinedCriteriaIdsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignCombinedCriteriaIdsResponse>(null as any);
    }

    getSelectivityTemplates(request: GetSelectivityTemplatesRequest): Promise<GetSelectivityTemplatesResponse> {
        let url_ = this.baseUrl + "/selectivity/selectivityTemplates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSelectivityTemplates(_response);
        });
    }

    protected processGetSelectivityTemplates(response: Response): Promise<GetSelectivityTemplatesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSelectivityTemplatesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetSelectivityTemplatesResponse>(null as any);
    }

    getSelectivityTemplateDetails(request: GetSelectivityTemplateDetailsRequest): Promise<GetSelectivityTemplateDetailsResponse> {
        let url_ = this.baseUrl + "/selectivity/selectivityTemplateDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSelectivityTemplateDetails(_response);
        });
    }

    protected processGetSelectivityTemplateDetails(response: Response): Promise<GetSelectivityTemplateDetailsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSelectivityTemplateDetailsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetSelectivityTemplateDetailsResponse>(null as any);
    }

    deleteSelectivityTemplates(request: DeleteSelectivityTemplateRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/selectivity/deleteSelectivityTemplates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteSelectivityTemplates(_response);
        });
    }

    protected processDeleteSelectivityTemplates(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class SpellCheckClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    spellCheck(text: string | null | undefined, lang: string | undefined, method: string | undefined): Promise<{ [key: string]: { [key: string]: string[]; }; }> {
        let url_ = this.baseUrl + "/spellCheck";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (text !== null && text !== undefined)
            content_.append("Text", text.toString());
        if (lang === null || lang === undefined)
            throw new Error("The parameter 'lang' cannot be null.");
        else
            content_.append("Lang", lang.toString());
        if (method === null || method === undefined)
            throw new Error("The parameter 'method' cannot be null.");
        else
            content_.append("Method", method.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSpellCheck(_response);
        });
    }

    protected processSpellCheck(response: Response): Promise<{ [key: string]: { [key: string]: string[]; }; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : {};
                }
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: { [key: string]: string[]; }; }>(null as any);
    }
}

export class UserClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getTargetDatabaseInstances(): Promise<GetTargetDatabaseInstancesResponse> {
        let url_ = this.baseUrl + "/user/getTargetDatabaseInstances";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTargetDatabaseInstances(_response);
        });
    }

    protected processGetTargetDatabaseInstances(response: Response): Promise<GetTargetDatabaseInstancesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTargetDatabaseInstancesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetTargetDatabaseInstancesResponse>(null as any);
    }

    saveUserPreferences(request: SaveUserPreferencesRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/user/saveUserPreferences";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveUserPreferences(_response);
        });
    }

    protected processSaveUserPreferences(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    deleteUserPreferences(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/user/deleteUserPreferences";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteUserPreferences(_response);
        });
    }

    protected processDeleteUserPreferences(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    saveLoginRedirect(request: SaveLoginRedirectRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/user/saveLoginRedirect";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveLoginRedirect(_response);
        });
    }

    protected processSaveLoginRedirect(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class AiTransformResponse implements IAiTransformResponse {
    content?: string | undefined;

    constructor(data?: IAiTransformResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): AiTransformResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AiTransformResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        return data;
    }
}

export interface IAiTransformResponse {
    content?: string | undefined;
}

export class AiTransformRequest implements IAiTransformRequest {
    text?: string | undefined;
    prompt?: string | undefined;
    provider?: string | undefined;

    constructor(data?: IAiTransformRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.prompt = _data["prompt"];
            this.provider = _data["provider"];
        }
    }

    static fromJS(data: any): AiTransformRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AiTransformRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["prompt"] = this.prompt;
        data["provider"] = this.provider;
        return data;
    }
}

export interface IAiTransformRequest {
    text?: string | undefined;
    prompt?: string | undefined;
    provider?: string | undefined;
}

export class WhoAmIResponse implements IWhoAmIResponse {
    isAuthenticated!: boolean;
    isPassResetRequired?: boolean | undefined;
    username?: string | undefined;
    availableTargets!: SafeDatabaseInstance[];
    userType!: DirectNetUserType;
    firstName!: string;
    lastName!: string;
    emailAddress!: string;
    permissions!: DatabaseTargetPermission[];
    dnetUserNamesByAzureEmail!: string[];
    fullscreenErrorMsg?: string | undefined;
    preferencesState!: string;
    isLoginRedirect!: boolean;

    constructor(data?: IWhoAmIResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.availableTargets = [];
            this.permissions = [];
            this.dnetUserNamesByAzureEmail = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAuthenticated = _data["isAuthenticated"];
            this.isPassResetRequired = _data["isPassResetRequired"];
            this.username = _data["username"];
            if (Array.isArray(_data["availableTargets"])) {
                this.availableTargets = [] as any;
                for (let item of _data["availableTargets"])
                    this.availableTargets!.push(SafeDatabaseInstance.fromJS(item));
            }
            this.userType = _data["userType"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(DatabaseTargetPermission.fromJS(item));
            }
            if (Array.isArray(_data["dnetUserNamesByAzureEmail"])) {
                this.dnetUserNamesByAzureEmail = [] as any;
                for (let item of _data["dnetUserNamesByAzureEmail"])
                    this.dnetUserNamesByAzureEmail!.push(item);
            }
            this.fullscreenErrorMsg = _data["fullscreenErrorMsg"];
            this.preferencesState = _data["preferencesState"];
            this.isLoginRedirect = _data["isLoginRedirect"];
        }
    }

    static fromJS(data: any): WhoAmIResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WhoAmIResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAuthenticated"] = this.isAuthenticated;
        data["isPassResetRequired"] = this.isPassResetRequired;
        data["username"] = this.username;
        if (Array.isArray(this.availableTargets)) {
            data["availableTargets"] = [];
            for (let item of this.availableTargets)
                data["availableTargets"].push(item.toJSON());
        }
        data["userType"] = this.userType;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.dnetUserNamesByAzureEmail)) {
            data["dnetUserNamesByAzureEmail"] = [];
            for (let item of this.dnetUserNamesByAzureEmail)
                data["dnetUserNamesByAzureEmail"].push(item);
        }
        data["fullscreenErrorMsg"] = this.fullscreenErrorMsg;
        data["preferencesState"] = this.preferencesState;
        data["isLoginRedirect"] = this.isLoginRedirect;
        return data;
    }
}

export interface IWhoAmIResponse {
    isAuthenticated: boolean;
    isPassResetRequired?: boolean | undefined;
    username?: string | undefined;
    availableTargets: SafeDatabaseInstance[];
    userType: DirectNetUserType;
    firstName: string;
    lastName: string;
    emailAddress: string;
    permissions: DatabaseTargetPermission[];
    dnetUserNamesByAzureEmail: string[];
    fullscreenErrorMsg?: string | undefined;
    preferencesState: string;
    isLoginRedirect: boolean;
}

export class SafeDatabaseInstance implements ISafeDatabaseInstance {
    displayName!: string;
    isActive!: boolean;
    target!: DatabaseTarget;

    constructor(data?: ISafeDatabaseInstance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.isActive = _data["isActive"];
            this.target = _data["target"];
        }
    }

    static fromJS(data: any): SafeDatabaseInstance {
        data = typeof data === 'object' ? data : {};
        let result = new SafeDatabaseInstance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["isActive"] = this.isActive;
        data["target"] = this.target;
        return data;
    }
}

export interface ISafeDatabaseInstance {
    displayName: string;
    isActive: boolean;
    target: DatabaseTarget;
}

export enum DatabaseTarget {
    Unknown = 0,
    Nebraska = 1,
    Staging = 2,
    PreStage = 3,
    Report = -4,
    SysPrinInstance = -3,
    DirectNet = -2,
    Security = -1,
}

export enum DirectNetUserType {
    Internal = 0,
    External = 1,
}

export class DatabaseTargetPermission implements IDatabaseTargetPermission {
    databaseTarget!: DatabaseTarget;
    behaviors?: string[] | undefined;

    constructor(data?: IDatabaseTargetPermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.databaseTarget = _data["databaseTarget"];
            if (Array.isArray(_data["behaviors"])) {
                this.behaviors = [] as any;
                for (let item of _data["behaviors"])
                    this.behaviors!.push(item);
            }
        }
    }

    static fromJS(data: any): DatabaseTargetPermission {
        data = typeof data === 'object' ? data : {};
        let result = new DatabaseTargetPermission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["databaseTarget"] = this.databaseTarget;
        if (Array.isArray(this.behaviors)) {
            data["behaviors"] = [];
            for (let item of this.behaviors)
                data["behaviors"].push(item);
        }
        return data;
    }
}

export interface IDatabaseTargetPermission {
    databaseTarget: DatabaseTarget;
    behaviors?: string[] | undefined;
}

export class LoginResponse implements ILoginResponse {
    username!: string;
    isPassResetRequired!: boolean;
    isPasswordChangeRecommended!: boolean;
    passwordChangeMessage!: string;
    usertype!: DirectNetUserType;
    isLoginRedirect!: boolean;
    firstName!: string;
    lastName!: string;
    emailAddress!: string;
    permissions!: DatabaseTargetPermission[];
    availableTargets!: SafeDatabaseInstance[];
    userPermittedSysPrinsForExternalUser?: SysPrin[] | undefined;
    preferencesState!: string;

    constructor(data?: ILoginResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.permissions = [];
            this.availableTargets = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.isPassResetRequired = _data["isPassResetRequired"];
            this.isPasswordChangeRecommended = _data["isPasswordChangeRecommended"];
            this.passwordChangeMessage = _data["passwordChangeMessage"];
            this.usertype = _data["usertype"];
            this.isLoginRedirect = _data["isLoginRedirect"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(DatabaseTargetPermission.fromJS(item));
            }
            if (Array.isArray(_data["availableTargets"])) {
                this.availableTargets = [] as any;
                for (let item of _data["availableTargets"])
                    this.availableTargets!.push(SafeDatabaseInstance.fromJS(item));
            }
            if (Array.isArray(_data["userPermittedSysPrinsForExternalUser"])) {
                this.userPermittedSysPrinsForExternalUser = [] as any;
                for (let item of _data["userPermittedSysPrinsForExternalUser"])
                    this.userPermittedSysPrinsForExternalUser!.push(SysPrin.fromJS(item));
            }
            this.preferencesState = _data["preferencesState"];
        }
    }

    static fromJS(data: any): LoginResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LoginResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["isPassResetRequired"] = this.isPassResetRequired;
        data["isPasswordChangeRecommended"] = this.isPasswordChangeRecommended;
        data["passwordChangeMessage"] = this.passwordChangeMessage;
        data["usertype"] = this.usertype;
        data["isLoginRedirect"] = this.isLoginRedirect;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.availableTargets)) {
            data["availableTargets"] = [];
            for (let item of this.availableTargets)
                data["availableTargets"].push(item.toJSON());
        }
        if (Array.isArray(this.userPermittedSysPrinsForExternalUser)) {
            data["userPermittedSysPrinsForExternalUser"] = [];
            for (let item of this.userPermittedSysPrinsForExternalUser)
                data["userPermittedSysPrinsForExternalUser"].push(item.toJSON());
        }
        data["preferencesState"] = this.preferencesState;
        return data;
    }
}

export interface ILoginResponse {
    username: string;
    isPassResetRequired: boolean;
    isPasswordChangeRecommended: boolean;
    passwordChangeMessage: string;
    usertype: DirectNetUserType;
    isLoginRedirect: boolean;
    firstName: string;
    lastName: string;
    emailAddress: string;
    permissions: DatabaseTargetPermission[];
    availableTargets: SafeDatabaseInstance[];
    userPermittedSysPrinsForExternalUser?: SysPrin[] | undefined;
    preferencesState: string;
}

export class SysPrin implements ISysPrin {
    system?: string | undefined;
    principle?: string | undefined;
    isCcsCustomer!: boolean;
    isSystemLevelCustomer!: boolean;

    constructor(data?: ISysPrin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.system = _data["system"];
            this.principle = _data["principle"];
            this.isCcsCustomer = _data["isCcsCustomer"];
            this.isSystemLevelCustomer = _data["isSystemLevelCustomer"];
        }
    }

    static fromJS(data: any): SysPrin {
        data = typeof data === 'object' ? data : {};
        let result = new SysPrin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["system"] = this.system;
        data["principle"] = this.principle;
        data["isCcsCustomer"] = this.isCcsCustomer;
        data["isSystemLevelCustomer"] = this.isSystemLevelCustomer;
        return data;
    }
}

export interface ISysPrin {
    system?: string | undefined;
    principle?: string | undefined;
    isCcsCustomer: boolean;
    isSystemLevelCustomer: boolean;
}

export class LoginRequest implements ILoginRequest {
    username!: string;
    password!: string;

    constructor(data?: ILoginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        return data;
    }
}

export interface ILoginRequest {
    username: string;
    password: string;
}

export class ChangePasswordRequest implements IChangePasswordRequest {
    currentPassword!: string;
    newPassword!: string;
    confirmPassword!: string;
    isUserRequested!: boolean;

    constructor(data?: IChangePasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
            this.confirmPassword = _data["confirmPassword"];
            this.isUserRequested = _data["isUserRequested"];
        }
    }

    static fromJS(data: any): ChangePasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        data["confirmPassword"] = this.confirmPassword;
        data["isUserRequested"] = this.isUserRequested;
        return data;
    }
}

export interface IChangePasswordRequest {
    currentPassword: string;
    newPassword: string;
    confirmPassword: string;
    isUserRequested: boolean;
}

export class ForgotPasswordRequest implements IForgotPasswordRequest {
    usernameOrEmail!: string;

    constructor(data?: IForgotPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.usernameOrEmail = _data["usernameOrEmail"];
        }
    }

    static fromJS(data: any): ForgotPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["usernameOrEmail"] = this.usernameOrEmail;
        return data;
    }
}

export interface IForgotPasswordRequest {
    usernameOrEmail: string;
}

export class GetCustomersResponse implements IGetCustomersResponse {
    customers!: CustomerDto[];

    constructor(data?: IGetCustomersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.customers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers!.push(CustomerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCustomersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCustomersResponse {
    customers: CustomerDto[];
}

export class CustomerDto implements ICustomerDto {
    sysPrin!: SysPrinDto;
    name!: string;

    constructor(data?: ICustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sysPrin = new SysPrinDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sysPrin = _data["sysPrin"] ? SysPrinDto.fromJS(_data["sysPrin"]) : new SysPrinDto();
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sysPrin"] = this.sysPrin ? this.sysPrin.toJSON() : <any>undefined;
        data["name"] = this.name;
        return data;
    }
}

export interface ICustomerDto {
    sysPrin: SysPrinDto;
    name: string;
}

export class SysPrinDto implements ISysPrinDto {
    system!: string;
    principle!: string;
    sysPrin!: string;
    isCcsCustomer?: boolean | undefined;
    isSystemLevelCustomer?: boolean | undefined;

    constructor(data?: ISysPrinDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.system = _data["system"];
            this.principle = _data["principle"];
            this.sysPrin = _data["sysPrin"];
            this.isCcsCustomer = _data["isCcsCustomer"];
            this.isSystemLevelCustomer = _data["isSystemLevelCustomer"];
        }
    }

    static fromJS(data: any): SysPrinDto {
        data = typeof data === 'object' ? data : {};
        let result = new SysPrinDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["system"] = this.system;
        data["principle"] = this.principle;
        data["sysPrin"] = this.sysPrin;
        data["isCcsCustomer"] = this.isCcsCustomer;
        data["isSystemLevelCustomer"] = this.isSystemLevelCustomer;
        return data;
    }
}

export interface ISysPrinDto {
    system: string;
    principle: string;
    sysPrin: string;
    isCcsCustomer?: boolean | undefined;
    isSystemLevelCustomer?: boolean | undefined;
}

export class GetAvailableSysPrinsResponse implements IGetAvailableSysPrinsResponse {
    sysprins!: SysPrinDto[];

    constructor(data?: IGetAvailableSysPrinsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sysprins = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sysprins"])) {
                this.sysprins = [] as any;
                for (let item of _data["sysprins"])
                    this.sysprins!.push(SysPrinDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAvailableSysPrinsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvailableSysPrinsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sysprins)) {
            data["sysprins"] = [];
            for (let item of this.sysprins)
                data["sysprins"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAvailableSysPrinsResponse {
    sysprins: SysPrinDto[];
}

export class GetAvailableSysPrinsRequest implements IGetAvailableSysPrinsRequest {
    docTypePrimaryKey!: number;

    constructor(data?: IGetAvailableSysPrinsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.docTypePrimaryKey = _data["docTypePrimaryKey"];
        }
    }

    static fromJS(data: any): GetAvailableSysPrinsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvailableSysPrinsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docTypePrimaryKey"] = this.docTypePrimaryKey;
        return data;
    }
}

export interface IGetAvailableSysPrinsRequest {
    docTypePrimaryKey: number;
}

export class GetVantageQueryForCustomerResponse implements IGetVantageQueryForCustomerResponse {
    vantageQueries!: CustomerVantageQueryDto[];

    constructor(data?: IGetVantageQueryForCustomerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.vantageQueries = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["vantageQueries"])) {
                this.vantageQueries = [] as any;
                for (let item of _data["vantageQueries"])
                    this.vantageQueries!.push(CustomerVantageQueryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetVantageQueryForCustomerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetVantageQueryForCustomerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.vantageQueries)) {
            data["vantageQueries"] = [];
            for (let item of this.vantageQueries)
                data["vantageQueries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetVantageQueryForCustomerResponse {
    vantageQueries: CustomerVantageQueryDto[];
}

export class CustomerVantageQueryDto implements ICustomerVantageQueryDto {
    sysPrin!: SysPrin;
    selectedVantageQuery!: OlmVantageQuery;
    vantageQueryList!: KeyValuePairOfIntegerAndOlmVantageQuery[];

    constructor(data?: ICustomerVantageQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sysPrin = new SysPrin();
            this.selectedVantageQuery = new OlmVantageQuery();
            this.vantageQueryList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sysPrin = _data["sysPrin"] ? SysPrin.fromJS(_data["sysPrin"]) : new SysPrin();
            this.selectedVantageQuery = _data["selectedVantageQuery"] ? OlmVantageQuery.fromJS(_data["selectedVantageQuery"]) : new OlmVantageQuery();
            if (Array.isArray(_data["vantageQueryList"])) {
                this.vantageQueryList = [] as any;
                for (let item of _data["vantageQueryList"])
                    this.vantageQueryList!.push(KeyValuePairOfIntegerAndOlmVantageQuery.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerVantageQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerVantageQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sysPrin"] = this.sysPrin ? this.sysPrin.toJSON() : <any>undefined;
        data["selectedVantageQuery"] = this.selectedVantageQuery ? this.selectedVantageQuery.toJSON() : <any>undefined;
        if (Array.isArray(this.vantageQueryList)) {
            data["vantageQueryList"] = [];
            for (let item of this.vantageQueryList)
                data["vantageQueryList"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomerVantageQueryDto {
    sysPrin: SysPrin;
    selectedVantageQuery: OlmVantageQuery;
    vantageQueryList: KeyValuePairOfIntegerAndOlmVantageQuery[];
}

export class KeyedItem implements IKeyedItem {
    primaryKey?: number | undefined;
    primaryKeyText?: string | undefined;

    constructor(data?: IKeyedItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primaryKey = _data["primaryKey"];
            this.primaryKeyText = _data["primaryKeyText"];
        }
    }

    static fromJS(data: any): KeyedItem {
        data = typeof data === 'object' ? data : {};
        let result = new KeyedItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primaryKey"] = this.primaryKey;
        data["primaryKeyText"] = this.primaryKeyText;
        return data;
    }
}

export interface IKeyedItem {
    primaryKey?: number | undefined;
    primaryKeyText?: string | undefined;
}

export class OlmVantageQuery extends KeyedItem implements IOlmVantageQuery {
    id?: string | undefined;
    name?: string | undefined;
    batchRunDate?: Date | undefined;
    sysPrin?: SysPrin | undefined;
    vantageCorpEntity?: string | undefined;
    isCorporate!: boolean;

    constructor(data?: IOlmVantageQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.batchRunDate = _data["batchRunDate"] ? new Date(_data["batchRunDate"].toString()) : <any>undefined;
            this.sysPrin = _data["sysPrin"] ? SysPrin.fromJS(_data["sysPrin"]) : <any>undefined;
            this.vantageCorpEntity = _data["vantageCorpEntity"];
            this.isCorporate = _data["isCorporate"];
        }
    }

    static override fromJS(data: any): OlmVantageQuery {
        data = typeof data === 'object' ? data : {};
        let result = new OlmVantageQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["batchRunDate"] = this.batchRunDate ? this.batchRunDate.toISOString() : <any>undefined;
        data["sysPrin"] = this.sysPrin ? this.sysPrin.toJSON() : <any>undefined;
        data["vantageCorpEntity"] = this.vantageCorpEntity;
        data["isCorporate"] = this.isCorporate;
        super.toJSON(data);
        return data;
    }
}

export interface IOlmVantageQuery extends IKeyedItem {
    id?: string | undefined;
    name?: string | undefined;
    batchRunDate?: Date | undefined;
    sysPrin?: SysPrin | undefined;
    vantageCorpEntity?: string | undefined;
    isCorporate: boolean;
}

export class KeyValuePairOfIntegerAndOlmVantageQuery implements IKeyValuePairOfIntegerAndOlmVantageQuery {
    key!: number;
    value?: OlmVantageQuery | undefined;

    constructor(data?: IKeyValuePairOfIntegerAndOlmVantageQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"] ? OlmVantageQuery.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): KeyValuePairOfIntegerAndOlmVantageQuery {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePairOfIntegerAndOlmVantageQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IKeyValuePairOfIntegerAndOlmVantageQuery {
    key: number;
    value?: OlmVantageQuery | undefined;
}

export class GetVantageQueryForCustomerRequest implements IGetVantageQueryForCustomerRequest {
    selectedSysprins!: SysPrinDto[];
    messageId!: number;
    vantageCorpEntity!: boolean;

    constructor(data?: IGetVantageQueryForCustomerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.selectedSysprins = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["selectedSysprins"])) {
                this.selectedSysprins = [] as any;
                for (let item of _data["selectedSysprins"])
                    this.selectedSysprins!.push(SysPrinDto.fromJS(item));
            }
            this.messageId = _data["messageId"];
            this.vantageCorpEntity = _data["vantageCorpEntity"];
        }
    }

    static fromJS(data: any): GetVantageQueryForCustomerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetVantageQueryForCustomerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.selectedSysprins)) {
            data["selectedSysprins"] = [];
            for (let item of this.selectedSysprins)
                data["selectedSysprins"].push(item.toJSON());
        }
        data["messageId"] = this.messageId;
        data["vantageCorpEntity"] = this.vantageCorpEntity;
        return data;
    }
}

export interface IGetVantageQueryForCustomerRequest {
    selectedSysprins: SysPrinDto[];
    messageId: number;
    vantageCorpEntity: boolean;
}

export class DiagnosticResponse implements IDiagnosticResponse {
    apiBuild!: string;
    reactBuild!: string;
    caRegion!: string;
    fontInfo!: string;
    securityInstance!: string;
    instances!: string[];

    constructor(data?: IDiagnosticResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.instances = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiBuild = _data["apiBuild"];
            this.reactBuild = _data["reactBuild"];
            this.caRegion = _data["caRegion"];
            this.fontInfo = _data["fontInfo"];
            this.securityInstance = _data["securityInstance"];
            if (Array.isArray(_data["instances"])) {
                this.instances = [] as any;
                for (let item of _data["instances"])
                    this.instances!.push(item);
            }
        }
    }

    static fromJS(data: any): DiagnosticResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosticResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiBuild"] = this.apiBuild;
        data["reactBuild"] = this.reactBuild;
        data["caRegion"] = this.caRegion;
        data["fontInfo"] = this.fontInfo;
        data["securityInstance"] = this.securityInstance;
        if (Array.isArray(this.instances)) {
            data["instances"] = [];
            for (let item of this.instances)
                data["instances"].push(item);
        }
        return data;
    }
}

export interface IDiagnosticResponse {
    apiBuild: string;
    reactBuild: string;
    caRegion: string;
    fontInfo: string;
    securityInstance: string;
    instances: string[];
}

export class GetDocTypesResponse implements IGetDocTypesResponse {
    docTypes!: DocTypeDto[];

    constructor(data?: IGetDocTypesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.docTypes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["docTypes"])) {
                this.docTypes = [] as any;
                for (let item of _data["docTypes"])
                    this.docTypes!.push(DocTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDocTypesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocTypesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.docTypes)) {
            data["docTypes"] = [];
            for (let item of this.docTypes)
                data["docTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDocTypesResponse {
    docTypes: DocTypeDto[];
}

export class DocTypeDto implements IDocTypeDto {
    id!: string;
    name!: string;
    primaryKey?: number | undefined;
    colors!: GlobalColor[];
    allowMassUpdates!: boolean;
    pdfPreviewEngineLocation!: OlmPdfPreviewEngineLocation;
    fonts!: GlobalFont[];
    sysPrins!: SysPrinDto[];

    constructor(data?: IDocTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.colors = [];
            this.fonts = [];
            this.sysPrins = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.primaryKey = _data["primaryKey"];
            if (Array.isArray(_data["colors"])) {
                this.colors = [] as any;
                for (let item of _data["colors"])
                    this.colors!.push(GlobalColor.fromJS(item));
            }
            this.allowMassUpdates = _data["allowMassUpdates"];
            this.pdfPreviewEngineLocation = _data["pdfPreviewEngineLocation"];
            if (Array.isArray(_data["fonts"])) {
                this.fonts = [] as any;
                for (let item of _data["fonts"])
                    this.fonts!.push(GlobalFont.fromJS(item));
            }
            if (Array.isArray(_data["sysPrins"])) {
                this.sysPrins = [] as any;
                for (let item of _data["sysPrins"])
                    this.sysPrins!.push(SysPrinDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["primaryKey"] = this.primaryKey;
        if (Array.isArray(this.colors)) {
            data["colors"] = [];
            for (let item of this.colors)
                data["colors"].push(item.toJSON());
        }
        data["allowMassUpdates"] = this.allowMassUpdates;
        data["pdfPreviewEngineLocation"] = this.pdfPreviewEngineLocation;
        if (Array.isArray(this.fonts)) {
            data["fonts"] = [];
            for (let item of this.fonts)
                data["fonts"].push(item.toJSON());
        }
        if (Array.isArray(this.sysPrins)) {
            data["sysPrins"] = [];
            for (let item of this.sysPrins)
                data["sysPrins"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDocTypeDto {
    id: string;
    name: string;
    primaryKey?: number | undefined;
    colors: GlobalColor[];
    allowMassUpdates: boolean;
    pdfPreviewEngineLocation: OlmPdfPreviewEngineLocation;
    fonts: GlobalFont[];
    sysPrins: SysPrinDto[];
}

export class GlobalColor extends KeyedItem implements IGlobalColor {
    name?: string | undefined;
    color!: Color;
    red!: number;
    green!: number;
    blue!: number;
    rgb?: string | undefined;
    rgB_DatabaseValue?: string | undefined;
    cmyk?: string | undefined;
    cyan!: number;
    magenta!: number;
    yellow!: number;
    black!: number;
    isHighlightColor!: boolean;
    isBlack!: boolean;

    constructor(data?: IGlobalColor) {
        super(data);
        if (!data) {
            this.color = new Color();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.color = _data["color"] ? Color.fromJS(_data["color"]) : new Color();
            this.red = _data["red"];
            this.green = _data["green"];
            this.blue = _data["blue"];
            this.rgb = _data["rgb"];
            this.rgB_DatabaseValue = _data["rgB_DatabaseValue"];
            this.cmyk = _data["cmyk"];
            this.cyan = _data["cyan"];
            this.magenta = _data["magenta"];
            this.yellow = _data["yellow"];
            this.black = _data["black"];
            this.isHighlightColor = _data["isHighlightColor"];
            this.isBlack = _data["isBlack"];
        }
    }

    static override fromJS(data: any): GlobalColor {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalColor();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["color"] = this.color ? this.color.toJSON() : <any>undefined;
        data["red"] = this.red;
        data["green"] = this.green;
        data["blue"] = this.blue;
        data["rgb"] = this.rgb;
        data["rgB_DatabaseValue"] = this.rgB_DatabaseValue;
        data["cmyk"] = this.cmyk;
        data["cyan"] = this.cyan;
        data["magenta"] = this.magenta;
        data["yellow"] = this.yellow;
        data["black"] = this.black;
        data["isHighlightColor"] = this.isHighlightColor;
        data["isBlack"] = this.isBlack;
        super.toJSON(data);
        return data;
    }
}

export interface IGlobalColor extends IKeyedItem {
    name?: string | undefined;
    color: Color;
    red: number;
    green: number;
    blue: number;
    rgb?: string | undefined;
    rgB_DatabaseValue?: string | undefined;
    cmyk?: string | undefined;
    cyan: number;
    magenta: number;
    yellow: number;
    black: number;
    isHighlightColor: boolean;
    isBlack: boolean;
}

export class Color implements IColor {
    r!: number;
    g!: number;
    b!: number;
    a!: number;
    isKnownColor!: boolean;
    isEmpty!: boolean;
    isNamedColor!: boolean;
    isSystemColor!: boolean;
    name!: string;

    constructor(data?: IColor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.r = _data["r"];
            this.g = _data["g"];
            this.b = _data["b"];
            this.a = _data["a"];
            this.isKnownColor = _data["isKnownColor"];
            this.isEmpty = _data["isEmpty"];
            this.isNamedColor = _data["isNamedColor"];
            this.isSystemColor = _data["isSystemColor"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Color {
        data = typeof data === 'object' ? data : {};
        let result = new Color();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["r"] = this.r;
        data["g"] = this.g;
        data["b"] = this.b;
        data["a"] = this.a;
        data["isKnownColor"] = this.isKnownColor;
        data["isEmpty"] = this.isEmpty;
        data["isNamedColor"] = this.isNamedColor;
        data["isSystemColor"] = this.isSystemColor;
        data["name"] = this.name;
        return data;
    }
}

export interface IColor {
    r: number;
    g: number;
    b: number;
    a: number;
    isKnownColor: boolean;
    isEmpty: boolean;
    isNamedColor: boolean;
    isSystemColor: boolean;
    name: string;
}

export enum OlmPdfPreviewEngineLocation {
    Legacy = 0,
    NewJersey = 1,
    Omaha = 2,
    ElectronicAdPage = 3,
}

export class GlobalFont extends KeyedItem implements IGlobalFont {
    name?: string | undefined;
    displayName?: string | undefined;
    fontId?: string | undefined;
    fontSizes?: number[] | undefined;
    fontSizesDisplayText?: string | undefined;
    isMicrosoftFont!: boolean;
    isLookalikeFont!: boolean;
    editorLookalikeFontInfo?: GlobalFontEditorLookalike | undefined;
    isDefaultFont!: boolean;
    defaultFontSize?: number | undefined;

    constructor(data?: IGlobalFont) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.fontId = _data["fontId"];
            if (Array.isArray(_data["fontSizes"])) {
                this.fontSizes = [] as any;
                for (let item of _data["fontSizes"])
                    this.fontSizes!.push(item);
            }
            this.fontSizesDisplayText = _data["fontSizesDisplayText"];
            this.isMicrosoftFont = _data["isMicrosoftFont"];
            this.isLookalikeFont = _data["isLookalikeFont"];
            this.editorLookalikeFontInfo = _data["editorLookalikeFontInfo"] ? GlobalFontEditorLookalike.fromJS(_data["editorLookalikeFontInfo"]) : <any>undefined;
            this.isDefaultFont = _data["isDefaultFont"];
            this.defaultFontSize = _data["defaultFontSize"];
        }
    }

    static override fromJS(data: any): GlobalFont {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalFont();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["fontId"] = this.fontId;
        if (Array.isArray(this.fontSizes)) {
            data["fontSizes"] = [];
            for (let item of this.fontSizes)
                data["fontSizes"].push(item);
        }
        data["fontSizesDisplayText"] = this.fontSizesDisplayText;
        data["isMicrosoftFont"] = this.isMicrosoftFont;
        data["isLookalikeFont"] = this.isLookalikeFont;
        data["editorLookalikeFontInfo"] = this.editorLookalikeFontInfo ? this.editorLookalikeFontInfo.toJSON() : <any>undefined;
        data["isDefaultFont"] = this.isDefaultFont;
        data["defaultFontSize"] = this.defaultFontSize;
        super.toJSON(data);
        return data;
    }
}

export interface IGlobalFont extends IKeyedItem {
    name?: string | undefined;
    displayName?: string | undefined;
    fontId?: string | undefined;
    fontSizes?: number[] | undefined;
    fontSizesDisplayText?: string | undefined;
    isMicrosoftFont: boolean;
    isLookalikeFont: boolean;
    editorLookalikeFontInfo?: GlobalFontEditorLookalike | undefined;
    isDefaultFont: boolean;
    defaultFontSize?: number | undefined;
}

export class GlobalFontEditorLookalike extends KeyedItem implements IGlobalFontEditorLookalike {
    name?: string | undefined;
    normalEotFileName?: string | undefined;
    boldEotFileName?: string | undefined;
    italicEotFileName?: string | undefined;
    boldItalicEotFileName?: string | undefined;

    constructor(data?: IGlobalFontEditorLookalike) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.normalEotFileName = _data["normalEotFileName"];
            this.boldEotFileName = _data["boldEotFileName"];
            this.italicEotFileName = _data["italicEotFileName"];
            this.boldItalicEotFileName = _data["boldItalicEotFileName"];
        }
    }

    static override fromJS(data: any): GlobalFontEditorLookalike {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalFontEditorLookalike();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["normalEotFileName"] = this.normalEotFileName;
        data["boldEotFileName"] = this.boldEotFileName;
        data["italicEotFileName"] = this.italicEotFileName;
        data["boldItalicEotFileName"] = this.boldItalicEotFileName;
        super.toJSON(data);
        return data;
    }
}

export interface IGlobalFontEditorLookalike extends IKeyedItem {
    name?: string | undefined;
    normalEotFileName?: string | undefined;
    boldEotFileName?: string | undefined;
    italicEotFileName?: string | undefined;
    boldItalicEotFileName?: string | undefined;
}

export class GetDocTypesRequest implements IGetDocTypesRequest {
    system!: string;
    principle!: string;

    constructor(data?: IGetDocTypesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.system = _data["system"];
            this.principle = _data["principle"];
        }
    }

    static fromJS(data: any): GetDocTypesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocTypesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["system"] = this.system;
        data["principle"] = this.principle;
        return data;
    }
}

export interface IGetDocTypesRequest {
    system: string;
    principle: string;
}

export class GetCopyDestinationDocTypesForTargetDBResponse implements IGetCopyDestinationDocTypesForTargetDBResponse {
    docTypes!: DocTypeDto[];

    constructor(data?: IGetCopyDestinationDocTypesForTargetDBResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.docTypes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["docTypes"])) {
                this.docTypes = [] as any;
                for (let item of _data["docTypes"])
                    this.docTypes!.push(DocTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCopyDestinationDocTypesForTargetDBResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCopyDestinationDocTypesForTargetDBResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.docTypes)) {
            data["docTypes"] = [];
            for (let item of this.docTypes)
                data["docTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCopyDestinationDocTypesForTargetDBResponse {
    docTypes: DocTypeDto[];
}

export class GetCopyDestinationDocTypesForTargetDBRequest implements IGetCopyDestinationDocTypesForTargetDBRequest {
    databaseInstance!: string;

    constructor(data?: IGetCopyDestinationDocTypesForTargetDBRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.databaseInstance = _data["databaseInstance"];
        }
    }

    static fromJS(data: any): GetCopyDestinationDocTypesForTargetDBRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetCopyDestinationDocTypesForTargetDBRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["databaseInstance"] = this.databaseInstance;
        return data;
    }
}

export interface IGetCopyDestinationDocTypesForTargetDBRequest {
    databaseInstance: string;
}

export class GetGraphicsBySysPrinsResponse implements IGetGraphicsBySysPrinsResponse {
    graphics!: GraphicDto[];

    constructor(data?: IGetGraphicsBySysPrinsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.graphics = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["graphics"])) {
                this.graphics = [] as any;
                for (let item of _data["graphics"])
                    this.graphics!.push(GraphicDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGraphicsBySysPrinsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetGraphicsBySysPrinsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.graphics)) {
            data["graphics"] = [];
            for (let item of this.graphics)
                data["graphics"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGraphicsBySysPrinsResponse {
    graphics: GraphicDto[];
}

export class GraphicDto implements IGraphicDto {
    id!: string;
    isUsedByAnotherMessage!: boolean;
    lastUpdated!: Date;
    location?: OlmLocationGraphicPosition | undefined;
    base64Image?: string | undefined;

    constructor(data?: IGraphicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isUsedByAnotherMessage = _data["isUsedByAnotherMessage"];
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : <any>undefined;
            this.location = _data["location"] ? OlmLocationGraphicPosition.fromJS(_data["location"]) : <any>undefined;
            this.base64Image = _data["base64Image"];
        }
    }

    static fromJS(data: any): GraphicDto {
        data = typeof data === 'object' ? data : {};
        let result = new GraphicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isUsedByAnotherMessage"] = this.isUsedByAnotherMessage;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["base64Image"] = this.base64Image;
        return data;
    }
}

export interface IGraphicDto {
    id: string;
    isUsedByAnotherMessage: boolean;
    lastUpdated: Date;
    location?: OlmLocationGraphicPosition | undefined;
    base64Image?: string | undefined;
}

export class OlmLocationGraphicPosition extends KeyedItem implements IOlmLocationGraphicPosition {
    position!: GraphicPosition;
    wrapText!: boolean;

    constructor(data?: IOlmLocationGraphicPosition) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.position = _data["position"];
            this.wrapText = _data["wrapText"];
        }
    }

    static override fromJS(data: any): OlmLocationGraphicPosition {
        data = typeof data === 'object' ? data : {};
        let result = new OlmLocationGraphicPosition();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["position"] = this.position;
        data["wrapText"] = this.wrapText;
        super.toJSON(data);
        return data;
    }
}

export interface IOlmLocationGraphicPosition extends IKeyedItem {
    position: GraphicPosition;
    wrapText: boolean;
}

export enum GraphicPosition {
    Above = 65,
    Below = 66,
    Left = 76,
    Right = 82,
}

export class GetGraphicsBySysPrinsRequest implements IGetGraphicsBySysPrinsRequest {
    location!: LocationDto;
    sysPrins!: SysPrinDto[];
    docTypeUid!: number;

    constructor(data?: IGetGraphicsBySysPrinsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.location = new LocationDto();
            this.sysPrins = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location = _data["location"] ? LocationDto.fromJS(_data["location"]) : new LocationDto();
            if (Array.isArray(_data["sysPrins"])) {
                this.sysPrins = [] as any;
                for (let item of _data["sysPrins"])
                    this.sysPrins!.push(SysPrinDto.fromJS(item));
            }
            this.docTypeUid = _data["docTypeUid"];
        }
    }

    static fromJS(data: any): GetGraphicsBySysPrinsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetGraphicsBySysPrinsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        if (Array.isArray(this.sysPrins)) {
            data["sysPrins"] = [];
            for (let item of this.sysPrins)
                data["sysPrins"].push(item.toJSON());
        }
        data["docTypeUid"] = this.docTypeUid;
        return data;
    }
}

export interface IGetGraphicsBySysPrinsRequest {
    location: LocationDto;
    sysPrins: SysPrinDto[];
    docTypeUid: number;
}

export class LocationDto implements ILocationDto {
    id?: string | undefined;
    name?: string | undefined;
    primaryKey?: number | undefined;
    graphicPath?: string | undefined;
    locationType?: OlmLocationType | undefined;
    isMultiChannel?: boolean | undefined;
    canUseGraphics?: boolean | undefined;
    canMessagesBePreviewedAlone?: boolean | undefined;
    maxGraphicHeight?: number | undefined;
    maxGraphicWidth?: number | undefined;
    height!: number;
    width!: number;
    allowedGraphicPositions?: OlmLocationGraphicPosition[] | undefined;
    messageRequirementRestriction?: RequirementRestriction | undefined;
    allowsBackgroundShading?: boolean | undefined;
    pageType?: OlmPageType | undefined;
    isOverflowLocationAllowed!: boolean;

    constructor(data?: ILocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.primaryKey = _data["primaryKey"];
            this.graphicPath = _data["graphicPath"];
            this.locationType = _data["locationType"] ? OlmLocationType.fromJS(_data["locationType"]) : <any>undefined;
            this.isMultiChannel = _data["isMultiChannel"];
            this.canUseGraphics = _data["canUseGraphics"];
            this.canMessagesBePreviewedAlone = _data["canMessagesBePreviewedAlone"];
            this.maxGraphicHeight = _data["maxGraphicHeight"];
            this.maxGraphicWidth = _data["maxGraphicWidth"];
            this.height = _data["height"];
            this.width = _data["width"];
            if (Array.isArray(_data["allowedGraphicPositions"])) {
                this.allowedGraphicPositions = [] as any;
                for (let item of _data["allowedGraphicPositions"])
                    this.allowedGraphicPositions!.push(OlmLocationGraphicPosition.fromJS(item));
            }
            this.messageRequirementRestriction = _data["messageRequirementRestriction"];
            this.allowsBackgroundShading = _data["allowsBackgroundShading"];
            this.pageType = _data["pageType"] ? OlmPageType.fromJS(_data["pageType"]) : <any>undefined;
            this.isOverflowLocationAllowed = _data["isOverflowLocationAllowed"];
        }
    }

    static fromJS(data: any): LocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["primaryKey"] = this.primaryKey;
        data["graphicPath"] = this.graphicPath;
        data["locationType"] = this.locationType ? this.locationType.toJSON() : <any>undefined;
        data["isMultiChannel"] = this.isMultiChannel;
        data["canUseGraphics"] = this.canUseGraphics;
        data["canMessagesBePreviewedAlone"] = this.canMessagesBePreviewedAlone;
        data["maxGraphicHeight"] = this.maxGraphicHeight;
        data["maxGraphicWidth"] = this.maxGraphicWidth;
        data["height"] = this.height;
        data["width"] = this.width;
        if (Array.isArray(this.allowedGraphicPositions)) {
            data["allowedGraphicPositions"] = [];
            for (let item of this.allowedGraphicPositions)
                data["allowedGraphicPositions"].push(item.toJSON());
        }
        data["messageRequirementRestriction"] = this.messageRequirementRestriction;
        data["allowsBackgroundShading"] = this.allowsBackgroundShading;
        data["pageType"] = this.pageType ? this.pageType.toJSON() : <any>undefined;
        data["isOverflowLocationAllowed"] = this.isOverflowLocationAllowed;
        return data;
    }
}

export interface ILocationDto {
    id?: string | undefined;
    name?: string | undefined;
    primaryKey?: number | undefined;
    graphicPath?: string | undefined;
    locationType?: OlmLocationType | undefined;
    isMultiChannel?: boolean | undefined;
    canUseGraphics?: boolean | undefined;
    canMessagesBePreviewedAlone?: boolean | undefined;
    maxGraphicHeight?: number | undefined;
    maxGraphicWidth?: number | undefined;
    height: number;
    width: number;
    allowedGraphicPositions?: OlmLocationGraphicPosition[] | undefined;
    messageRequirementRestriction?: RequirementRestriction | undefined;
    allowsBackgroundShading?: boolean | undefined;
    pageType?: OlmPageType | undefined;
    isOverflowLocationAllowed: boolean;
}

export class OlmLocationType extends KeyedItem implements IOlmLocationType {
    allowsMessageLinking!: boolean;
    name?: string | undefined;
    isRestrictedAccess!: boolean;
    isTransactionLocation!: boolean;
    requiresLineSpacingAfterTransactions!: boolean;
    isTransactionDetailLocation!: boolean;
    requiredLocationId?: string | undefined;
    mustUseASpecificLocationId!: boolean;
    isPrintableAdPageLocation!: boolean;
    isAdPageLocation!: boolean;
    isElectronicAdPageLocation!: boolean;
    isInsertLocation!: boolean;
    isInViewHoldLocation!: boolean;
    isCarrierPrintLocation!: boolean;
    isSavingsLocation!: boolean;
    isTransitionLocation!: boolean;
    isDiscountEndingMessageLocation!: boolean;
    isUpsellMessageLocation!: boolean;
    mustBeExcludedFromMultiMessagePdfPreview!: boolean;
    supportsGraphics!: boolean;
    requiresGraphicPositionsToBeAvailable!: boolean;
    isFullPageGraphicLocation!: boolean;
    supportsBackgroundShading!: boolean;
    supportsUnderlinedText!: boolean;
    supportsFontSizes!: boolean;
    supportsLineSpacing!: boolean;
    supportsMessageText!: boolean;
    requiresOverflowLocationsToSupportThisLocationsGraphicPositions!: boolean;
    requiresOverflowLocationsToSupportThisLocationsMessageRestrictions!: boolean;
    requiresOverflowLocationsToBeTheSameSize!: boolean;
    requiresOverflowLocationsToBeTheSameLocationType!: boolean;
    canHaveOverflowLocation!: boolean;
    canBeAnOverflowLocation!: boolean;
    isGraphicRequired!: boolean;

    constructor(data?: IOlmLocationType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.allowsMessageLinking = _data["allowsMessageLinking"];
            this.name = _data["name"];
            this.isRestrictedAccess = _data["isRestrictedAccess"];
            this.isTransactionLocation = _data["isTransactionLocation"];
            this.requiresLineSpacingAfterTransactions = _data["requiresLineSpacingAfterTransactions"];
            this.isTransactionDetailLocation = _data["isTransactionDetailLocation"];
            this.requiredLocationId = _data["requiredLocationId"];
            this.mustUseASpecificLocationId = _data["mustUseASpecificLocationId"];
            this.isPrintableAdPageLocation = _data["isPrintableAdPageLocation"];
            this.isAdPageLocation = _data["isAdPageLocation"];
            this.isElectronicAdPageLocation = _data["isElectronicAdPageLocation"];
            this.isInsertLocation = _data["isInsertLocation"];
            this.isInViewHoldLocation = _data["isInViewHoldLocation"];
            this.isCarrierPrintLocation = _data["isCarrierPrintLocation"];
            this.isSavingsLocation = _data["isSavingsLocation"];
            this.isTransitionLocation = _data["isTransitionLocation"];
            this.isDiscountEndingMessageLocation = _data["isDiscountEndingMessageLocation"];
            this.isUpsellMessageLocation = _data["isUpsellMessageLocation"];
            this.mustBeExcludedFromMultiMessagePdfPreview = _data["mustBeExcludedFromMultiMessagePdfPreview"];
            this.supportsGraphics = _data["supportsGraphics"];
            this.requiresGraphicPositionsToBeAvailable = _data["requiresGraphicPositionsToBeAvailable"];
            this.isFullPageGraphicLocation = _data["isFullPageGraphicLocation"];
            this.supportsBackgroundShading = _data["supportsBackgroundShading"];
            this.supportsUnderlinedText = _data["supportsUnderlinedText"];
            this.supportsFontSizes = _data["supportsFontSizes"];
            this.supportsLineSpacing = _data["supportsLineSpacing"];
            this.supportsMessageText = _data["supportsMessageText"];
            this.requiresOverflowLocationsToSupportThisLocationsGraphicPositions = _data["requiresOverflowLocationsToSupportThisLocationsGraphicPositions"];
            this.requiresOverflowLocationsToSupportThisLocationsMessageRestrictions = _data["requiresOverflowLocationsToSupportThisLocationsMessageRestrictions"];
            this.requiresOverflowLocationsToBeTheSameSize = _data["requiresOverflowLocationsToBeTheSameSize"];
            this.requiresOverflowLocationsToBeTheSameLocationType = _data["requiresOverflowLocationsToBeTheSameLocationType"];
            this.canHaveOverflowLocation = _data["canHaveOverflowLocation"];
            this.canBeAnOverflowLocation = _data["canBeAnOverflowLocation"];
            this.isGraphicRequired = _data["isGraphicRequired"];
        }
    }

    static override fromJS(data: any): OlmLocationType {
        data = typeof data === 'object' ? data : {};
        let result = new OlmLocationType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowsMessageLinking"] = this.allowsMessageLinking;
        data["name"] = this.name;
        data["isRestrictedAccess"] = this.isRestrictedAccess;
        data["isTransactionLocation"] = this.isTransactionLocation;
        data["requiresLineSpacingAfterTransactions"] = this.requiresLineSpacingAfterTransactions;
        data["isTransactionDetailLocation"] = this.isTransactionDetailLocation;
        data["requiredLocationId"] = this.requiredLocationId;
        data["mustUseASpecificLocationId"] = this.mustUseASpecificLocationId;
        data["isPrintableAdPageLocation"] = this.isPrintableAdPageLocation;
        data["isAdPageLocation"] = this.isAdPageLocation;
        data["isElectronicAdPageLocation"] = this.isElectronicAdPageLocation;
        data["isInsertLocation"] = this.isInsertLocation;
        data["isInViewHoldLocation"] = this.isInViewHoldLocation;
        data["isCarrierPrintLocation"] = this.isCarrierPrintLocation;
        data["isSavingsLocation"] = this.isSavingsLocation;
        data["isTransitionLocation"] = this.isTransitionLocation;
        data["isDiscountEndingMessageLocation"] = this.isDiscountEndingMessageLocation;
        data["isUpsellMessageLocation"] = this.isUpsellMessageLocation;
        data["mustBeExcludedFromMultiMessagePdfPreview"] = this.mustBeExcludedFromMultiMessagePdfPreview;
        data["supportsGraphics"] = this.supportsGraphics;
        data["requiresGraphicPositionsToBeAvailable"] = this.requiresGraphicPositionsToBeAvailable;
        data["isFullPageGraphicLocation"] = this.isFullPageGraphicLocation;
        data["supportsBackgroundShading"] = this.supportsBackgroundShading;
        data["supportsUnderlinedText"] = this.supportsUnderlinedText;
        data["supportsFontSizes"] = this.supportsFontSizes;
        data["supportsLineSpacing"] = this.supportsLineSpacing;
        data["supportsMessageText"] = this.supportsMessageText;
        data["requiresOverflowLocationsToSupportThisLocationsGraphicPositions"] = this.requiresOverflowLocationsToSupportThisLocationsGraphicPositions;
        data["requiresOverflowLocationsToSupportThisLocationsMessageRestrictions"] = this.requiresOverflowLocationsToSupportThisLocationsMessageRestrictions;
        data["requiresOverflowLocationsToBeTheSameSize"] = this.requiresOverflowLocationsToBeTheSameSize;
        data["requiresOverflowLocationsToBeTheSameLocationType"] = this.requiresOverflowLocationsToBeTheSameLocationType;
        data["canHaveOverflowLocation"] = this.canHaveOverflowLocation;
        data["canBeAnOverflowLocation"] = this.canBeAnOverflowLocation;
        data["isGraphicRequired"] = this.isGraphicRequired;
        super.toJSON(data);
        return data;
    }
}

export interface IOlmLocationType extends IKeyedItem {
    allowsMessageLinking: boolean;
    name?: string | undefined;
    isRestrictedAccess: boolean;
    isTransactionLocation: boolean;
    requiresLineSpacingAfterTransactions: boolean;
    isTransactionDetailLocation: boolean;
    requiredLocationId?: string | undefined;
    mustUseASpecificLocationId: boolean;
    isPrintableAdPageLocation: boolean;
    isAdPageLocation: boolean;
    isElectronicAdPageLocation: boolean;
    isInsertLocation: boolean;
    isInViewHoldLocation: boolean;
    isCarrierPrintLocation: boolean;
    isSavingsLocation: boolean;
    isTransitionLocation: boolean;
    isDiscountEndingMessageLocation: boolean;
    isUpsellMessageLocation: boolean;
    mustBeExcludedFromMultiMessagePdfPreview: boolean;
    supportsGraphics: boolean;
    requiresGraphicPositionsToBeAvailable: boolean;
    isFullPageGraphicLocation: boolean;
    supportsBackgroundShading: boolean;
    supportsUnderlinedText: boolean;
    supportsFontSizes: boolean;
    supportsLineSpacing: boolean;
    supportsMessageText: boolean;
    requiresOverflowLocationsToSupportThisLocationsGraphicPositions: boolean;
    requiresOverflowLocationsToSupportThisLocationsMessageRestrictions: boolean;
    requiresOverflowLocationsToBeTheSameSize: boolean;
    requiresOverflowLocationsToBeTheSameLocationType: boolean;
    canHaveOverflowLocation: boolean;
    canBeAnOverflowLocation: boolean;
    isGraphicRequired: boolean;
}

export enum RequirementRestriction {
    Both = 0,
    Optional = 1,
    Required = 2,
}

export class OlmPageType extends KeyedItem implements IOlmPageType {
    documentType?: OlmDocumentType | undefined;
    pageTypeId?: string | undefined;
    name?: string | undefined;
    pageNumber!: number;
    pageNumberUserEntry?: string | undefined;
    height!: number;
    heightUserEntry?: string | undefined;
    width!: number;
    widthUserEntry?: string | undefined;
    isRepeatingPage!: boolean;

    constructor(data?: IOlmPageType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentType = _data["documentType"] ? OlmDocumentType.fromJS(_data["documentType"]) : <any>undefined;
            this.pageTypeId = _data["pageTypeId"];
            this.name = _data["name"];
            this.pageNumber = _data["pageNumber"];
            this.pageNumberUserEntry = _data["pageNumberUserEntry"];
            this.height = _data["height"];
            this.heightUserEntry = _data["heightUserEntry"];
            this.width = _data["width"];
            this.widthUserEntry = _data["widthUserEntry"];
            this.isRepeatingPage = _data["isRepeatingPage"];
        }
    }

    static override fromJS(data: any): OlmPageType {
        data = typeof data === 'object' ? data : {};
        let result = new OlmPageType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentType"] = this.documentType ? this.documentType.toJSON() : <any>undefined;
        data["pageTypeId"] = this.pageTypeId;
        data["name"] = this.name;
        data["pageNumber"] = this.pageNumber;
        data["pageNumberUserEntry"] = this.pageNumberUserEntry;
        data["height"] = this.height;
        data["heightUserEntry"] = this.heightUserEntry;
        data["width"] = this.width;
        data["widthUserEntry"] = this.widthUserEntry;
        data["isRepeatingPage"] = this.isRepeatingPage;
        super.toJSON(data);
        return data;
    }
}

export interface IOlmPageType extends IKeyedItem {
    documentType?: OlmDocumentType | undefined;
    pageTypeId?: string | undefined;
    name?: string | undefined;
    pageNumber: number;
    pageNumberUserEntry?: string | undefined;
    height: number;
    heightUserEntry?: string | undefined;
    width: number;
    widthUserEntry?: string | undefined;
    isRepeatingPage: boolean;
}

export class OlmDocumentType extends KeyedItem implements IOlmDocumentType {
    docTypeId?: string | undefined;
    sysPrins?: SysPrin[] | undefined;
    name?: string | undefined;
    njCompositionParmFile?: string | undefined;
    exstreamPubName?: string | undefined;
    colorOption?: string | undefined;
    pdfDirectory?: string | undefined;
    pdfFileName?: string | undefined;
    ecareMessageDisplay!: boolean;
    allowMassUpdates!: boolean;
    colors?: GlobalColor[] | undefined;
    fonts?: GlobalFont[] | undefined;
    pdfPreviewEngineLocation!: OlmPdfPreviewEngineLocation;
    deleteNotify!: boolean;
    deleteEmailAddress?: string | undefined;

    constructor(data?: IOlmDocumentType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.docTypeId = _data["docTypeId"];
            if (Array.isArray(_data["sysPrins"])) {
                this.sysPrins = [] as any;
                for (let item of _data["sysPrins"])
                    this.sysPrins!.push(SysPrin.fromJS(item));
            }
            this.name = _data["name"];
            this.njCompositionParmFile = _data["njCompositionParmFile"];
            this.exstreamPubName = _data["exstreamPubName"];
            this.colorOption = _data["colorOption"];
            this.pdfDirectory = _data["pdfDirectory"];
            this.pdfFileName = _data["pdfFileName"];
            this.ecareMessageDisplay = _data["ecareMessageDisplay"];
            this.allowMassUpdates = _data["allowMassUpdates"];
            if (Array.isArray(_data["colors"])) {
                this.colors = [] as any;
                for (let item of _data["colors"])
                    this.colors!.push(GlobalColor.fromJS(item));
            }
            if (Array.isArray(_data["fonts"])) {
                this.fonts = [] as any;
                for (let item of _data["fonts"])
                    this.fonts!.push(GlobalFont.fromJS(item));
            }
            this.pdfPreviewEngineLocation = _data["pdfPreviewEngineLocation"];
            this.deleteNotify = _data["deleteNotify"];
            this.deleteEmailAddress = _data["deleteEmailAddress"];
        }
    }

    static override fromJS(data: any): OlmDocumentType {
        data = typeof data === 'object' ? data : {};
        let result = new OlmDocumentType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docTypeId"] = this.docTypeId;
        if (Array.isArray(this.sysPrins)) {
            data["sysPrins"] = [];
            for (let item of this.sysPrins)
                data["sysPrins"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["njCompositionParmFile"] = this.njCompositionParmFile;
        data["exstreamPubName"] = this.exstreamPubName;
        data["colorOption"] = this.colorOption;
        data["pdfDirectory"] = this.pdfDirectory;
        data["pdfFileName"] = this.pdfFileName;
        data["ecareMessageDisplay"] = this.ecareMessageDisplay;
        data["allowMassUpdates"] = this.allowMassUpdates;
        if (Array.isArray(this.colors)) {
            data["colors"] = [];
            for (let item of this.colors)
                data["colors"].push(item.toJSON());
        }
        if (Array.isArray(this.fonts)) {
            data["fonts"] = [];
            for (let item of this.fonts)
                data["fonts"].push(item.toJSON());
        }
        data["pdfPreviewEngineLocation"] = this.pdfPreviewEngineLocation;
        data["deleteNotify"] = this.deleteNotify;
        data["deleteEmailAddress"] = this.deleteEmailAddress;
        super.toJSON(data);
        return data;
    }
}

export interface IOlmDocumentType extends IKeyedItem {
    docTypeId?: string | undefined;
    sysPrins?: SysPrin[] | undefined;
    name?: string | undefined;
    njCompositionParmFile?: string | undefined;
    exstreamPubName?: string | undefined;
    colorOption?: string | undefined;
    pdfDirectory?: string | undefined;
    pdfFileName?: string | undefined;
    ecareMessageDisplay: boolean;
    allowMassUpdates: boolean;
    colors?: GlobalColor[] | undefined;
    fonts?: GlobalFont[] | undefined;
    pdfPreviewEngineLocation: OlmPdfPreviewEngineLocation;
    deleteNotify: boolean;
    deleteEmailAddress?: string | undefined;
}

export class GetGraphicByIdResponse implements IGetGraphicByIdResponse {
    graphic!: GraphicDto;

    constructor(data?: IGetGraphicByIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.graphic = new GraphicDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.graphic = _data["graphic"] ? GraphicDto.fromJS(_data["graphic"]) : new GraphicDto();
        }
    }

    static fromJS(data: any): GetGraphicByIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetGraphicByIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["graphic"] = this.graphic ? this.graphic.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGraphicByIdResponse {
    graphic: GraphicDto;
}

export class GetGraphicByIdRequest implements IGetGraphicByIdRequest {
    graphicId!: string;
    sysPrins!: SysPrin[];

    constructor(data?: IGetGraphicByIdRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sysPrins = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.graphicId = _data["graphicId"];
            if (Array.isArray(_data["sysPrins"])) {
                this.sysPrins = [] as any;
                for (let item of _data["sysPrins"])
                    this.sysPrins!.push(SysPrin.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGraphicByIdRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetGraphicByIdRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["graphicId"] = this.graphicId;
        if (Array.isArray(this.sysPrins)) {
            data["sysPrins"] = [];
            for (let item of this.sysPrins)
                data["sysPrins"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGraphicByIdRequest {
    graphicId: string;
    sysPrins: SysPrin[];
}

export class GetLocationsResponse implements IGetLocationsResponse {
    locations!: LocationDto[];

    constructor(data?: IGetLocationsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.locations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(LocationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLocationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLocationsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetLocationsResponse {
    locations: LocationDto[];
}

export class GetLocationsRequest implements IGetLocationsRequest {
    docTypePrimaryKey!: number;
    system!: string;
    principle!: string;

    constructor(data?: IGetLocationsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.docTypePrimaryKey = _data["docTypePrimaryKey"];
            this.system = _data["system"];
            this.principle = _data["principle"];
        }
    }

    static fromJS(data: any): GetLocationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetLocationsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docTypePrimaryKey"] = this.docTypePrimaryKey;
        data["system"] = this.system;
        data["principle"] = this.principle;
        return data;
    }
}

export interface IGetLocationsRequest {
    docTypePrimaryKey: number;
    system: string;
    principle: string;
}

export class GetLocationsWithDetailsResponse implements IGetLocationsWithDetailsResponse {
    locations!: LocationDto[];

    constructor(data?: IGetLocationsWithDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.locations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(LocationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLocationsWithDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLocationsWithDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetLocationsWithDetailsResponse {
    locations: LocationDto[];
}

export class GetLocationsWithDetailsRequest implements IGetLocationsWithDetailsRequest {
    system!: string;
    principle!: string;
    docTypePrimaryKey!: number;
    appendIdWithName!: boolean;

    constructor(data?: IGetLocationsWithDetailsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.system = _data["system"];
            this.principle = _data["principle"];
            this.docTypePrimaryKey = _data["docTypePrimaryKey"];
            this.appendIdWithName = _data["appendIdWithName"];
        }
    }

    static fromJS(data: any): GetLocationsWithDetailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetLocationsWithDetailsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["system"] = this.system;
        data["principle"] = this.principle;
        data["docTypePrimaryKey"] = this.docTypePrimaryKey;
        data["appendIdWithName"] = this.appendIdWithName;
        return data;
    }
}

export interface IGetLocationsWithDetailsRequest {
    system: string;
    principle: string;
    docTypePrimaryKey: number;
    appendIdWithName: boolean;
}

export class GetFirstUnusedRankForLocationAndSysPrinResponse implements IGetFirstUnusedRankForLocationAndSysPrinResponse {
    firstUnusedRank!: number;

    constructor(data?: IGetFirstUnusedRankForLocationAndSysPrinResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstUnusedRank = _data["firstUnusedRank"];
        }
    }

    static fromJS(data: any): GetFirstUnusedRankForLocationAndSysPrinResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFirstUnusedRankForLocationAndSysPrinResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstUnusedRank"] = this.firstUnusedRank;
        return data;
    }
}

export interface IGetFirstUnusedRankForLocationAndSysPrinResponse {
    firstUnusedRank: number;
}

export class GetFirstUnusedRankForLocationAndSysPrinRequest implements IGetFirstUnusedRankForLocationAndSysPrinRequest {
    locationPk?: number | undefined;
    sysPrins!: SysPrinDto[];
    excludedMessagePk?: number | undefined;

    constructor(data?: IGetFirstUnusedRankForLocationAndSysPrinRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sysPrins = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationPk = _data["locationPk"];
            if (Array.isArray(_data["sysPrins"])) {
                this.sysPrins = [] as any;
                for (let item of _data["sysPrins"])
                    this.sysPrins!.push(SysPrinDto.fromJS(item));
            }
            this.excludedMessagePk = _data["excludedMessagePk"];
        }
    }

    static fromJS(data: any): GetFirstUnusedRankForLocationAndSysPrinRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFirstUnusedRankForLocationAndSysPrinRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationPk"] = this.locationPk;
        if (Array.isArray(this.sysPrins)) {
            data["sysPrins"] = [];
            for (let item of this.sysPrins)
                data["sysPrins"].push(item.toJSON());
        }
        data["excludedMessagePk"] = this.excludedMessagePk;
        return data;
    }
}

export interface IGetFirstUnusedRankForLocationAndSysPrinRequest {
    locationPk?: number | undefined;
    sysPrins: SysPrinDto[];
    excludedMessagePk?: number | undefined;
}

export class GetMessagesResponse implements IGetMessagesResponse {
    messages!: MessageDto[];

    constructor(data?: IGetMessagesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(MessageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMessagesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMessagesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMessagesResponse {
    messages: MessageDto[];
}

export class MessageDto implements IMessageDto {
    id!: string;
    rank?: number | undefined;
    title!: string;
    messageType!: string;
    location!: LocationDto;
    beginDate?: Date | undefined;
    beginDateUserEntry?: string | undefined;
    endDate?: Date | undefined;
    endDateUserEntry?: string | undefined;
    primaryKey?: number | undefined;
    forceHardcopy!: boolean;
    isRequired!: boolean;
    isOverflowAllowed!: boolean;
    creator!: string;
    createDate!: Date;
    createDateUserEntry!: string;
    approver!: string;
    approvalDate?: Date | undefined;
    approvalDateUserEntry!: string;
    status!: MessageStatus;
    sysPrinCount?: number | undefined;
    hideInEcare?: boolean | undefined;
    graphicId?: string | undefined;
    lastUpdate!: string;
    deletionDate?: Date | undefined;
    deletionDateUserEntry!: string;
    doctypeId!: string;
    doctypeName!: string;
    customerSysPrin!: string;
    canUserViewThisMessage!: boolean;
    canUserModifyThisMessage!: boolean;
    canUserApproveThisMessage!: boolean;
    canUserDeleteThisMessage!: boolean;
    canUserRestoreThisMessageFromTheTrash!: boolean;
    canUserModifyStatusToPending!: boolean;
    canUserModifyStatusToDraft!: boolean;
    canUserModifyRank!: boolean;

    constructor(data?: IMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.location = new LocationDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rank = _data["rank"];
            this.title = _data["title"];
            this.messageType = _data["messageType"];
            this.location = _data["location"] ? LocationDto.fromJS(_data["location"]) : new LocationDto();
            this.beginDate = _data["beginDate"] ? new Date(_data["beginDate"].toString()) : <any>undefined;
            this.beginDateUserEntry = _data["beginDateUserEntry"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.endDateUserEntry = _data["endDateUserEntry"];
            this.primaryKey = _data["primaryKey"];
            this.forceHardcopy = _data["forceHardcopy"];
            this.isRequired = _data["isRequired"];
            this.isOverflowAllowed = _data["isOverflowAllowed"];
            this.creator = _data["creator"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.createDateUserEntry = _data["createDateUserEntry"];
            this.approver = _data["approver"];
            this.approvalDate = _data["approvalDate"] ? new Date(_data["approvalDate"].toString()) : <any>undefined;
            this.approvalDateUserEntry = _data["approvalDateUserEntry"];
            this.status = _data["status"];
            this.sysPrinCount = _data["sysPrinCount"];
            this.hideInEcare = _data["hideInEcare"];
            this.graphicId = _data["graphicId"];
            this.lastUpdate = _data["lastUpdate"];
            this.deletionDate = _data["deletionDate"] ? new Date(_data["deletionDate"].toString()) : <any>undefined;
            this.deletionDateUserEntry = _data["deletionDateUserEntry"];
            this.doctypeId = _data["doctypeId"];
            this.doctypeName = _data["doctypeName"];
            this.customerSysPrin = _data["customerSysPrin"];
            this.canUserViewThisMessage = _data["canUserViewThisMessage"];
            this.canUserModifyThisMessage = _data["canUserModifyThisMessage"];
            this.canUserApproveThisMessage = _data["canUserApproveThisMessage"];
            this.canUserDeleteThisMessage = _data["canUserDeleteThisMessage"];
            this.canUserRestoreThisMessageFromTheTrash = _data["canUserRestoreThisMessageFromTheTrash"];
            this.canUserModifyStatusToPending = _data["canUserModifyStatusToPending"];
            this.canUserModifyStatusToDraft = _data["canUserModifyStatusToDraft"];
            this.canUserModifyRank = _data["canUserModifyRank"];
        }
    }

    static fromJS(data: any): MessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rank"] = this.rank;
        data["title"] = this.title;
        data["messageType"] = this.messageType;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["beginDateUserEntry"] = this.beginDateUserEntry;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["endDateUserEntry"] = this.endDateUserEntry;
        data["primaryKey"] = this.primaryKey;
        data["forceHardcopy"] = this.forceHardcopy;
        data["isRequired"] = this.isRequired;
        data["isOverflowAllowed"] = this.isOverflowAllowed;
        data["creator"] = this.creator;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["createDateUserEntry"] = this.createDateUserEntry;
        data["approver"] = this.approver;
        data["approvalDate"] = this.approvalDate ? this.approvalDate.toISOString() : <any>undefined;
        data["approvalDateUserEntry"] = this.approvalDateUserEntry;
        data["status"] = this.status;
        data["sysPrinCount"] = this.sysPrinCount;
        data["hideInEcare"] = this.hideInEcare;
        data["graphicId"] = this.graphicId;
        data["lastUpdate"] = this.lastUpdate;
        data["deletionDate"] = this.deletionDate ? this.deletionDate.toISOString() : <any>undefined;
        data["deletionDateUserEntry"] = this.deletionDateUserEntry;
        data["doctypeId"] = this.doctypeId;
        data["doctypeName"] = this.doctypeName;
        data["customerSysPrin"] = this.customerSysPrin;
        data["canUserViewThisMessage"] = this.canUserViewThisMessage;
        data["canUserModifyThisMessage"] = this.canUserModifyThisMessage;
        data["canUserApproveThisMessage"] = this.canUserApproveThisMessage;
        data["canUserDeleteThisMessage"] = this.canUserDeleteThisMessage;
        data["canUserRestoreThisMessageFromTheTrash"] = this.canUserRestoreThisMessageFromTheTrash;
        data["canUserModifyStatusToPending"] = this.canUserModifyStatusToPending;
        data["canUserModifyStatusToDraft"] = this.canUserModifyStatusToDraft;
        data["canUserModifyRank"] = this.canUserModifyRank;
        return data;
    }
}

export interface IMessageDto {
    id: string;
    rank?: number | undefined;
    title: string;
    messageType: string;
    location: LocationDto;
    beginDate?: Date | undefined;
    beginDateUserEntry?: string | undefined;
    endDate?: Date | undefined;
    endDateUserEntry?: string | undefined;
    primaryKey?: number | undefined;
    forceHardcopy: boolean;
    isRequired: boolean;
    isOverflowAllowed: boolean;
    creator: string;
    createDate: Date;
    createDateUserEntry: string;
    approver: string;
    approvalDate?: Date | undefined;
    approvalDateUserEntry: string;
    status: MessageStatus;
    sysPrinCount?: number | undefined;
    hideInEcare?: boolean | undefined;
    graphicId?: string | undefined;
    lastUpdate: string;
    deletionDate?: Date | undefined;
    deletionDateUserEntry: string;
    doctypeId: string;
    doctypeName: string;
    customerSysPrin: string;
    canUserViewThisMessage: boolean;
    canUserModifyThisMessage: boolean;
    canUserApproveThisMessage: boolean;
    canUserDeleteThisMessage: boolean;
    canUserRestoreThisMessageFromTheTrash: boolean;
    canUserModifyStatusToPending: boolean;
    canUserModifyStatusToDraft: boolean;
    canUserModifyRank: boolean;
}

export enum MessageStatus {
    Draft = 0,
    Pending = 1,
    Approved = 2,
}

export class GetMessagesRequest implements IGetMessagesRequest {
    system!: string;
    principle!: string;
    docTypePrimaryKey!: number;

    constructor(data?: IGetMessagesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.system = _data["system"];
            this.principle = _data["principle"];
            this.docTypePrimaryKey = _data["docTypePrimaryKey"];
        }
    }

    static fromJS(data: any): GetMessagesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMessagesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["system"] = this.system;
        data["principle"] = this.principle;
        data["docTypePrimaryKey"] = this.docTypePrimaryKey;
        return data;
    }
}

export interface IGetMessagesRequest {
    system: string;
    principle: string;
    docTypePrimaryKey: number;
}

export class GetTrashBinMessagesResponse implements IGetTrashBinMessagesResponse {
    messages!: MessageDto[];

    constructor(data?: IGetTrashBinMessagesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(MessageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTrashBinMessagesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTrashBinMessagesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTrashBinMessagesResponse {
    messages: MessageDto[];
}

export class GetTrashBinMessagesRequest implements IGetTrashBinMessagesRequest {
    system!: string;
    principle!: string;
    docTypePrimaryKey!: number;

    constructor(data?: IGetTrashBinMessagesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.system = _data["system"];
            this.principle = _data["principle"];
            this.docTypePrimaryKey = _data["docTypePrimaryKey"];
        }
    }

    static fromJS(data: any): GetTrashBinMessagesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTrashBinMessagesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["system"] = this.system;
        data["principle"] = this.principle;
        data["docTypePrimaryKey"] = this.docTypePrimaryKey;
        return data;
    }
}

export interface IGetTrashBinMessagesRequest {
    system: string;
    principle: string;
    docTypePrimaryKey: number;
}

export class GetExternalClientGroupsResponse implements IGetExternalClientGroupsResponse {
    externalClientGroups!: ExternalClientReplacementGroup[];

    constructor(data?: IGetExternalClientGroupsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.externalClientGroups = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["externalClientGroups"])) {
                this.externalClientGroups = [] as any;
                for (let item of _data["externalClientGroups"])
                    this.externalClientGroups!.push(ExternalClientReplacementGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetExternalClientGroupsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetExternalClientGroupsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.externalClientGroups)) {
            data["externalClientGroups"] = [];
            for (let item of this.externalClientGroups)
                data["externalClientGroups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetExternalClientGroupsResponse {
    externalClientGroups: ExternalClientReplacementGroup[];
}

export class ExternalClientReplacementGroup extends KeyedItem implements IExternalClientReplacementGroup {
    applicationId?: string | undefined;
    groupName?: string | undefined;
    sysPrin?: SysPrin | undefined;
    created!: Date;
    replacementVariables?: ExternalClientReplacementVariable[] | undefined;

    constructor(data?: IExternalClientReplacementGroup) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.groupName = _data["groupName"];
            this.sysPrin = _data["sysPrin"] ? SysPrin.fromJS(_data["sysPrin"]) : <any>undefined;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            if (Array.isArray(_data["replacementVariables"])) {
                this.replacementVariables = [] as any;
                for (let item of _data["replacementVariables"])
                    this.replacementVariables!.push(ExternalClientReplacementVariable.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ExternalClientReplacementGroup {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalClientReplacementGroup();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["groupName"] = this.groupName;
        data["sysPrin"] = this.sysPrin ? this.sysPrin.toJSON() : <any>undefined;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        if (Array.isArray(this.replacementVariables)) {
            data["replacementVariables"] = [];
            for (let item of this.replacementVariables)
                data["replacementVariables"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IExternalClientReplacementGroup extends IKeyedItem {
    applicationId?: string | undefined;
    groupName?: string | undefined;
    sysPrin?: SysPrin | undefined;
    created: Date;
    replacementVariables?: ExternalClientReplacementVariable[] | undefined;
}

export abstract class ReplacementVariable extends KeyedItem implements IReplacementVariable {
    name?: string | undefined;
    friendlyName?: string | undefined;
    description?: string | undefined;
    requiredOlmFieldDefaultForeignKeyValue?: number | undefined;
    requiredOlmFieldForeignKey?: number | undefined;
    fieldName?: string | undefined;
    fieldDecode?: string | undefined;
    previewValue?: string | undefined;
    caseTranslation!: CaseTranslation;
    variableDataSource?: string | undefined;
    listLimit?: number | undefined;
    isRepeatingVar!: boolean;
    listLimitVar?: string | undefined;
    listCountVar?: string | undefined;

    constructor(data?: IReplacementVariable) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.friendlyName = _data["friendlyName"];
            this.description = _data["description"];
            this.requiredOlmFieldDefaultForeignKeyValue = _data["requiredOlmFieldDefaultForeignKeyValue"];
            this.requiredOlmFieldForeignKey = _data["requiredOlmFieldForeignKey"];
            this.fieldName = _data["fieldName"];
            this.fieldDecode = _data["fieldDecode"];
            this.previewValue = _data["previewValue"];
            this.caseTranslation = _data["caseTranslation"];
            this.variableDataSource = _data["variableDataSource"];
            this.listLimit = _data["listLimit"];
            this.isRepeatingVar = _data["isRepeatingVar"];
            this.listLimitVar = _data["listLimitVar"];
            this.listCountVar = _data["listCountVar"];
        }
    }

    static override fromJS(data: any): ReplacementVariable {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ReplacementVariable' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["friendlyName"] = this.friendlyName;
        data["description"] = this.description;
        data["requiredOlmFieldDefaultForeignKeyValue"] = this.requiredOlmFieldDefaultForeignKeyValue;
        data["requiredOlmFieldForeignKey"] = this.requiredOlmFieldForeignKey;
        data["fieldName"] = this.fieldName;
        data["fieldDecode"] = this.fieldDecode;
        data["previewValue"] = this.previewValue;
        data["caseTranslation"] = this.caseTranslation;
        data["variableDataSource"] = this.variableDataSource;
        data["listLimit"] = this.listLimit;
        data["isRepeatingVar"] = this.isRepeatingVar;
        data["listLimitVar"] = this.listLimitVar;
        data["listCountVar"] = this.listCountVar;
        super.toJSON(data);
        return data;
    }
}

export interface IReplacementVariable extends IKeyedItem {
    name?: string | undefined;
    friendlyName?: string | undefined;
    description?: string | undefined;
    requiredOlmFieldDefaultForeignKeyValue?: number | undefined;
    requiredOlmFieldForeignKey?: number | undefined;
    fieldName?: string | undefined;
    fieldDecode?: string | undefined;
    previewValue?: string | undefined;
    caseTranslation: CaseTranslation;
    variableDataSource?: string | undefined;
    listLimit?: number | undefined;
    isRepeatingVar: boolean;
    listLimitVar?: string | undefined;
    listCountVar?: string | undefined;
}

export class ExternalClientReplacementVariable extends ReplacementVariable implements IExternalClientReplacementVariable {
    sysPrin?: SysPrin | undefined;
    groupName?: string | undefined;
    friendlyName?: string | undefined;
    _FriendlyName?: string | undefined;

    constructor(data?: IExternalClientReplacementVariable) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sysPrin = _data["sysPrin"] ? SysPrin.fromJS(_data["sysPrin"]) : <any>undefined;
            this.groupName = _data["groupName"];
            this.friendlyName = _data["friendlyName"];
            this._FriendlyName = _data["_FriendlyName"];
        }
    }

    static override fromJS(data: any): ExternalClientReplacementVariable {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalClientReplacementVariable();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sysPrin"] = this.sysPrin ? this.sysPrin.toJSON() : <any>undefined;
        data["groupName"] = this.groupName;
        data["friendlyName"] = this.friendlyName;
        data["_FriendlyName"] = this._FriendlyName;
        super.toJSON(data);
        return data;
    }
}

export interface IExternalClientReplacementVariable extends IReplacementVariable {
    sysPrin?: SysPrin | undefined;
    groupName?: string | undefined;
    friendlyName?: string | undefined;
    _FriendlyName?: string | undefined;
}

export enum CaseTranslation {
    NONE = 0,
    MIXED = 1,
    UPPER = 2,
    LOWER = 3,
}

export class OlmReplacementVariable extends ReplacementVariable implements IOlmReplacementVariable {
    documentTypeForeignKey?: number | undefined;
    friendlyName?: string | undefined;

    constructor(data?: IOlmReplacementVariable) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentTypeForeignKey = _data["documentTypeForeignKey"];
            this.friendlyName = _data["friendlyName"];
        }
    }

    static override fromJS(data: any): OlmReplacementVariable {
        data = typeof data === 'object' ? data : {};
        let result = new OlmReplacementVariable();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentTypeForeignKey"] = this.documentTypeForeignKey;
        data["friendlyName"] = this.friendlyName;
        super.toJSON(data);
        return data;
    }
}

export interface IOlmReplacementVariable extends IReplacementVariable {
    documentTypeForeignKey?: number | undefined;
    friendlyName?: string | undefined;
}

export class VantageReplacementVariable extends ReplacementVariable implements IVantageReplacementVariable {
    sysPrin?: SysPrin | undefined;
    friendlyName?: string | undefined;
    _FriendlyName?: string | undefined;
    isFriendlyNameFormatValid!: boolean;

    constructor(data?: IVantageReplacementVariable) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sysPrin = _data["sysPrin"] ? SysPrin.fromJS(_data["sysPrin"]) : <any>undefined;
            this.friendlyName = _data["friendlyName"];
            this._FriendlyName = _data["_FriendlyName"];
            this.isFriendlyNameFormatValid = _data["isFriendlyNameFormatValid"];
        }
    }

    static override fromJS(data: any): VantageReplacementVariable {
        data = typeof data === 'object' ? data : {};
        let result = new VantageReplacementVariable();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sysPrin"] = this.sysPrin ? this.sysPrin.toJSON() : <any>undefined;
        data["friendlyName"] = this.friendlyName;
        data["_FriendlyName"] = this._FriendlyName;
        data["isFriendlyNameFormatValid"] = this.isFriendlyNameFormatValid;
        super.toJSON(data);
        return data;
    }
}

export interface IVantageReplacementVariable extends IReplacementVariable {
    sysPrin?: SysPrin | undefined;
    friendlyName?: string | undefined;
    _FriendlyName?: string | undefined;
    isFriendlyNameFormatValid: boolean;
}

export class RestoreMessageRequest implements IRestoreMessageRequest {
    primaryKeys!: number[];

    constructor(data?: IRestoreMessageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.primaryKeys = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["primaryKeys"])) {
                this.primaryKeys = [] as any;
                for (let item of _data["primaryKeys"])
                    this.primaryKeys!.push(item);
            }
        }
    }

    static fromJS(data: any): RestoreMessageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RestoreMessageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.primaryKeys)) {
            data["primaryKeys"] = [];
            for (let item of this.primaryKeys)
                data["primaryKeys"].push(item);
        }
        return data;
    }
}

export interface IRestoreMessageRequest {
    primaryKeys: number[];
}

export class GetReplacementVariablesAvailableToMessageResponse implements IGetReplacementVariablesAvailableToMessageResponse {
    replacementVariables!: ReplacementVariableDto[];
    forbiddenVariablesWarning!: string;

    constructor(data?: IGetReplacementVariablesAvailableToMessageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.replacementVariables = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["replacementVariables"])) {
                this.replacementVariables = [] as any;
                for (let item of _data["replacementVariables"])
                    this.replacementVariables!.push(ReplacementVariableDto.fromJS(item));
            }
            this.forbiddenVariablesWarning = _data["forbiddenVariablesWarning"];
        }
    }

    static fromJS(data: any): GetReplacementVariablesAvailableToMessageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetReplacementVariablesAvailableToMessageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.replacementVariables)) {
            data["replacementVariables"] = [];
            for (let item of this.replacementVariables)
                data["replacementVariables"].push(item.toJSON());
        }
        data["forbiddenVariablesWarning"] = this.forbiddenVariablesWarning;
        return data;
    }
}

export interface IGetReplacementVariablesAvailableToMessageResponse {
    replacementVariables: ReplacementVariableDto[];
    forbiddenVariablesWarning: string;
}

export class ReplacementVariableDto implements IReplacementVariableDto {
    name!: string;
    listCountVar!: string;
    listLimitVar!: string;

    constructor(data?: IReplacementVariableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.listCountVar = _data["listCountVar"];
            this.listLimitVar = _data["listLimitVar"];
        }
    }

    static fromJS(data: any): ReplacementVariableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReplacementVariableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["listCountVar"] = this.listCountVar;
        data["listLimitVar"] = this.listLimitVar;
        return data;
    }
}

export interface IReplacementVariableDto {
    name: string;
    listCountVar: string;
    listLimitVar: string;
}

export class GetReplacementVariablesAvailableToMessageRequest implements IGetReplacementVariablesAvailableToMessageRequest {
    message!: OlmMessage;

    constructor(data?: IGetReplacementVariablesAvailableToMessageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.message = new OlmMessage();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"] ? OlmMessage.fromJS(_data["message"]) : new OlmMessage();
        }
    }

    static fromJS(data: any): GetReplacementVariablesAvailableToMessageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetReplacementVariablesAvailableToMessageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message ? this.message.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetReplacementVariablesAvailableToMessageRequest {
    message: OlmMessage;
}

export class SavableItem extends KeyedItem implements ISavableItem {
    created!: Date;
    createdBy?: string | undefined;

    constructor(data?: ISavableItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
        }
    }

    static override fromJS(data: any): SavableItem {
        data = typeof data === 'object' ? data : {};
        let result = new SavableItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        super.toJSON(data);
        return data;
    }
}

export interface ISavableItem extends IKeyedItem {
    created: Date;
    createdBy?: string | undefined;
}

export class UpdatableItem extends SavableItem implements IUpdatableItem {
    lastUpdated!: Date;
    lastUpdatedBy?: string | undefined;

    constructor(data?: IUpdatableItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
        }
    }

    static override fromJS(data: any): UpdatableItem {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatableItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdatableItem extends ISavableItem {
    lastUpdated: Date;
    lastUpdatedBy?: string | undefined;
}

export class OlmMessage extends UpdatableItem implements IOlmMessage {
    originalPrimaryKeyUsedOnlyByCopyMethod?: number | undefined;
    sysPrins?: SysPrin[] | undefined;
    title?: string | undefined;
    status!: OlmMessageStatus;
    requestorFirstName?: string | undefined;
    requestorLastName?: string | undefined;
    requestorEmail?: string | undefined;
    departmentFk?: string | undefined;
    departmentName?: string | undefined;
    messageNotes?: string | undefined;
    messageId?: string | undefined;
    messageType?: string | undefined;
    beginDate?: Date | undefined;
    beginDateUserEntry?: string | undefined;
    endDate?: Date | undefined;
    endDateUserEntry?: string | undefined;
    selectivityProfile?: OlmSelectivityProfile | undefined;
    selectivityProfileForeignKey?: number | undefined;
    forceHardcopy!: boolean;
    hideInECare!: boolean;
    multiChannel!: boolean;
    isRequired!: boolean;
    location?: OlmLocation | undefined;
    locationName?: string | undefined;
    isMessageInSecureLocation!: boolean;
    locationForeignKey?: number | undefined;
    rank?: number | undefined;
    rankUserEntry?: string | undefined;
    backgroundColor?: GlobalColor | undefined;
    backgroundColorForeignKey?: number | undefined;
    lineSpacing!: number;
    lineSpacingFormattedValue?: string | undefined;
    isOverflowAllowed!: boolean;
    isInTrash!: boolean;
    approvedBy?: string | undefined;
    approved?: Date | undefined;
    hasEverBeenApproved!: boolean;
    details?: { [key: string]: OlmMessageDetail; } | undefined;
    detailsList?: DictionaryEntry[] | undefined;
    vantageQueries?: { [key: string]: OlmVantageQuery; } | undefined;
    corporateVantageQueryName?: string | undefined;
    isCorporateVantageMessage!: boolean;
    isVantageMessage!: boolean;
    externalClientReplacementGroups?: { [key: string]: ExternalClientReplacementGroup; } | undefined;
    isExternalClientGroupMessage!: boolean;
    canThisMessageBePreviewedAlone!: boolean;
    canThisMessageBePreviewedWithOtherMessages!: boolean;
    deletedDate?: Date | undefined;
    massUpdateImportFileName?: string | undefined;
    massUpdateImportFileTimestamp?: Date | undefined;
    changeHistory?: ChangeHistoryItem[] | undefined;
    secondaryLinkedMessages?: SecondaryMessageInfoForLinking[] | undefined;
    primaryLinkedMessages?: OlmLinkedMessageDataRow[] | undefined;
    allLinkedMessages?: OlmLinkedMessageDataRow[] | undefined;
    originMessageKey?: number | undefined;
    originMessageInstance?: string | undefined;

    constructor(data?: IOlmMessage) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.originalPrimaryKeyUsedOnlyByCopyMethod = _data["originalPrimaryKeyUsedOnlyByCopyMethod"];
            if (Array.isArray(_data["sysPrins"])) {
                this.sysPrins = [] as any;
                for (let item of _data["sysPrins"])
                    this.sysPrins!.push(SysPrin.fromJS(item));
            }
            this.title = _data["title"];
            this.status = _data["status"];
            this.requestorFirstName = _data["requestorFirstName"];
            this.requestorLastName = _data["requestorLastName"];
            this.requestorEmail = _data["requestorEmail"];
            this.departmentFk = _data["departmentFk"];
            this.departmentName = _data["departmentName"];
            this.messageNotes = _data["messageNotes"];
            this.messageId = _data["messageId"];
            this.messageType = _data["messageType"];
            this.beginDate = _data["beginDate"] ? new Date(_data["beginDate"].toString()) : <any>undefined;
            this.beginDateUserEntry = _data["beginDateUserEntry"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.endDateUserEntry = _data["endDateUserEntry"];
            this.selectivityProfile = _data["selectivityProfile"] ? OlmSelectivityProfile.fromJS(_data["selectivityProfile"]) : <any>undefined;
            this.selectivityProfileForeignKey = _data["selectivityProfileForeignKey"];
            this.forceHardcopy = _data["forceHardcopy"];
            this.hideInECare = _data["hideInECare"];
            this.multiChannel = _data["multiChannel"];
            this.isRequired = _data["isRequired"];
            this.location = _data["location"] ? OlmLocation.fromJS(_data["location"]) : <any>undefined;
            this.locationName = _data["locationName"];
            this.isMessageInSecureLocation = _data["isMessageInSecureLocation"];
            this.locationForeignKey = _data["locationForeignKey"];
            this.rank = _data["rank"];
            this.rankUserEntry = _data["rankUserEntry"];
            this.backgroundColor = _data["backgroundColor"] ? GlobalColor.fromJS(_data["backgroundColor"]) : <any>undefined;
            this.backgroundColorForeignKey = _data["backgroundColorForeignKey"];
            this.lineSpacing = _data["lineSpacing"];
            this.lineSpacingFormattedValue = _data["lineSpacingFormattedValue"];
            this.isOverflowAllowed = _data["isOverflowAllowed"];
            this.isInTrash = _data["isInTrash"];
            this.approvedBy = _data["approvedBy"];
            this.approved = _data["approved"] ? new Date(_data["approved"].toString()) : <any>undefined;
            this.hasEverBeenApproved = _data["hasEverBeenApproved"];
            if (_data["details"]) {
                this.details = {} as any;
                for (let key in _data["details"]) {
                    if (_data["details"].hasOwnProperty(key))
                        (<any>this.details)![key] = _data["details"][key] ? OlmMessageDetail.fromJS(_data["details"][key]) : new OlmMessageDetail();
                }
            }
            if (Array.isArray(_data["detailsList"])) {
                this.detailsList = [] as any;
                for (let item of _data["detailsList"])
                    this.detailsList!.push(DictionaryEntry.fromJS(item));
            }
            if (_data["vantageQueries"]) {
                this.vantageQueries = {} as any;
                for (let key in _data["vantageQueries"]) {
                    if (_data["vantageQueries"].hasOwnProperty(key))
                        (<any>this.vantageQueries)![key] = _data["vantageQueries"][key] ? OlmVantageQuery.fromJS(_data["vantageQueries"][key]) : new OlmVantageQuery();
                }
            }
            this.corporateVantageQueryName = _data["corporateVantageQueryName"];
            this.isCorporateVantageMessage = _data["isCorporateVantageMessage"];
            this.isVantageMessage = _data["isVantageMessage"];
            if (_data["externalClientReplacementGroups"]) {
                this.externalClientReplacementGroups = {} as any;
                for (let key in _data["externalClientReplacementGroups"]) {
                    if (_data["externalClientReplacementGroups"].hasOwnProperty(key))
                        (<any>this.externalClientReplacementGroups)![key] = _data["externalClientReplacementGroups"][key] ? ExternalClientReplacementGroup.fromJS(_data["externalClientReplacementGroups"][key]) : new ExternalClientReplacementGroup();
                }
            }
            this.isExternalClientGroupMessage = _data["isExternalClientGroupMessage"];
            this.canThisMessageBePreviewedAlone = _data["canThisMessageBePreviewedAlone"];
            this.canThisMessageBePreviewedWithOtherMessages = _data["canThisMessageBePreviewedWithOtherMessages"];
            this.deletedDate = _data["deletedDate"] ? new Date(_data["deletedDate"].toString()) : <any>undefined;
            this.massUpdateImportFileName = _data["massUpdateImportFileName"];
            this.massUpdateImportFileTimestamp = _data["massUpdateImportFileTimestamp"] ? new Date(_data["massUpdateImportFileTimestamp"].toString()) : <any>undefined;
            if (Array.isArray(_data["changeHistory"])) {
                this.changeHistory = [] as any;
                for (let item of _data["changeHistory"])
                    this.changeHistory!.push(ChangeHistoryItem.fromJS(item));
            }
            if (Array.isArray(_data["secondaryLinkedMessages"])) {
                this.secondaryLinkedMessages = [] as any;
                for (let item of _data["secondaryLinkedMessages"])
                    this.secondaryLinkedMessages!.push(SecondaryMessageInfoForLinking.fromJS(item));
            }
            if (Array.isArray(_data["primaryLinkedMessages"])) {
                this.primaryLinkedMessages = [] as any;
                for (let item of _data["primaryLinkedMessages"])
                    this.primaryLinkedMessages!.push(OlmLinkedMessageDataRow.fromJS(item));
            }
            if (Array.isArray(_data["allLinkedMessages"])) {
                this.allLinkedMessages = [] as any;
                for (let item of _data["allLinkedMessages"])
                    this.allLinkedMessages!.push(OlmLinkedMessageDataRow.fromJS(item));
            }
            this.originMessageKey = _data["originMessageKey"];
            this.originMessageInstance = _data["originMessageInstance"];
        }
    }

    static override fromJS(data: any): OlmMessage {
        data = typeof data === 'object' ? data : {};
        let result = new OlmMessage();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalPrimaryKeyUsedOnlyByCopyMethod"] = this.originalPrimaryKeyUsedOnlyByCopyMethod;
        if (Array.isArray(this.sysPrins)) {
            data["sysPrins"] = [];
            for (let item of this.sysPrins)
                data["sysPrins"].push(item.toJSON());
        }
        data["title"] = this.title;
        data["status"] = this.status;
        data["requestorFirstName"] = this.requestorFirstName;
        data["requestorLastName"] = this.requestorLastName;
        data["requestorEmail"] = this.requestorEmail;
        data["departmentFk"] = this.departmentFk;
        data["departmentName"] = this.departmentName;
        data["messageNotes"] = this.messageNotes;
        data["messageId"] = this.messageId;
        data["messageType"] = this.messageType;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["beginDateUserEntry"] = this.beginDateUserEntry;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["endDateUserEntry"] = this.endDateUserEntry;
        data["selectivityProfile"] = this.selectivityProfile ? this.selectivityProfile.toJSON() : <any>undefined;
        data["selectivityProfileForeignKey"] = this.selectivityProfileForeignKey;
        data["forceHardcopy"] = this.forceHardcopy;
        data["hideInECare"] = this.hideInECare;
        data["multiChannel"] = this.multiChannel;
        data["isRequired"] = this.isRequired;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["locationName"] = this.locationName;
        data["isMessageInSecureLocation"] = this.isMessageInSecureLocation;
        data["locationForeignKey"] = this.locationForeignKey;
        data["rank"] = this.rank;
        data["rankUserEntry"] = this.rankUserEntry;
        data["backgroundColor"] = this.backgroundColor ? this.backgroundColor.toJSON() : <any>undefined;
        data["backgroundColorForeignKey"] = this.backgroundColorForeignKey;
        data["lineSpacing"] = this.lineSpacing;
        data["lineSpacingFormattedValue"] = this.lineSpacingFormattedValue;
        data["isOverflowAllowed"] = this.isOverflowAllowed;
        data["isInTrash"] = this.isInTrash;
        data["approvedBy"] = this.approvedBy;
        data["approved"] = this.approved ? this.approved.toISOString() : <any>undefined;
        data["hasEverBeenApproved"] = this.hasEverBeenApproved;
        if (this.details) {
            data["details"] = {};
            for (let key in this.details) {
                if (this.details.hasOwnProperty(key))
                    (<any>data["details"])[key] = this.details[key] ? this.details[key].toJSON() : <any>undefined;
            }
        }
        if (Array.isArray(this.detailsList)) {
            data["detailsList"] = [];
            for (let item of this.detailsList)
                data["detailsList"].push(item.toJSON());
        }
        if (this.vantageQueries) {
            data["vantageQueries"] = {};
            for (let key in this.vantageQueries) {
                if (this.vantageQueries.hasOwnProperty(key))
                    (<any>data["vantageQueries"])[key] = this.vantageQueries[key] ? this.vantageQueries[key].toJSON() : <any>undefined;
            }
        }
        data["corporateVantageQueryName"] = this.corporateVantageQueryName;
        data["isCorporateVantageMessage"] = this.isCorporateVantageMessage;
        data["isVantageMessage"] = this.isVantageMessage;
        if (this.externalClientReplacementGroups) {
            data["externalClientReplacementGroups"] = {};
            for (let key in this.externalClientReplacementGroups) {
                if (this.externalClientReplacementGroups.hasOwnProperty(key))
                    (<any>data["externalClientReplacementGroups"])[key] = this.externalClientReplacementGroups[key] ? this.externalClientReplacementGroups[key].toJSON() : <any>undefined;
            }
        }
        data["isExternalClientGroupMessage"] = this.isExternalClientGroupMessage;
        data["canThisMessageBePreviewedAlone"] = this.canThisMessageBePreviewedAlone;
        data["canThisMessageBePreviewedWithOtherMessages"] = this.canThisMessageBePreviewedWithOtherMessages;
        data["deletedDate"] = this.deletedDate ? this.deletedDate.toISOString() : <any>undefined;
        data["massUpdateImportFileName"] = this.massUpdateImportFileName;
        data["massUpdateImportFileTimestamp"] = this.massUpdateImportFileTimestamp ? this.massUpdateImportFileTimestamp.toISOString() : <any>undefined;
        if (Array.isArray(this.changeHistory)) {
            data["changeHistory"] = [];
            for (let item of this.changeHistory)
                data["changeHistory"].push(item.toJSON());
        }
        if (Array.isArray(this.secondaryLinkedMessages)) {
            data["secondaryLinkedMessages"] = [];
            for (let item of this.secondaryLinkedMessages)
                data["secondaryLinkedMessages"].push(item.toJSON());
        }
        if (Array.isArray(this.primaryLinkedMessages)) {
            data["primaryLinkedMessages"] = [];
            for (let item of this.primaryLinkedMessages)
                data["primaryLinkedMessages"].push(item.toJSON());
        }
        if (Array.isArray(this.allLinkedMessages)) {
            data["allLinkedMessages"] = [];
            for (let item of this.allLinkedMessages)
                data["allLinkedMessages"].push(item.toJSON());
        }
        data["originMessageKey"] = this.originMessageKey;
        data["originMessageInstance"] = this.originMessageInstance;
        super.toJSON(data);
        return data;
    }
}

export interface IOlmMessage extends IUpdatableItem {
    originalPrimaryKeyUsedOnlyByCopyMethod?: number | undefined;
    sysPrins?: SysPrin[] | undefined;
    title?: string | undefined;
    status: OlmMessageStatus;
    requestorFirstName?: string | undefined;
    requestorLastName?: string | undefined;
    requestorEmail?: string | undefined;
    departmentFk?: string | undefined;
    departmentName?: string | undefined;
    messageNotes?: string | undefined;
    messageId?: string | undefined;
    messageType?: string | undefined;
    beginDate?: Date | undefined;
    beginDateUserEntry?: string | undefined;
    endDate?: Date | undefined;
    endDateUserEntry?: string | undefined;
    selectivityProfile?: OlmSelectivityProfile | undefined;
    selectivityProfileForeignKey?: number | undefined;
    forceHardcopy: boolean;
    hideInECare: boolean;
    multiChannel: boolean;
    isRequired: boolean;
    location?: OlmLocation | undefined;
    locationName?: string | undefined;
    isMessageInSecureLocation: boolean;
    locationForeignKey?: number | undefined;
    rank?: number | undefined;
    rankUserEntry?: string | undefined;
    backgroundColor?: GlobalColor | undefined;
    backgroundColorForeignKey?: number | undefined;
    lineSpacing: number;
    lineSpacingFormattedValue?: string | undefined;
    isOverflowAllowed: boolean;
    isInTrash: boolean;
    approvedBy?: string | undefined;
    approved?: Date | undefined;
    hasEverBeenApproved: boolean;
    details?: { [key: string]: OlmMessageDetail; } | undefined;
    detailsList?: DictionaryEntry[] | undefined;
    vantageQueries?: { [key: string]: OlmVantageQuery; } | undefined;
    corporateVantageQueryName?: string | undefined;
    isCorporateVantageMessage: boolean;
    isVantageMessage: boolean;
    externalClientReplacementGroups?: { [key: string]: ExternalClientReplacementGroup; } | undefined;
    isExternalClientGroupMessage: boolean;
    canThisMessageBePreviewedAlone: boolean;
    canThisMessageBePreviewedWithOtherMessages: boolean;
    deletedDate?: Date | undefined;
    massUpdateImportFileName?: string | undefined;
    massUpdateImportFileTimestamp?: Date | undefined;
    changeHistory?: ChangeHistoryItem[] | undefined;
    secondaryLinkedMessages?: SecondaryMessageInfoForLinking[] | undefined;
    primaryLinkedMessages?: OlmLinkedMessageDataRow[] | undefined;
    allLinkedMessages?: OlmLinkedMessageDataRow[] | undefined;
    originMessageKey?: number | undefined;
    originMessageInstance?: string | undefined;
}

export enum OlmMessageStatus {
    Draft = 0,
    Pending = 1,
    Approved = 2,
}

export class OlmSelectivityProfile extends UpdatableItem implements IOlmSelectivityProfile {
    documentTypeForeignKey?: number | undefined;
    isSelectivityProfileTemplate!: boolean;
    name?: string | undefined;
    inclusionOperation!: InclusionOperator;
    criteria?: OlmSelectivityCriterion[] | undefined;
    highestRecordedLogicalBlockId?: number | undefined;
    highestRecordedLogicalBlockIdText?: string | undefined;

    constructor(data?: IOlmSelectivityProfile) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentTypeForeignKey = _data["documentTypeForeignKey"];
            this.isSelectivityProfileTemplate = _data["isSelectivityProfileTemplate"];
            this.name = _data["name"];
            this.inclusionOperation = _data["inclusionOperation"];
            if (Array.isArray(_data["criteria"])) {
                this.criteria = [] as any;
                for (let item of _data["criteria"])
                    this.criteria!.push(OlmSelectivityCriterion.fromJS(item));
            }
            this.highestRecordedLogicalBlockId = _data["highestRecordedLogicalBlockId"];
            this.highestRecordedLogicalBlockIdText = _data["highestRecordedLogicalBlockIdText"];
        }
    }

    static override fromJS(data: any): OlmSelectivityProfile {
        data = typeof data === 'object' ? data : {};
        let result = new OlmSelectivityProfile();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentTypeForeignKey"] = this.documentTypeForeignKey;
        data["isSelectivityProfileTemplate"] = this.isSelectivityProfileTemplate;
        data["name"] = this.name;
        data["inclusionOperation"] = this.inclusionOperation;
        if (Array.isArray(this.criteria)) {
            data["criteria"] = [];
            for (let item of this.criteria)
                data["criteria"].push(item.toJSON());
        }
        data["highestRecordedLogicalBlockId"] = this.highestRecordedLogicalBlockId;
        data["highestRecordedLogicalBlockIdText"] = this.highestRecordedLogicalBlockIdText;
        super.toJSON(data);
        return data;
    }
}

export interface IOlmSelectivityProfile extends IUpdatableItem {
    documentTypeForeignKey?: number | undefined;
    isSelectivityProfileTemplate: boolean;
    name?: string | undefined;
    inclusionOperation: InclusionOperator;
    criteria?: OlmSelectivityCriterion[] | undefined;
    highestRecordedLogicalBlockId?: number | undefined;
    highestRecordedLogicalBlockIdText?: string | undefined;
}

export enum InclusionOperator {
    Always = 65,
    UnlessSelectivityOrAnExternalFileMatches = 69,
    UnlessSelectivityAndAnExternalFileMatches = 70,
    UnlessSelectivityMatches = 71,
    WheneverSelectivityOrAnExternalFileMatches = 73,
    WheneverSelectivityAndAnExternalFileMatches = 74,
    WheneverSelectivityMatches = 75,
    WheneverAVantageQueryMatches = 86,
    WheneverAVantageQueryAndAnExternalFileMatches = 87,
    WheneverAnExternalFileMatches = 88,
}

export class OlmSelectivityCriterion extends UpdatableItem implements IOlmSelectivityCriterion {
    selectivityProfileMasterForeignKey?: number | undefined;
    operand?: OlmSelectivityOperand | undefined;
    field?: OlmField | undefined;
    sequence!: number;
    extendedFieldSequence?: string | undefined;
    valuesRelationship!: CombinatorialCollectionOperator;
    nextCriterionRelationship!: CombinatorialOperator;
    values?: OlmSelectivityCriterionValue[] | undefined;
    valuesAsCsv?: string | undefined;
    combinedGroupCriteriaId?: string | undefined;
    isCombinedGroupMember!: boolean;
    isCombinedCriteriaParentRecord!: boolean;
    isCsv!: boolean;
    logicalBlockId?: number | undefined;
    logicalBlockIdText?: string | undefined;
    criterionNotes?: string | undefined;

    constructor(data?: IOlmSelectivityCriterion) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.selectivityProfileMasterForeignKey = _data["selectivityProfileMasterForeignKey"];
            this.operand = _data["operand"] ? OlmSelectivityOperand.fromJS(_data["operand"]) : <any>undefined;
            this.field = _data["field"] ? OlmField.fromJS(_data["field"]) : <any>undefined;
            this.sequence = _data["sequence"];
            this.extendedFieldSequence = _data["extendedFieldSequence"];
            this.valuesRelationship = _data["valuesRelationship"];
            this.nextCriterionRelationship = _data["nextCriterionRelationship"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(OlmSelectivityCriterionValue.fromJS(item));
            }
            this.valuesAsCsv = _data["valuesAsCsv"];
            this.combinedGroupCriteriaId = _data["combinedGroupCriteriaId"];
            this.isCombinedGroupMember = _data["isCombinedGroupMember"];
            this.isCombinedCriteriaParentRecord = _data["isCombinedCriteriaParentRecord"];
            this.isCsv = _data["isCsv"];
            this.logicalBlockId = _data["logicalBlockId"];
            this.logicalBlockIdText = _data["logicalBlockIdText"];
            this.criterionNotes = _data["criterionNotes"];
        }
    }

    static override fromJS(data: any): OlmSelectivityCriterion {
        data = typeof data === 'object' ? data : {};
        let result = new OlmSelectivityCriterion();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selectivityProfileMasterForeignKey"] = this.selectivityProfileMasterForeignKey;
        data["operand"] = this.operand ? this.operand.toJSON() : <any>undefined;
        data["field"] = this.field ? this.field.toJSON() : <any>undefined;
        data["sequence"] = this.sequence;
        data["extendedFieldSequence"] = this.extendedFieldSequence;
        data["valuesRelationship"] = this.valuesRelationship;
        data["nextCriterionRelationship"] = this.nextCriterionRelationship;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        data["valuesAsCsv"] = this.valuesAsCsv;
        data["combinedGroupCriteriaId"] = this.combinedGroupCriteriaId;
        data["isCombinedGroupMember"] = this.isCombinedGroupMember;
        data["isCombinedCriteriaParentRecord"] = this.isCombinedCriteriaParentRecord;
        data["isCsv"] = this.isCsv;
        data["logicalBlockId"] = this.logicalBlockId;
        data["logicalBlockIdText"] = this.logicalBlockIdText;
        data["criterionNotes"] = this.criterionNotes;
        super.toJSON(data);
        return data;
    }
}

export interface IOlmSelectivityCriterion extends IUpdatableItem {
    selectivityProfileMasterForeignKey?: number | undefined;
    operand?: OlmSelectivityOperand | undefined;
    field?: OlmField | undefined;
    sequence: number;
    extendedFieldSequence?: string | undefined;
    valuesRelationship: CombinatorialCollectionOperator;
    nextCriterionRelationship: CombinatorialOperator;
    values?: OlmSelectivityCriterionValue[] | undefined;
    valuesAsCsv?: string | undefined;
    combinedGroupCriteriaId?: string | undefined;
    isCombinedGroupMember: boolean;
    isCombinedCriteriaParentRecord: boolean;
    isCsv: boolean;
    logicalBlockId?: number | undefined;
    logicalBlockIdText?: string | undefined;
    criterionNotes?: string | undefined;
}

export class OlmSelectivityOperand extends UpdatableItem implements IOlmSelectivityOperand {
    name?: string | undefined;
    operator!: OperatorType;
    requiredValuesRelationship?: CombinatorialCollectionOperator | undefined;

    constructor(data?: IOlmSelectivityOperand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.operator = _data["operator"];
            this.requiredValuesRelationship = _data["requiredValuesRelationship"];
        }
    }

    static override fromJS(data: any): OlmSelectivityOperand {
        data = typeof data === 'object' ? data : {};
        let result = new OlmSelectivityOperand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["operator"] = this.operator;
        data["requiredValuesRelationship"] = this.requiredValuesRelationship;
        super.toJSON(data);
        return data;
    }
}

export interface IOlmSelectivityOperand extends IUpdatableItem {
    name?: string | undefined;
    operator: OperatorType;
    requiredValuesRelationship?: CombinatorialCollectionOperator | undefined;
}

export enum OperatorType {
    Is_Equal_To = 0,
    Is_Not_Equal_To = 1,
    Is_Between = 2,
    Is_Not_Between = 3,
    Is_Greater_Than = 4,
    Is_Greater_Than_or_Equal_To = 5,
    Is_Less_Than = 6,
    Is_Less_Than_or_Equal_To = 7,
    Is_True = 8,
    Is_False = 9,
    Is_Not_Blank = 10,
    Is_Blank = 11,
    Contains = 12,
    Does_Not_Contain = 13,
}

export enum CombinatorialCollectionOperator {
    All = 65,
    Any = 79,
}

export class OlmField extends KeyedItem implements IOlmField {
    isMonthsRemainingField!: boolean;
    isStepStoneMonthsRemainingField!: boolean;
    isServicePackageCodesField!: boolean;
    isLookInsideServicePackageCodesField!: boolean;
    isDiscountTypeField!: boolean;
    isActiveDiscountCodeField!: boolean;
    isEquipmentStatusField!: boolean;
    name?: string | undefined;
    length!: number;
    lengthUserEntry?: string | undefined;
    isMultiEntry!: boolean;
    isMultiEntry_OriginalValue!: boolean;
    isStandaloneSelectivity!: boolean;
    isStandaloneSelectivity_OriginalValue!: boolean;
    documentType?: OlmDocumentType | undefined;
    dataType?: OlmDataType | undefined;
    usesRequiredValuesRelationship!: boolean;
    isExternalSource!: boolean;
    isExternalSource_OriginalValue!: boolean;
    isSequenceRequired!: boolean;
    lowValue?: number | undefined;
    highValue?: number | undefined;
    values?: OlmFieldValue[] | undefined;
    isCombinedSelectivityParentRecord!: boolean;
    allowCombiningCriteriaIntoGroups!: boolean;
    combinedSelectivityFieldName!: CombinedSelectivityFieldNames;
    allowAnyNone!: boolean;
    allowAnyNoneOriginalValue!: boolean;
    allow_Any_None_Enable!: boolean;
    allow_Any_None_EnableOriginalValue!: boolean;

    constructor(data?: IOlmField) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isMonthsRemainingField = _data["isMonthsRemainingField"];
            this.isStepStoneMonthsRemainingField = _data["isStepStoneMonthsRemainingField"];
            this.isServicePackageCodesField = _data["isServicePackageCodesField"];
            this.isLookInsideServicePackageCodesField = _data["isLookInsideServicePackageCodesField"];
            this.isDiscountTypeField = _data["isDiscountTypeField"];
            this.isActiveDiscountCodeField = _data["isActiveDiscountCodeField"];
            this.isEquipmentStatusField = _data["isEquipmentStatusField"];
            this.name = _data["name"];
            this.length = _data["length"];
            this.lengthUserEntry = _data["lengthUserEntry"];
            this.isMultiEntry = _data["isMultiEntry"];
            this.isMultiEntry_OriginalValue = _data["isMultiEntry_OriginalValue"];
            this.isStandaloneSelectivity = _data["isStandaloneSelectivity"];
            this.isStandaloneSelectivity_OriginalValue = _data["isStandaloneSelectivity_OriginalValue"];
            this.documentType = _data["documentType"] ? OlmDocumentType.fromJS(_data["documentType"]) : <any>undefined;
            this.dataType = _data["dataType"] ? OlmDataType.fromJS(_data["dataType"]) : <any>undefined;
            this.usesRequiredValuesRelationship = _data["usesRequiredValuesRelationship"];
            this.isExternalSource = _data["isExternalSource"];
            this.isExternalSource_OriginalValue = _data["isExternalSource_OriginalValue"];
            this.isSequenceRequired = _data["isSequenceRequired"];
            this.lowValue = _data["lowValue"];
            this.highValue = _data["highValue"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(OlmFieldValue.fromJS(item));
            }
            this.isCombinedSelectivityParentRecord = _data["isCombinedSelectivityParentRecord"];
            this.allowCombiningCriteriaIntoGroups = _data["allowCombiningCriteriaIntoGroups"];
            this.combinedSelectivityFieldName = _data["combinedSelectivityFieldName"];
            this.allowAnyNone = _data["allowAnyNone"];
            this.allowAnyNoneOriginalValue = _data["allowAnyNoneOriginalValue"];
            this.allow_Any_None_Enable = _data["allow_Any_None_Enable"];
            this.allow_Any_None_EnableOriginalValue = _data["allow_Any_None_EnableOriginalValue"];
        }
    }

    static override fromJS(data: any): OlmField {
        data = typeof data === 'object' ? data : {};
        let result = new OlmField();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isMonthsRemainingField"] = this.isMonthsRemainingField;
        data["isStepStoneMonthsRemainingField"] = this.isStepStoneMonthsRemainingField;
        data["isServicePackageCodesField"] = this.isServicePackageCodesField;
        data["isLookInsideServicePackageCodesField"] = this.isLookInsideServicePackageCodesField;
        data["isDiscountTypeField"] = this.isDiscountTypeField;
        data["isActiveDiscountCodeField"] = this.isActiveDiscountCodeField;
        data["isEquipmentStatusField"] = this.isEquipmentStatusField;
        data["name"] = this.name;
        data["length"] = this.length;
        data["lengthUserEntry"] = this.lengthUserEntry;
        data["isMultiEntry"] = this.isMultiEntry;
        data["isMultiEntry_OriginalValue"] = this.isMultiEntry_OriginalValue;
        data["isStandaloneSelectivity"] = this.isStandaloneSelectivity;
        data["isStandaloneSelectivity_OriginalValue"] = this.isStandaloneSelectivity_OriginalValue;
        data["documentType"] = this.documentType ? this.documentType.toJSON() : <any>undefined;
        data["dataType"] = this.dataType ? this.dataType.toJSON() : <any>undefined;
        data["usesRequiredValuesRelationship"] = this.usesRequiredValuesRelationship;
        data["isExternalSource"] = this.isExternalSource;
        data["isExternalSource_OriginalValue"] = this.isExternalSource_OriginalValue;
        data["isSequenceRequired"] = this.isSequenceRequired;
        data["lowValue"] = this.lowValue;
        data["highValue"] = this.highValue;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        data["isCombinedSelectivityParentRecord"] = this.isCombinedSelectivityParentRecord;
        data["allowCombiningCriteriaIntoGroups"] = this.allowCombiningCriteriaIntoGroups;
        data["combinedSelectivityFieldName"] = this.combinedSelectivityFieldName;
        data["allowAnyNone"] = this.allowAnyNone;
        data["allowAnyNoneOriginalValue"] = this.allowAnyNoneOriginalValue;
        data["allow_Any_None_Enable"] = this.allow_Any_None_Enable;
        data["allow_Any_None_EnableOriginalValue"] = this.allow_Any_None_EnableOriginalValue;
        super.toJSON(data);
        return data;
    }
}

export interface IOlmField extends IKeyedItem {
    isMonthsRemainingField: boolean;
    isStepStoneMonthsRemainingField: boolean;
    isServicePackageCodesField: boolean;
    isLookInsideServicePackageCodesField: boolean;
    isDiscountTypeField: boolean;
    isActiveDiscountCodeField: boolean;
    isEquipmentStatusField: boolean;
    name?: string | undefined;
    length: number;
    lengthUserEntry?: string | undefined;
    isMultiEntry: boolean;
    isMultiEntry_OriginalValue: boolean;
    isStandaloneSelectivity: boolean;
    isStandaloneSelectivity_OriginalValue: boolean;
    documentType?: OlmDocumentType | undefined;
    dataType?: OlmDataType | undefined;
    usesRequiredValuesRelationship: boolean;
    isExternalSource: boolean;
    isExternalSource_OriginalValue: boolean;
    isSequenceRequired: boolean;
    lowValue?: number | undefined;
    highValue?: number | undefined;
    values?: OlmFieldValue[] | undefined;
    isCombinedSelectivityParentRecord: boolean;
    allowCombiningCriteriaIntoGroups: boolean;
    combinedSelectivityFieldName: CombinedSelectivityFieldNames;
    allowAnyNone: boolean;
    allowAnyNoneOriginalValue: boolean;
    allow_Any_None_Enable: boolean;
    allow_Any_None_EnableOriginalValue: boolean;
}

export class OlmDataType extends KeyedItem implements IOlmDataType {
    name?: string | undefined;
    type!: DataType;
    controlType?: string | undefined;
    isListControl!: boolean;
    operands?: OlmSelectivityOperand[] | undefined;

    constructor(data?: IOlmDataType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            this.controlType = _data["controlType"];
            this.isListControl = _data["isListControl"];
            if (Array.isArray(_data["operands"])) {
                this.operands = [] as any;
                for (let item of _data["operands"])
                    this.operands!.push(OlmSelectivityOperand.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): OlmDataType {
        data = typeof data === 'object' ? data : {};
        let result = new OlmDataType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        data["controlType"] = this.controlType;
        data["isListControl"] = this.isListControl;
        if (Array.isArray(this.operands)) {
            data["operands"] = [];
            for (let item of this.operands)
                data["operands"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IOlmDataType extends IKeyedItem {
    name?: string | undefined;
    type: DataType;
    controlType?: string | undefined;
    isListControl: boolean;
    operands?: OlmSelectivityOperand[] | undefined;
}

export enum DataType {
    Boolean = 0,
    Date = 1,
    Numeric = 2,
    Text = 4,
    Currency = 5,
}

export class OlmFieldValue extends KeyedItem implements IOlmFieldValue {
    olmFieldForeignKey?: number | undefined;
    code?: string | undefined;
    decode?: string | undefined;
    defaultValue?: string | undefined;

    constructor(data?: IOlmFieldValue) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.olmFieldForeignKey = _data["olmFieldForeignKey"];
            this.code = _data["code"];
            this.decode = _data["decode"];
            this.defaultValue = _data["defaultValue"];
        }
    }

    static override fromJS(data: any): OlmFieldValue {
        data = typeof data === 'object' ? data : {};
        let result = new OlmFieldValue();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["olmFieldForeignKey"] = this.olmFieldForeignKey;
        data["code"] = this.code;
        data["decode"] = this.decode;
        data["defaultValue"] = this.defaultValue;
        super.toJSON(data);
        return data;
    }
}

export interface IOlmFieldValue extends IKeyedItem {
    olmFieldForeignKey?: number | undefined;
    code?: string | undefined;
    decode?: string | undefined;
    defaultValue?: string | undefined;
}

export enum CombinedSelectivityFieldNames {
    None = 1,
    Active_Discount_Code = 2,
    Discount_Type = 4,
    Months_Remaining = 8,
    Service_Package_Codes = 16,
    Service_Package_Codes_Look_Inside_Pkg = 32,
    SS_Months_Remaining = 64,
    Unsupported_Selectivity_Field = 9223372036854775808,
}

export enum CombinatorialOperator {
    And = 65,
    Or = 79,
}

export class OlmSelectivityCriterionValue extends UpdatableItem implements IOlmSelectivityCriterionValue {
    selectivityProfileDetailForeignKey?: number | undefined;
    sequence!: number;
    value?: string | undefined;

    constructor(data?: IOlmSelectivityCriterionValue) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.selectivityProfileDetailForeignKey = _data["selectivityProfileDetailForeignKey"];
            this.sequence = _data["sequence"];
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): OlmSelectivityCriterionValue {
        data = typeof data === 'object' ? data : {};
        let result = new OlmSelectivityCriterionValue();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selectivityProfileDetailForeignKey"] = this.selectivityProfileDetailForeignKey;
        data["sequence"] = this.sequence;
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IOlmSelectivityCriterionValue extends IUpdatableItem {
    selectivityProfileDetailForeignKey?: number | undefined;
    sequence: number;
    value?: string | undefined;
}

export class OlmLocation extends UpdatableItem implements IOlmLocation {
    pageType?: OlmPageType | undefined;
    name?: string | undefined;
    height!: number;
    heightUserEntry?: string | undefined;
    width!: number;
    widthUserEntry?: string | undefined;
    maxGraphicHeight?: number | undefined;
    maxGraphicHeightUserEntry?: string | undefined;
    maxGraphicWidth?: number | undefined;
    maxGraphicWidthUserEntry?: string | undefined;
    offsetTop!: number;
    offsetTopUserEntry?: string | undefined;
    offsetLeft!: number;
    offsetLeftUserEntry?: string | undefined;
    overflowLocation?: OlmLocation | undefined;
    overflowLocationForeignKey?: number | undefined;
    isOverflowLocationAllowed!: boolean;
    isOverflowLocationRequired!: boolean;
    locationType?: OlmLocationType | undefined;
    locationId?: string | undefined;
    lineSpacingBetweenMessages!: number;
    lineSpacingAfterTransactions?: number | undefined;
    linesPerInch!: number;
    linesPerInchUserEntry?: string | undefined;
    previewOffset!: number;
    previewOffsetUserEntry?: string | undefined;
    graphicPath?: string | undefined;
    allowedGraphicPositions?: OlmLocationGraphicPosition[] | undefined;
    canUseGraphics!: boolean;
    canUseTextWrappingAroundGraphics!: boolean;
    allowOverflowToLocationsThatDoNotSupportTheSameGraphicPositions!: boolean;
    allowsBackgroundShading!: boolean;
    messageRequirementRestriction!: RequirementRestriction;
    allowOverflowToLocationsThatDoNotSupportTheSameMessageRequirementRestrictions!: boolean;
    excludeFromMultiMessagePreview!: boolean;
    canMessagesInThisLocationBePreviewedAlone!: boolean;
    canMessagesInThisLocationBePreviewedWithOtherMessages!: boolean;
    isSecureLocation!: boolean;
    isMultiChannel!: boolean;

    constructor(data?: IOlmLocation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pageType = _data["pageType"] ? OlmPageType.fromJS(_data["pageType"]) : <any>undefined;
            this.name = _data["name"];
            this.height = _data["height"];
            this.heightUserEntry = _data["heightUserEntry"];
            this.width = _data["width"];
            this.widthUserEntry = _data["widthUserEntry"];
            this.maxGraphicHeight = _data["maxGraphicHeight"];
            this.maxGraphicHeightUserEntry = _data["maxGraphicHeightUserEntry"];
            this.maxGraphicWidth = _data["maxGraphicWidth"];
            this.maxGraphicWidthUserEntry = _data["maxGraphicWidthUserEntry"];
            this.offsetTop = _data["offsetTop"];
            this.offsetTopUserEntry = _data["offsetTopUserEntry"];
            this.offsetLeft = _data["offsetLeft"];
            this.offsetLeftUserEntry = _data["offsetLeftUserEntry"];
            this.overflowLocation = _data["overflowLocation"] ? OlmLocation.fromJS(_data["overflowLocation"]) : <any>undefined;
            this.overflowLocationForeignKey = _data["overflowLocationForeignKey"];
            this.isOverflowLocationAllowed = _data["isOverflowLocationAllowed"];
            this.isOverflowLocationRequired = _data["isOverflowLocationRequired"];
            this.locationType = _data["locationType"] ? OlmLocationType.fromJS(_data["locationType"]) : <any>undefined;
            this.locationId = _data["locationId"];
            this.lineSpacingBetweenMessages = _data["lineSpacingBetweenMessages"];
            this.lineSpacingAfterTransactions = _data["lineSpacingAfterTransactions"];
            this.linesPerInch = _data["linesPerInch"];
            this.linesPerInchUserEntry = _data["linesPerInchUserEntry"];
            this.previewOffset = _data["previewOffset"];
            this.previewOffsetUserEntry = _data["previewOffsetUserEntry"];
            this.graphicPath = _data["graphicPath"];
            if (Array.isArray(_data["allowedGraphicPositions"])) {
                this.allowedGraphicPositions = [] as any;
                for (let item of _data["allowedGraphicPositions"])
                    this.allowedGraphicPositions!.push(OlmLocationGraphicPosition.fromJS(item));
            }
            this.canUseGraphics = _data["canUseGraphics"];
            this.canUseTextWrappingAroundGraphics = _data["canUseTextWrappingAroundGraphics"];
            this.allowOverflowToLocationsThatDoNotSupportTheSameGraphicPositions = _data["allowOverflowToLocationsThatDoNotSupportTheSameGraphicPositions"];
            this.allowsBackgroundShading = _data["allowsBackgroundShading"];
            this.messageRequirementRestriction = _data["messageRequirementRestriction"];
            this.allowOverflowToLocationsThatDoNotSupportTheSameMessageRequirementRestrictions = _data["allowOverflowToLocationsThatDoNotSupportTheSameMessageRequirementRestrictions"];
            this.excludeFromMultiMessagePreview = _data["excludeFromMultiMessagePreview"];
            this.canMessagesInThisLocationBePreviewedAlone = _data["canMessagesInThisLocationBePreviewedAlone"];
            this.canMessagesInThisLocationBePreviewedWithOtherMessages = _data["canMessagesInThisLocationBePreviewedWithOtherMessages"];
            this.isSecureLocation = _data["isSecureLocation"];
            this.isMultiChannel = _data["isMultiChannel"];
        }
    }

    static override fromJS(data: any): OlmLocation {
        data = typeof data === 'object' ? data : {};
        let result = new OlmLocation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageType"] = this.pageType ? this.pageType.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["height"] = this.height;
        data["heightUserEntry"] = this.heightUserEntry;
        data["width"] = this.width;
        data["widthUserEntry"] = this.widthUserEntry;
        data["maxGraphicHeight"] = this.maxGraphicHeight;
        data["maxGraphicHeightUserEntry"] = this.maxGraphicHeightUserEntry;
        data["maxGraphicWidth"] = this.maxGraphicWidth;
        data["maxGraphicWidthUserEntry"] = this.maxGraphicWidthUserEntry;
        data["offsetTop"] = this.offsetTop;
        data["offsetTopUserEntry"] = this.offsetTopUserEntry;
        data["offsetLeft"] = this.offsetLeft;
        data["offsetLeftUserEntry"] = this.offsetLeftUserEntry;
        data["overflowLocation"] = this.overflowLocation ? this.overflowLocation.toJSON() : <any>undefined;
        data["overflowLocationForeignKey"] = this.overflowLocationForeignKey;
        data["isOverflowLocationAllowed"] = this.isOverflowLocationAllowed;
        data["isOverflowLocationRequired"] = this.isOverflowLocationRequired;
        data["locationType"] = this.locationType ? this.locationType.toJSON() : <any>undefined;
        data["locationId"] = this.locationId;
        data["lineSpacingBetweenMessages"] = this.lineSpacingBetweenMessages;
        data["lineSpacingAfterTransactions"] = this.lineSpacingAfterTransactions;
        data["linesPerInch"] = this.linesPerInch;
        data["linesPerInchUserEntry"] = this.linesPerInchUserEntry;
        data["previewOffset"] = this.previewOffset;
        data["previewOffsetUserEntry"] = this.previewOffsetUserEntry;
        data["graphicPath"] = this.graphicPath;
        if (Array.isArray(this.allowedGraphicPositions)) {
            data["allowedGraphicPositions"] = [];
            for (let item of this.allowedGraphicPositions)
                data["allowedGraphicPositions"].push(item.toJSON());
        }
        data["canUseGraphics"] = this.canUseGraphics;
        data["canUseTextWrappingAroundGraphics"] = this.canUseTextWrappingAroundGraphics;
        data["allowOverflowToLocationsThatDoNotSupportTheSameGraphicPositions"] = this.allowOverflowToLocationsThatDoNotSupportTheSameGraphicPositions;
        data["allowsBackgroundShading"] = this.allowsBackgroundShading;
        data["messageRequirementRestriction"] = this.messageRequirementRestriction;
        data["allowOverflowToLocationsThatDoNotSupportTheSameMessageRequirementRestrictions"] = this.allowOverflowToLocationsThatDoNotSupportTheSameMessageRequirementRestrictions;
        data["excludeFromMultiMessagePreview"] = this.excludeFromMultiMessagePreview;
        data["canMessagesInThisLocationBePreviewedAlone"] = this.canMessagesInThisLocationBePreviewedAlone;
        data["canMessagesInThisLocationBePreviewedWithOtherMessages"] = this.canMessagesInThisLocationBePreviewedWithOtherMessages;
        data["isSecureLocation"] = this.isSecureLocation;
        data["isMultiChannel"] = this.isMultiChannel;
        super.toJSON(data);
        return data;
    }
}

export interface IOlmLocation extends IUpdatableItem {
    pageType?: OlmPageType | undefined;
    name?: string | undefined;
    height: number;
    heightUserEntry?: string | undefined;
    width: number;
    widthUserEntry?: string | undefined;
    maxGraphicHeight?: number | undefined;
    maxGraphicHeightUserEntry?: string | undefined;
    maxGraphicWidth?: number | undefined;
    maxGraphicWidthUserEntry?: string | undefined;
    offsetTop: number;
    offsetTopUserEntry?: string | undefined;
    offsetLeft: number;
    offsetLeftUserEntry?: string | undefined;
    overflowLocation?: OlmLocation | undefined;
    overflowLocationForeignKey?: number | undefined;
    isOverflowLocationAllowed: boolean;
    isOverflowLocationRequired: boolean;
    locationType?: OlmLocationType | undefined;
    locationId?: string | undefined;
    lineSpacingBetweenMessages: number;
    lineSpacingAfterTransactions?: number | undefined;
    linesPerInch: number;
    linesPerInchUserEntry?: string | undefined;
    previewOffset: number;
    previewOffsetUserEntry?: string | undefined;
    graphicPath?: string | undefined;
    allowedGraphicPositions?: OlmLocationGraphicPosition[] | undefined;
    canUseGraphics: boolean;
    canUseTextWrappingAroundGraphics: boolean;
    allowOverflowToLocationsThatDoNotSupportTheSameGraphicPositions: boolean;
    allowsBackgroundShading: boolean;
    messageRequirementRestriction: RequirementRestriction;
    allowOverflowToLocationsThatDoNotSupportTheSameMessageRequirementRestrictions: boolean;
    excludeFromMultiMessagePreview: boolean;
    canMessagesInThisLocationBePreviewedAlone: boolean;
    canMessagesInThisLocationBePreviewedWithOtherMessages: boolean;
    isSecureLocation: boolean;
    isMultiChannel: boolean;
}

export class OlmMessageDetail extends UpdatableItem implements IOlmMessageDetail {
    messageMasterForeignKey?: number | undefined;
    payloads?: OlmMessagePayload[] | undefined;
    isPrimaryLanguage!: boolean;
    language?: string | undefined;
    hasGraphic!: boolean;
    graphicNumber?: string | undefined;
    wrapText!: boolean;
    has_Repeating_Vars!: boolean;
    graphicPosition?: GraphicPosition | undefined;
    graphicPositionText?: string | undefined;
    text?: string | undefined;
    plainText?: string | undefined;
    hasText!: boolean;
    replacementVariablesNamesInText?: string[] | undefined;
    fontNamesUsedInText?: string[] | undefined;
    fontSizesUsedInText?: string[] | undefined;
    fontColorsUsedInText?: string[] | undefined;

    constructor(data?: IOlmMessageDetail) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.messageMasterForeignKey = _data["messageMasterForeignKey"];
            if (Array.isArray(_data["payloads"])) {
                this.payloads = [] as any;
                for (let item of _data["payloads"])
                    this.payloads!.push(OlmMessagePayload.fromJS(item));
            }
            this.isPrimaryLanguage = _data["isPrimaryLanguage"];
            this.language = _data["language"];
            this.hasGraphic = _data["hasGraphic"];
            this.graphicNumber = _data["graphicNumber"];
            this.wrapText = _data["wrapText"];
            this.has_Repeating_Vars = _data["has_Repeating_Vars"];
            this.graphicPosition = _data["graphicPosition"];
            this.graphicPositionText = _data["graphicPositionText"];
            this.text = _data["text"];
            this.plainText = _data["plainText"];
            this.hasText = _data["hasText"];
            if (Array.isArray(_data["replacementVariablesNamesInText"])) {
                this.replacementVariablesNamesInText = [] as any;
                for (let item of _data["replacementVariablesNamesInText"])
                    this.replacementVariablesNamesInText!.push(item);
            }
            if (Array.isArray(_data["fontNamesUsedInText"])) {
                this.fontNamesUsedInText = [] as any;
                for (let item of _data["fontNamesUsedInText"])
                    this.fontNamesUsedInText!.push(item);
            }
            if (Array.isArray(_data["fontSizesUsedInText"])) {
                this.fontSizesUsedInText = [] as any;
                for (let item of _data["fontSizesUsedInText"])
                    this.fontSizesUsedInText!.push(item);
            }
            if (Array.isArray(_data["fontColorsUsedInText"])) {
                this.fontColorsUsedInText = [] as any;
                for (let item of _data["fontColorsUsedInText"])
                    this.fontColorsUsedInText!.push(item);
            }
        }
    }

    static override fromJS(data: any): OlmMessageDetail {
        data = typeof data === 'object' ? data : {};
        let result = new OlmMessageDetail();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageMasterForeignKey"] = this.messageMasterForeignKey;
        if (Array.isArray(this.payloads)) {
            data["payloads"] = [];
            for (let item of this.payloads)
                data["payloads"].push(item.toJSON());
        }
        data["isPrimaryLanguage"] = this.isPrimaryLanguage;
        data["language"] = this.language;
        data["hasGraphic"] = this.hasGraphic;
        data["graphicNumber"] = this.graphicNumber;
        data["wrapText"] = this.wrapText;
        data["has_Repeating_Vars"] = this.has_Repeating_Vars;
        data["graphicPosition"] = this.graphicPosition;
        data["graphicPositionText"] = this.graphicPositionText;
        data["text"] = this.text;
        data["plainText"] = this.plainText;
        data["hasText"] = this.hasText;
        if (Array.isArray(this.replacementVariablesNamesInText)) {
            data["replacementVariablesNamesInText"] = [];
            for (let item of this.replacementVariablesNamesInText)
                data["replacementVariablesNamesInText"].push(item);
        }
        if (Array.isArray(this.fontNamesUsedInText)) {
            data["fontNamesUsedInText"] = [];
            for (let item of this.fontNamesUsedInText)
                data["fontNamesUsedInText"].push(item);
        }
        if (Array.isArray(this.fontSizesUsedInText)) {
            data["fontSizesUsedInText"] = [];
            for (let item of this.fontSizesUsedInText)
                data["fontSizesUsedInText"].push(item);
        }
        if (Array.isArray(this.fontColorsUsedInText)) {
            data["fontColorsUsedInText"] = [];
            for (let item of this.fontColorsUsedInText)
                data["fontColorsUsedInText"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IOlmMessageDetail extends IUpdatableItem {
    messageMasterForeignKey?: number | undefined;
    payloads?: OlmMessagePayload[] | undefined;
    isPrimaryLanguage: boolean;
    language?: string | undefined;
    hasGraphic: boolean;
    graphicNumber?: string | undefined;
    wrapText: boolean;
    has_Repeating_Vars: boolean;
    graphicPosition?: GraphicPosition | undefined;
    graphicPositionText?: string | undefined;
    text?: string | undefined;
    plainText?: string | undefined;
    hasText: boolean;
    replacementVariablesNamesInText?: string[] | undefined;
    fontNamesUsedInText?: string[] | undefined;
    fontSizesUsedInText?: string[] | undefined;
    fontColorsUsedInText?: string[] | undefined;
}

export class OlmMessagePayload extends KeyedItem implements IOlmMessagePayload {
    messageDetailForeignKey?: number | undefined;
    variableName?: string | undefined;
    variableType!: OlmMessageVariableType;
    choice1?: string | undefined;
    choice2?: string | undefined;

    constructor(data?: IOlmMessagePayload) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.messageDetailForeignKey = _data["messageDetailForeignKey"];
            this.variableName = _data["variableName"];
            this.variableType = _data["variableType"];
            this.choice1 = _data["choice1"];
            this.choice2 = _data["choice2"];
        }
    }

    static override fromJS(data: any): OlmMessagePayload {
        data = typeof data === 'object' ? data : {};
        let result = new OlmMessagePayload();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageDetailForeignKey"] = this.messageDetailForeignKey;
        data["variableName"] = this.variableName;
        data["variableType"] = this.variableType;
        data["choice1"] = this.choice1;
        data["choice2"] = this.choice2;
        super.toJSON(data);
        return data;
    }
}

export interface IOlmMessagePayload extends IKeyedItem {
    messageDetailForeignKey?: number | undefined;
    variableName?: string | undefined;
    variableType: OlmMessageVariableType;
    choice1?: string | undefined;
    choice2?: string | undefined;
}

export enum OlmMessageVariableType {
    ReplacementVariable = 0,
}

export class DictionaryEntry implements IDictionaryEntry {
    key!: any;
    value?: any | undefined;

    constructor(data?: IDictionaryEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): DictionaryEntry {
        data = typeof data === 'object' ? data : {};
        let result = new DictionaryEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IDictionaryEntry {
    key: any;
    value?: any | undefined;
}

export class ChangeHistoryItem extends KeyedItem implements IChangeHistoryItem {
    itemPrimaryKey!: number;
    databaseTable?: string | undefined;
    databaseColumn?: string | undefined;
    fieldName?: string | undefined;
    action!: ChangeHistoryAction;
    previousValue?: string | undefined;
    newValue?: string | undefined;
    updated!: Date;
    userId?: string | undefined;

    constructor(data?: IChangeHistoryItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.itemPrimaryKey = _data["itemPrimaryKey"];
            this.databaseTable = _data["databaseTable"];
            this.databaseColumn = _data["databaseColumn"];
            this.fieldName = _data["fieldName"];
            this.action = _data["action"];
            this.previousValue = _data["previousValue"];
            this.newValue = _data["newValue"];
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
            this.userId = _data["userId"];
        }
    }

    static override fromJS(data: any): ChangeHistoryItem {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeHistoryItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemPrimaryKey"] = this.itemPrimaryKey;
        data["databaseTable"] = this.databaseTable;
        data["databaseColumn"] = this.databaseColumn;
        data["fieldName"] = this.fieldName;
        data["action"] = this.action;
        data["previousValue"] = this.previousValue;
        data["newValue"] = this.newValue;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        super.toJSON(data);
        return data;
    }
}

export interface IChangeHistoryItem extends IKeyedItem {
    itemPrimaryKey: number;
    databaseTable?: string | undefined;
    databaseColumn?: string | undefined;
    fieldName?: string | undefined;
    action: ChangeHistoryAction;
    previousValue?: string | undefined;
    newValue?: string | undefined;
    updated: Date;
    userId?: string | undefined;
}

export enum ChangeHistoryAction {
    Unknown = 0,
    Added = 1,
    Changed = 2,
    Removed = 3,
}

export class SecondaryMessageInfoForLinking implements ISecondaryMessageInfoForLinking {
    secondaryMessagePrimaryKey!: number;
    linkedPrimaryMessageForeignKeys?: number[] | undefined;
    isLinkedToOneOrMorePrimaryMessages!: boolean;
    messageDescription?: string | undefined;
    messageId?: string | undefined;
    messageType?: string | undefined;
    locationId?: string | undefined;
    locationName?: string | undefined;
    rank?: number | undefined;
    status?: string | undefined;
    beginDate!: Date;
    endDate?: Date | undefined;
    assignedSysPrins?: SysPrin[] | undefined;

    constructor(data?: ISecondaryMessageInfoForLinking) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secondaryMessagePrimaryKey = _data["secondaryMessagePrimaryKey"];
            if (Array.isArray(_data["linkedPrimaryMessageForeignKeys"])) {
                this.linkedPrimaryMessageForeignKeys = [] as any;
                for (let item of _data["linkedPrimaryMessageForeignKeys"])
                    this.linkedPrimaryMessageForeignKeys!.push(item);
            }
            this.isLinkedToOneOrMorePrimaryMessages = _data["isLinkedToOneOrMorePrimaryMessages"];
            this.messageDescription = _data["messageDescription"];
            this.messageId = _data["messageId"];
            this.messageType = _data["messageType"];
            this.locationId = _data["locationId"];
            this.locationName = _data["locationName"];
            this.rank = _data["rank"];
            this.status = _data["status"];
            this.beginDate = _data["beginDate"] ? new Date(_data["beginDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["assignedSysPrins"])) {
                this.assignedSysPrins = [] as any;
                for (let item of _data["assignedSysPrins"])
                    this.assignedSysPrins!.push(SysPrin.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SecondaryMessageInfoForLinking {
        data = typeof data === 'object' ? data : {};
        let result = new SecondaryMessageInfoForLinking();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secondaryMessagePrimaryKey"] = this.secondaryMessagePrimaryKey;
        if (Array.isArray(this.linkedPrimaryMessageForeignKeys)) {
            data["linkedPrimaryMessageForeignKeys"] = [];
            for (let item of this.linkedPrimaryMessageForeignKeys)
                data["linkedPrimaryMessageForeignKeys"].push(item);
        }
        data["isLinkedToOneOrMorePrimaryMessages"] = this.isLinkedToOneOrMorePrimaryMessages;
        data["messageDescription"] = this.messageDescription;
        data["messageId"] = this.messageId;
        data["messageType"] = this.messageType;
        data["locationId"] = this.locationId;
        data["locationName"] = this.locationName;
        data["rank"] = this.rank;
        data["status"] = this.status;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.assignedSysPrins)) {
            data["assignedSysPrins"] = [];
            for (let item of this.assignedSysPrins)
                data["assignedSysPrins"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISecondaryMessageInfoForLinking {
    secondaryMessagePrimaryKey: number;
    linkedPrimaryMessageForeignKeys?: number[] | undefined;
    isLinkedToOneOrMorePrimaryMessages: boolean;
    messageDescription?: string | undefined;
    messageId?: string | undefined;
    messageType?: string | undefined;
    locationId?: string | undefined;
    locationName?: string | undefined;
    rank?: number | undefined;
    status?: string | undefined;
    beginDate: Date;
    endDate?: Date | undefined;
    assignedSysPrins?: SysPrin[] | undefined;
}

export class OlmLinkedMessageDataRow implements IOlmLinkedMessageDataRow {
    primaryKey?: number | undefined;
    rank?: number | undefined;
    messageDescription?: string | undefined;
    locationName?: string | undefined;
    status?: string | undefined;
    messageType?: string | undefined;

    constructor(data?: IOlmLinkedMessageDataRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primaryKey = _data["primaryKey"];
            this.rank = _data["rank"];
            this.messageDescription = _data["messageDescription"];
            this.locationName = _data["locationName"];
            this.status = _data["status"];
            this.messageType = _data["messageType"];
        }
    }

    static fromJS(data: any): OlmLinkedMessageDataRow {
        data = typeof data === 'object' ? data : {};
        let result = new OlmLinkedMessageDataRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primaryKey"] = this.primaryKey;
        data["rank"] = this.rank;
        data["messageDescription"] = this.messageDescription;
        data["locationName"] = this.locationName;
        data["status"] = this.status;
        data["messageType"] = this.messageType;
        return data;
    }
}

export interface IOlmLinkedMessageDataRow {
    primaryKey?: number | undefined;
    rank?: number | undefined;
    messageDescription?: string | undefined;
    locationName?: string | undefined;
    status?: string | undefined;
    messageType?: string | undefined;
}

export class GetDepartmentsResponse implements IGetDepartmentsResponse {
    departments!: DepartmentDto[];

    constructor(data?: IGetDepartmentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.departments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["departments"])) {
                this.departments = [] as any;
                for (let item of _data["departments"])
                    this.departments!.push(DepartmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDepartmentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDepartmentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.departments)) {
            data["departments"] = [];
            for (let item of this.departments)
                data["departments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDepartmentsResponse {
    departments: DepartmentDto[];
}

export class DepartmentDto implements IDepartmentDto {
    primaryKey!: string;
    name!: string;

    constructor(data?: IDepartmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primaryKey = _data["primaryKey"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): DepartmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primaryKey"] = this.primaryKey;
        data["name"] = this.name;
        return data;
    }
}

export interface IDepartmentDto {
    primaryKey: string;
    name: string;
}

export class CreateDepartmentRequest implements ICreateDepartmentRequest {
    departmentName!: string;
    docTypePrimaryKey!: number;

    constructor(data?: ICreateDepartmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departmentName = _data["departmentName"];
            this.docTypePrimaryKey = _data["docTypePrimaryKey"];
        }
    }

    static fromJS(data: any): CreateDepartmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDepartmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departmentName"] = this.departmentName;
        data["docTypePrimaryKey"] = this.docTypePrimaryKey;
        return data;
    }
}

export interface ICreateDepartmentRequest {
    departmentName: string;
    docTypePrimaryKey: number;
}

export class UpdateDepartmentRequest implements IUpdateDepartmentRequest {
    department!: DepartmentDto;
    docTypePrimaryKey!: number;

    constructor(data?: IUpdateDepartmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.department = new DepartmentDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.department = _data["department"] ? DepartmentDto.fromJS(_data["department"]) : new DepartmentDto();
            this.docTypePrimaryKey = _data["docTypePrimaryKey"];
        }
    }

    static fromJS(data: any): UpdateDepartmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDepartmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["department"] = this.department ? this.department.toJSON() : <any>undefined;
        data["docTypePrimaryKey"] = this.docTypePrimaryKey;
        return data;
    }
}

export interface IUpdateDepartmentRequest {
    department: DepartmentDto;
    docTypePrimaryKey: number;
}

export class DeleteDepartmentRequest implements IDeleteDepartmentRequest {
    departmentPrimaryKey!: string;
    docTypePrimaryKey!: number;

    constructor(data?: IDeleteDepartmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departmentPrimaryKey = _data["departmentPrimaryKey"];
            this.docTypePrimaryKey = _data["docTypePrimaryKey"];
        }
    }

    static fromJS(data: any): DeleteDepartmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteDepartmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departmentPrimaryKey"] = this.departmentPrimaryKey;
        data["docTypePrimaryKey"] = this.docTypePrimaryKey;
        return data;
    }
}

export interface IDeleteDepartmentRequest {
    departmentPrimaryKey: string;
    docTypePrimaryKey: number;
}

export class GetLanguagesResponse implements IGetLanguagesResponse {
    languages!: LanguageDto[];

    constructor(data?: IGetLanguagesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.languages = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(LanguageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguagesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLanguagesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetLanguagesResponse {
    languages: LanguageDto[];
}

export class LanguageDto implements ILanguageDto {
    name!: string;
    sysPrin!: SysPrinDto;

    constructor(data?: ILanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sysPrin = new SysPrinDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.sysPrin = _data["sysPrin"] ? SysPrinDto.fromJS(_data["sysPrin"]) : new SysPrinDto();
        }
    }

    static fromJS(data: any): LanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["sysPrin"] = this.sysPrin ? this.sysPrin.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILanguageDto {
    name: string;
    sysPrin: SysPrinDto;
}

export class GetLanguagesRequest implements IGetLanguagesRequest {
    sysPrins!: SysPrinDto[];

    constructor(data?: IGetLanguagesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sysPrins = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sysPrins"])) {
                this.sysPrins = [] as any;
                for (let item of _data["sysPrins"])
                    this.sysPrins!.push(SysPrinDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguagesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetLanguagesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sysPrins)) {
            data["sysPrins"] = [];
            for (let item of this.sysPrins)
                data["sysPrins"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetLanguagesRequest {
    sysPrins: SysPrinDto[];
}

export class GetMessageDetailsResponse implements IGetMessageDetailsResponse {
    messageDetails!: OlmMessage;
    permissions!: OlmMessagePermissions;
    errors?: ErrorModel[] | undefined;

    constructor(data?: IGetMessageDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messageDetails = new OlmMessage();
            this.permissions = new OlmMessagePermissions();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageDetails = _data["messageDetails"] ? OlmMessage.fromJS(_data["messageDetails"]) : new OlmMessage();
            this.permissions = _data["permissions"] ? OlmMessagePermissions.fromJS(_data["permissions"]) : new OlmMessagePermissions();
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMessageDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMessageDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageDetails"] = this.messageDetails ? this.messageDetails.toJSON() : <any>undefined;
        data["permissions"] = this.permissions ? this.permissions.toJSON() : <any>undefined;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMessageDetailsResponse {
    messageDetails: OlmMessage;
    permissions: OlmMessagePermissions;
    errors?: ErrorModel[] | undefined;
}

export class OlmMessagePermissions implements IOlmMessagePermissions {
    canUserViewThisMessage!: boolean;
    canUserModifyThisMessage!: boolean;
    canUserApproveThisMessage!: boolean;
    canUserModifyStatusToPending!: boolean;
    canUserModifyStatusToDraft!: boolean;
    canUserDeleteThisMessage!: boolean;
    canUserRestoreThisMessageFromTheTrash!: boolean;
    canUserModifyRank!: boolean;

    constructor(data?: IOlmMessagePermissions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canUserViewThisMessage = _data["canUserViewThisMessage"];
            this.canUserModifyThisMessage = _data["canUserModifyThisMessage"];
            this.canUserApproveThisMessage = _data["canUserApproveThisMessage"];
            this.canUserModifyStatusToPending = _data["canUserModifyStatusToPending"];
            this.canUserModifyStatusToDraft = _data["canUserModifyStatusToDraft"];
            this.canUserDeleteThisMessage = _data["canUserDeleteThisMessage"];
            this.canUserRestoreThisMessageFromTheTrash = _data["canUserRestoreThisMessageFromTheTrash"];
            this.canUserModifyRank = _data["canUserModifyRank"];
        }
    }

    static fromJS(data: any): OlmMessagePermissions {
        data = typeof data === 'object' ? data : {};
        let result = new OlmMessagePermissions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canUserViewThisMessage"] = this.canUserViewThisMessage;
        data["canUserModifyThisMessage"] = this.canUserModifyThisMessage;
        data["canUserApproveThisMessage"] = this.canUserApproveThisMessage;
        data["canUserModifyStatusToPending"] = this.canUserModifyStatusToPending;
        data["canUserModifyStatusToDraft"] = this.canUserModifyStatusToDraft;
        data["canUserDeleteThisMessage"] = this.canUserDeleteThisMessage;
        data["canUserRestoreThisMessageFromTheTrash"] = this.canUserRestoreThisMessageFromTheTrash;
        data["canUserModifyRank"] = this.canUserModifyRank;
        return data;
    }
}

export interface IOlmMessagePermissions {
    canUserViewThisMessage: boolean;
    canUserModifyThisMessage: boolean;
    canUserApproveThisMessage: boolean;
    canUserModifyStatusToPending: boolean;
    canUserModifyStatusToDraft: boolean;
    canUserDeleteThisMessage: boolean;
    canUserRestoreThisMessageFromTheTrash: boolean;
    canUserModifyRank: boolean;
}

export class ErrorModel implements IErrorModel {
    messageId!: number;
    field?: string | undefined;
    errorMsg!: string;

    constructor(data?: IErrorModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageId = _data["messageId"];
            this.field = _data["field"];
            this.errorMsg = _data["errorMsg"];
        }
    }

    static fromJS(data: any): ErrorModel {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageId"] = this.messageId;
        data["field"] = this.field;
        data["errorMsg"] = this.errorMsg;
        return data;
    }
}

export interface IErrorModel {
    messageId: number;
    field?: string | undefined;
    errorMsg: string;
}

export class GetMessageDetailsRequest implements IGetMessageDetailsRequest {
    messageId!: number;

    constructor(data?: IGetMessageDetailsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageId = _data["messageId"];
        }
    }

    static fromJS(data: any): GetMessageDetailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMessageDetailsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageId"] = this.messageId;
        return data;
    }
}

export interface IGetMessageDetailsRequest {
    messageId: number;
}

export class DoesMessageExistResponse implements IDoesMessageExistResponse {
    messageExists!: boolean;

    constructor(data?: IDoesMessageExistResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageExists = _data["messageExists"];
        }
    }

    static fromJS(data: any): DoesMessageExistResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DoesMessageExistResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageExists"] = this.messageExists;
        return data;
    }
}

export interface IDoesMessageExistResponse {
    messageExists: boolean;
}

export class DoesMessageExistRequest implements IDoesMessageExistRequest {
    messageId!: number;

    constructor(data?: IDoesMessageExistRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageId = _data["messageId"];
        }
    }

    static fromJS(data: any): DoesMessageExistRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DoesMessageExistRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageId"] = this.messageId;
        return data;
    }
}

export interface IDoesMessageExistRequest {
    messageId: number;
}

export class DeleteMessagesRequest implements IDeleteMessagesRequest {
    messageIds!: number[];

    constructor(data?: IDeleteMessagesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messageIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messageIds"])) {
                this.messageIds = [] as any;
                for (let item of _data["messageIds"])
                    this.messageIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteMessagesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMessagesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messageIds)) {
            data["messageIds"] = [];
            for (let item of this.messageIds)
                data["messageIds"].push(item);
        }
        return data;
    }
}

export interface IDeleteMessagesRequest {
    messageIds: number[];
}

export class MoveMessagesToTrashRequest implements IMoveMessagesToTrashRequest {
    messageUniqueIds!: number[];
    docTypeUniqueId!: number;

    constructor(data?: IMoveMessagesToTrashRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messageUniqueIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messageUniqueIds"])) {
                this.messageUniqueIds = [] as any;
                for (let item of _data["messageUniqueIds"])
                    this.messageUniqueIds!.push(item);
            }
            this.docTypeUniqueId = _data["docTypeUniqueId"];
        }
    }

    static fromJS(data: any): MoveMessagesToTrashRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MoveMessagesToTrashRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messageUniqueIds)) {
            data["messageUniqueIds"] = [];
            for (let item of this.messageUniqueIds)
                data["messageUniqueIds"].push(item);
        }
        data["docTypeUniqueId"] = this.docTypeUniqueId;
        return data;
    }
}

export interface IMoveMessagesToTrashRequest {
    messageUniqueIds: number[];
    docTypeUniqueId: number;
}

export class CreateMessageCopiesRequest implements ICreateMessageCopiesRequest {
    sourceSysPrins!: SysPrinDto;
    targetSysPrins!: SysPrinDto[];
    copyParms!: CopyParmsDto[];
    targetDBName!: string;
    docTypePrimaryKey!: number;
    copyRanks!: boolean;

    constructor(data?: ICreateMessageCopiesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sourceSysPrins = new SysPrinDto();
            this.targetSysPrins = [];
            this.copyParms = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceSysPrins = _data["sourceSysPrins"] ? SysPrinDto.fromJS(_data["sourceSysPrins"]) : new SysPrinDto();
            if (Array.isArray(_data["targetSysPrins"])) {
                this.targetSysPrins = [] as any;
                for (let item of _data["targetSysPrins"])
                    this.targetSysPrins!.push(SysPrinDto.fromJS(item));
            }
            if (Array.isArray(_data["copyParms"])) {
                this.copyParms = [] as any;
                for (let item of _data["copyParms"])
                    this.copyParms!.push(CopyParmsDto.fromJS(item));
            }
            this.targetDBName = _data["targetDBName"];
            this.docTypePrimaryKey = _data["docTypePrimaryKey"];
            this.copyRanks = _data["copyRanks"];
        }
    }

    static fromJS(data: any): CreateMessageCopiesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMessageCopiesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceSysPrins"] = this.sourceSysPrins ? this.sourceSysPrins.toJSON() : <any>undefined;
        if (Array.isArray(this.targetSysPrins)) {
            data["targetSysPrins"] = [];
            for (let item of this.targetSysPrins)
                data["targetSysPrins"].push(item.toJSON());
        }
        if (Array.isArray(this.copyParms)) {
            data["copyParms"] = [];
            for (let item of this.copyParms)
                data["copyParms"].push(item.toJSON());
        }
        data["targetDBName"] = this.targetDBName;
        data["docTypePrimaryKey"] = this.docTypePrimaryKey;
        data["copyRanks"] = this.copyRanks;
        return data;
    }
}

export interface ICreateMessageCopiesRequest {
    sourceSysPrins: SysPrinDto;
    targetSysPrins: SysPrinDto[];
    copyParms: CopyParmsDto[];
    targetDBName: string;
    docTypePrimaryKey: number;
    copyRanks: boolean;
}

export class CopyParmsDto implements ICopyParmsDto {
    uniqueId!: number;
    numCopies!: number;
    selectivityOption!: OlmMessageCopySelectivityOption;
    oneMessageMultiSysprinCopy!: boolean;

    constructor(data?: ICopyParmsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.numCopies = _data["numCopies"];
            this.selectivityOption = _data["selectivityOption"];
            this.oneMessageMultiSysprinCopy = _data["oneMessageMultiSysprinCopy"];
        }
    }

    static fromJS(data: any): CopyParmsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CopyParmsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["numCopies"] = this.numCopies;
        data["selectivityOption"] = this.selectivityOption;
        data["oneMessageMultiSysprinCopy"] = this.oneMessageMultiSysprinCopy;
        return data;
    }
}

export interface ICopyParmsDto {
    uniqueId: number;
    numCopies: number;
    selectivityOption: OlmMessageCopySelectivityOption;
    oneMessageMultiSysprinCopy: boolean;
}

export enum OlmMessageCopySelectivityOption {
    CopyMessageAndSelectivityProfile = 0,
    CopyMessageAndUseExistingSelectivityProfile = 1,
    CopyMessageWithoutSelectivityProfile = 2,
}

export class EmailCopyMessageErrorsRequest implements IEmailCopyMessageErrorsRequest {
    errors!: string[];

    constructor(data?: IEmailCopyMessageErrorsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): EmailCopyMessageErrorsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EmailCopyMessageErrorsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IEmailCopyMessageErrorsRequest {
    errors: string[];
}

export class ExportMassUpdateMessagesRequest implements IExportMassUpdateMessagesRequest {
    messageUniqueIds!: number[];
    system!: string;
    principle!: string;
    docTypeName!: string;
    url!: string;

    constructor(data?: IExportMassUpdateMessagesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messageUniqueIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messageUniqueIds"])) {
                this.messageUniqueIds = [] as any;
                for (let item of _data["messageUniqueIds"])
                    this.messageUniqueIds!.push(item);
            }
            this.system = _data["system"];
            this.principle = _data["principle"];
            this.docTypeName = _data["docTypeName"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): ExportMassUpdateMessagesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExportMassUpdateMessagesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messageUniqueIds)) {
            data["messageUniqueIds"] = [];
            for (let item of this.messageUniqueIds)
                data["messageUniqueIds"].push(item);
        }
        data["system"] = this.system;
        data["principle"] = this.principle;
        data["docTypeName"] = this.docTypeName;
        data["url"] = this.url;
        return data;
    }
}

export interface IExportMassUpdateMessagesRequest {
    messageUniqueIds: number[];
    system: string;
    principle: string;
    docTypeName: string;
    url: string;
}

export class ImportMassUpdateMessagesRequest implements IImportMassUpdateMessagesRequest {
    system!: string;
    principle!: string;
    docTypeName!: string;
    fileName!: string;
    csvBase64!: string;

    constructor(data?: IImportMassUpdateMessagesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.system = _data["system"];
            this.principle = _data["principle"];
            this.docTypeName = _data["docTypeName"];
            this.fileName = _data["fileName"];
            this.csvBase64 = _data["csvBase64"];
        }
    }

    static fromJS(data: any): ImportMassUpdateMessagesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportMassUpdateMessagesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["system"] = this.system;
        data["principle"] = this.principle;
        data["docTypeName"] = this.docTypeName;
        data["fileName"] = this.fileName;
        data["csvBase64"] = this.csvBase64;
        return data;
    }
}

export interface IImportMassUpdateMessagesRequest {
    system: string;
    principle: string;
    docTypeName: string;
    fileName: string;
    csvBase64: string;
}

export class ChangeRanksRequest implements IChangeRanksRequest {
    messageRanks!: ChangeMessageRankDto[];

    constructor(data?: IChangeRanksRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messageRanks = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messageRanks"])) {
                this.messageRanks = [] as any;
                for (let item of _data["messageRanks"])
                    this.messageRanks!.push(ChangeMessageRankDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChangeRanksRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeRanksRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messageRanks)) {
            data["messageRanks"] = [];
            for (let item of this.messageRanks)
                data["messageRanks"].push(item.toJSON());
        }
        return data;
    }
}

export interface IChangeRanksRequest {
    messageRanks: ChangeMessageRankDto[];
}

export class ChangeMessageRankDto implements IChangeMessageRankDto {
    primaryKey!: number;
    rank?: number | undefined;

    constructor(data?: IChangeMessageRankDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primaryKey = _data["primaryKey"];
            this.rank = _data["rank"];
        }
    }

    static fromJS(data: any): ChangeMessageRankDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeMessageRankDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primaryKey"] = this.primaryKey;
        data["rank"] = this.rank;
        return data;
    }
}

export interface IChangeMessageRankDto {
    primaryKey: number;
    rank?: number | undefined;
}

export class ChangeMessageStatusResponse implements IChangeMessageStatusResponse {
    responseMsg!: string;

    constructor(data?: IChangeMessageStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseMsg = _data["responseMsg"];
        }
    }

    static fromJS(data: any): ChangeMessageStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeMessageStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseMsg"] = this.responseMsg;
        return data;
    }
}

export interface IChangeMessageStatusResponse {
    responseMsg: string;
}

export class ChangeMessageStatusesRequest implements IChangeMessageStatusesRequest {
    statusChangeMessagePks!: number[];
    targetStatus!: OlmMessageStatus;

    constructor(data?: IChangeMessageStatusesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusChangeMessagePks = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["statusChangeMessagePks"])) {
                this.statusChangeMessagePks = [] as any;
                for (let item of _data["statusChangeMessagePks"])
                    this.statusChangeMessagePks!.push(item);
            }
            this.targetStatus = _data["targetStatus"];
        }
    }

    static fromJS(data: any): ChangeMessageStatusesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeMessageStatusesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.statusChangeMessagePks)) {
            data["statusChangeMessagePks"] = [];
            for (let item of this.statusChangeMessagePks)
                data["statusChangeMessagePks"].push(item);
        }
        data["targetStatus"] = this.targetStatus;
        return data;
    }
}

export interface IChangeMessageStatusesRequest {
    statusChangeMessagePks: number[];
    targetStatus: OlmMessageStatus;
}

export class ChangeMessageStatusRequest implements IChangeMessageStatusRequest {
    messageId!: number;
    targetStatus!: OlmMessageStatus;

    constructor(data?: IChangeMessageStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageId = _data["messageId"];
            this.targetStatus = _data["targetStatus"];
        }
    }

    static fromJS(data: any): ChangeMessageStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeMessageStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageId"] = this.messageId;
        data["targetStatus"] = this.targetStatus;
        return data;
    }
}

export interface IChangeMessageStatusRequest {
    messageId: number;
    targetStatus: OlmMessageStatus;
}

export class SaveMessageResponse implements ISaveMessageResponse {
    messageUniqueId!: number;

    constructor(data?: ISaveMessageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageUniqueId = _data["messageUniqueId"];
        }
    }

    static fromJS(data: any): SaveMessageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveMessageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageUniqueId"] = this.messageUniqueId;
        return data;
    }
}

export interface ISaveMessageResponse {
    messageUniqueId: number;
}

export class SaveMessageRequest implements ISaveMessageRequest {
    hidAllowSpecialCharacters!: boolean;
    message!: OlmMessage;

    constructor(data?: ISaveMessageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.message = new OlmMessage();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hidAllowSpecialCharacters = _data["hidAllowSpecialCharacters"];
            this.message = _data["message"] ? OlmMessage.fromJS(_data["message"]) : new OlmMessage();
        }
    }

    static fromJS(data: any): SaveMessageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveMessageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hidAllowSpecialCharacters"] = this.hidAllowSpecialCharacters;
        data["message"] = this.message ? this.message.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveMessageRequest {
    hidAllowSpecialCharacters: boolean;
    message: OlmMessage;
}

export class GetPdfPreviewRequest implements IGetPdfPreviewRequest {
    msgPrimaryKeys!: number[];
    system!: string;
    principle!: string;
    language!: string;

    constructor(data?: IGetPdfPreviewRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.msgPrimaryKeys = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["msgPrimaryKeys"])) {
                this.msgPrimaryKeys = [] as any;
                for (let item of _data["msgPrimaryKeys"])
                    this.msgPrimaryKeys!.push(item);
            }
            this.system = _data["system"];
            this.principle = _data["principle"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): GetPdfPreviewRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPdfPreviewRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.msgPrimaryKeys)) {
            data["msgPrimaryKeys"] = [];
            for (let item of this.msgPrimaryKeys)
                data["msgPrimaryKeys"].push(item);
        }
        data["system"] = this.system;
        data["principle"] = this.principle;
        data["language"] = this.language;
        return data;
    }
}

export interface IGetPdfPreviewRequest {
    msgPrimaryKeys: number[];
    system: string;
    principle: string;
    language: string;
}

export class GetSinglePdfPreviewRequest implements IGetSinglePdfPreviewRequest {
    msg!: OlmMessage;
    system!: string;
    principle!: string;
    language!: string;

    constructor(data?: IGetSinglePdfPreviewRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.msg = new OlmMessage();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.msg = _data["msg"] ? OlmMessage.fromJS(_data["msg"]) : new OlmMessage();
            this.system = _data["system"];
            this.principle = _data["principle"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): GetSinglePdfPreviewRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSinglePdfPreviewRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["msg"] = this.msg ? this.msg.toJSON() : <any>undefined;
        data["system"] = this.system;
        data["principle"] = this.principle;
        data["language"] = this.language;
        return data;
    }
}

export interface IGetSinglePdfPreviewRequest {
    msg: OlmMessage;
    system: string;
    principle: string;
    language: string;
}

export abstract class ValidationResults implements IValidationResults {
    validationFailureGroups?: { [key: string]: Anonymous3[]; } | undefined;
    hasFailures!: boolean;
    totalFailureCount!: number;

    constructor(data?: IValidationResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["validationFailureGroups"]) {
                this.validationFailureGroups = {} as any;
                for (let key in _data["validationFailureGroups"]) {
                    if (_data["validationFailureGroups"].hasOwnProperty(key))
                        (<any>this.validationFailureGroups)![key] = _data["validationFailureGroups"][key] !== undefined ? _data["validationFailureGroups"][key] : [];
                }
            }
            this.hasFailures = _data["hasFailures"];
            this.totalFailureCount = _data["totalFailureCount"];
        }
    }

    static fromJS(data: any): ValidationResults {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ValidationResults' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.validationFailureGroups) {
            data["validationFailureGroups"] = {};
            for (let key in this.validationFailureGroups) {
                if (this.validationFailureGroups.hasOwnProperty(key))
                    (<any>data["validationFailureGroups"])[key] = (<any>this.validationFailureGroups)[key];
            }
        }
        data["hasFailures"] = this.hasFailures;
        data["totalFailureCount"] = this.totalFailureCount;
        return data;
    }
}

export interface IValidationResults {
    validationFailureGroups?: { [key: string]: Anonymous3[]; } | undefined;
    hasFailures: boolean;
    totalFailureCount: number;
}

export class OlmMessageValidationResults extends ValidationResults implements IOlmMessageValidationResults {
    validationFailureGroups?: { [key: string]: Anonymous[]; } | undefined;
    selectivityValidationResults?: OlmSelectivityValidationResults | undefined;
    pdfPreviewValidationExceptions?: PdfPreviewException[] | undefined;
    accessValidationFailures?: OlmMessageAccessFailure[] | undefined;
    sysPrinValidationFailures?: OlmMessageSysPrinFailure[] | undefined;
    requestorFirstNameFailures?: OlmMessageRequestorFirstNameFailure[] | undefined;
    requestorLastNameFailures?: OlmMessageRequestorLastNameFailure[] | undefined;
    requestorEmailFailures?: OlmMessageRequestorEmailFailure[] | undefined;
    departmentFailures?: OlmMessageDepartmentFailure[] | undefined;
    notesValidationFailures?: OlmMessageNotesFailure[] | undefined;
    titleValidationFailures?: OlmMessageTitleFailure[] | undefined;
    messageIdValidationFailures?: OlmMessageIdFailure[] | undefined;
    messageTypeValidationFailures?: OlmMessageTypeFailure[] | undefined;
    messageLinkingValidationFailures?: OlmMessageLinkingFailure[] | undefined;
    rankValidationFailures?: OlmMessageRankFailure[] | undefined;
    requirementValidationFailures?: OlmMessageRequirementFailure[] | undefined;
    forceHardcopyValidationFailures?: OlmMessageForceHardcopyFailure[] | undefined;
    locationSelectionValidationFailures?: OlmMessageLocationSelectionFailure[] | undefined;
    beginDateValidationFailures?: OlmMessageBeginDateFailure[] | undefined;
    endDateValidationFailures?: OlmMessageEndDateFailure[] | undefined;
    overflowValidationFailures?: OlmMessageOverflowFailure[] | undefined;
    vantageQueryValidationFailures?: OlmMessageVantageQueryFailure[] | undefined;
    externalClientGroupValidationFailures?: OlmMessageExternalClientGroupFailure[] | undefined;
    backgroundColorValidationFailures?: OlmMessageBackgroundColorFailure[] | undefined;
    lineSpacingValidationFailures?: OlmMessageLineSpacingFailure[] | undefined;
    primaryLanguageValidationFailures?: OlmMessagePrimaryLanguageFailure[] | undefined;
    languageValidationFailures?: OlmMessageLanguageFailure[] | undefined;
    messageTextValidationFailures?: OlmMessageTextFailure[] | undefined;
    stuffCodeValidationFailures?: OlmStuffCodeFailure[] | undefined;
    inViewHoldIdValidationFailures?: OlmMessageInViewHoldIdFailure[] | undefined;
    graphicLocationValidationFailures?: OlmMessageGraphicLocationFailure[] | undefined;
    graphicLocationTextWrapValidationFailures?: OlmMessageGraphicLocationTextWrapFailure[] | undefined;
    graphicIdValidationFailures?: OlmMessageGraphicNumberFailure[] | undefined;
    replacementVariableValidationFailures?: OlmMessageReplacementVariableFailure[] | undefined;
    generalValidationFailures?: OlmMessageGeneralFailure[] | undefined;

    constructor(data?: IOlmMessageValidationResults) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["validationFailureGroups"]) {
                this.validationFailureGroups = {} as any;
                for (let key in _data["validationFailureGroups"]) {
                    if (_data["validationFailureGroups"].hasOwnProperty(key))
                        (<any>this.validationFailureGroups)![key] = _data["validationFailureGroups"][key] !== undefined ? _data["validationFailureGroups"][key] : [];
                }
            }
            this.selectivityValidationResults = _data["selectivityValidationResults"] ? OlmSelectivityValidationResults.fromJS(_data["selectivityValidationResults"]) : <any>undefined;
            if (Array.isArray(_data["pdfPreviewValidationExceptions"])) {
                this.pdfPreviewValidationExceptions = [] as any;
                for (let item of _data["pdfPreviewValidationExceptions"])
                    this.pdfPreviewValidationExceptions!.push(PdfPreviewException.fromJS(item));
            }
            if (Array.isArray(_data["accessValidationFailures"])) {
                this.accessValidationFailures = [] as any;
                for (let item of _data["accessValidationFailures"])
                    this.accessValidationFailures!.push(OlmMessageAccessFailure.fromJS(item));
            }
            if (Array.isArray(_data["sysPrinValidationFailures"])) {
                this.sysPrinValidationFailures = [] as any;
                for (let item of _data["sysPrinValidationFailures"])
                    this.sysPrinValidationFailures!.push(OlmMessageSysPrinFailure.fromJS(item));
            }
            if (Array.isArray(_data["requestorFirstNameFailures"])) {
                this.requestorFirstNameFailures = [] as any;
                for (let item of _data["requestorFirstNameFailures"])
                    this.requestorFirstNameFailures!.push(OlmMessageRequestorFirstNameFailure.fromJS(item));
            }
            if (Array.isArray(_data["requestorLastNameFailures"])) {
                this.requestorLastNameFailures = [] as any;
                for (let item of _data["requestorLastNameFailures"])
                    this.requestorLastNameFailures!.push(OlmMessageRequestorLastNameFailure.fromJS(item));
            }
            if (Array.isArray(_data["requestorEmailFailures"])) {
                this.requestorEmailFailures = [] as any;
                for (let item of _data["requestorEmailFailures"])
                    this.requestorEmailFailures!.push(OlmMessageRequestorEmailFailure.fromJS(item));
            }
            if (Array.isArray(_data["departmentFailures"])) {
                this.departmentFailures = [] as any;
                for (let item of _data["departmentFailures"])
                    this.departmentFailures!.push(OlmMessageDepartmentFailure.fromJS(item));
            }
            if (Array.isArray(_data["notesValidationFailures"])) {
                this.notesValidationFailures = [] as any;
                for (let item of _data["notesValidationFailures"])
                    this.notesValidationFailures!.push(OlmMessageNotesFailure.fromJS(item));
            }
            if (Array.isArray(_data["titleValidationFailures"])) {
                this.titleValidationFailures = [] as any;
                for (let item of _data["titleValidationFailures"])
                    this.titleValidationFailures!.push(OlmMessageTitleFailure.fromJS(item));
            }
            if (Array.isArray(_data["messageIdValidationFailures"])) {
                this.messageIdValidationFailures = [] as any;
                for (let item of _data["messageIdValidationFailures"])
                    this.messageIdValidationFailures!.push(OlmMessageIdFailure.fromJS(item));
            }
            if (Array.isArray(_data["messageTypeValidationFailures"])) {
                this.messageTypeValidationFailures = [] as any;
                for (let item of _data["messageTypeValidationFailures"])
                    this.messageTypeValidationFailures!.push(OlmMessageTypeFailure.fromJS(item));
            }
            if (Array.isArray(_data["messageLinkingValidationFailures"])) {
                this.messageLinkingValidationFailures = [] as any;
                for (let item of _data["messageLinkingValidationFailures"])
                    this.messageLinkingValidationFailures!.push(OlmMessageLinkingFailure.fromJS(item));
            }
            if (Array.isArray(_data["rankValidationFailures"])) {
                this.rankValidationFailures = [] as any;
                for (let item of _data["rankValidationFailures"])
                    this.rankValidationFailures!.push(OlmMessageRankFailure.fromJS(item));
            }
            if (Array.isArray(_data["requirementValidationFailures"])) {
                this.requirementValidationFailures = [] as any;
                for (let item of _data["requirementValidationFailures"])
                    this.requirementValidationFailures!.push(OlmMessageRequirementFailure.fromJS(item));
            }
            if (Array.isArray(_data["forceHardcopyValidationFailures"])) {
                this.forceHardcopyValidationFailures = [] as any;
                for (let item of _data["forceHardcopyValidationFailures"])
                    this.forceHardcopyValidationFailures!.push(OlmMessageForceHardcopyFailure.fromJS(item));
            }
            if (Array.isArray(_data["locationSelectionValidationFailures"])) {
                this.locationSelectionValidationFailures = [] as any;
                for (let item of _data["locationSelectionValidationFailures"])
                    this.locationSelectionValidationFailures!.push(OlmMessageLocationSelectionFailure.fromJS(item));
            }
            if (Array.isArray(_data["beginDateValidationFailures"])) {
                this.beginDateValidationFailures = [] as any;
                for (let item of _data["beginDateValidationFailures"])
                    this.beginDateValidationFailures!.push(OlmMessageBeginDateFailure.fromJS(item));
            }
            if (Array.isArray(_data["endDateValidationFailures"])) {
                this.endDateValidationFailures = [] as any;
                for (let item of _data["endDateValidationFailures"])
                    this.endDateValidationFailures!.push(OlmMessageEndDateFailure.fromJS(item));
            }
            if (Array.isArray(_data["overflowValidationFailures"])) {
                this.overflowValidationFailures = [] as any;
                for (let item of _data["overflowValidationFailures"])
                    this.overflowValidationFailures!.push(OlmMessageOverflowFailure.fromJS(item));
            }
            if (Array.isArray(_data["vantageQueryValidationFailures"])) {
                this.vantageQueryValidationFailures = [] as any;
                for (let item of _data["vantageQueryValidationFailures"])
                    this.vantageQueryValidationFailures!.push(OlmMessageVantageQueryFailure.fromJS(item));
            }
            if (Array.isArray(_data["externalClientGroupValidationFailures"])) {
                this.externalClientGroupValidationFailures = [] as any;
                for (let item of _data["externalClientGroupValidationFailures"])
                    this.externalClientGroupValidationFailures!.push(OlmMessageExternalClientGroupFailure.fromJS(item));
            }
            if (Array.isArray(_data["backgroundColorValidationFailures"])) {
                this.backgroundColorValidationFailures = [] as any;
                for (let item of _data["backgroundColorValidationFailures"])
                    this.backgroundColorValidationFailures!.push(OlmMessageBackgroundColorFailure.fromJS(item));
            }
            if (Array.isArray(_data["lineSpacingValidationFailures"])) {
                this.lineSpacingValidationFailures = [] as any;
                for (let item of _data["lineSpacingValidationFailures"])
                    this.lineSpacingValidationFailures!.push(OlmMessageLineSpacingFailure.fromJS(item));
            }
            if (Array.isArray(_data["primaryLanguageValidationFailures"])) {
                this.primaryLanguageValidationFailures = [] as any;
                for (let item of _data["primaryLanguageValidationFailures"])
                    this.primaryLanguageValidationFailures!.push(OlmMessagePrimaryLanguageFailure.fromJS(item));
            }
            if (Array.isArray(_data["languageValidationFailures"])) {
                this.languageValidationFailures = [] as any;
                for (let item of _data["languageValidationFailures"])
                    this.languageValidationFailures!.push(OlmMessageLanguageFailure.fromJS(item));
            }
            if (Array.isArray(_data["messageTextValidationFailures"])) {
                this.messageTextValidationFailures = [] as any;
                for (let item of _data["messageTextValidationFailures"])
                    this.messageTextValidationFailures!.push(OlmMessageTextFailure.fromJS(item));
            }
            if (Array.isArray(_data["stuffCodeValidationFailures"])) {
                this.stuffCodeValidationFailures = [] as any;
                for (let item of _data["stuffCodeValidationFailures"])
                    this.stuffCodeValidationFailures!.push(OlmStuffCodeFailure.fromJS(item));
            }
            if (Array.isArray(_data["inViewHoldIdValidationFailures"])) {
                this.inViewHoldIdValidationFailures = [] as any;
                for (let item of _data["inViewHoldIdValidationFailures"])
                    this.inViewHoldIdValidationFailures!.push(OlmMessageInViewHoldIdFailure.fromJS(item));
            }
            if (Array.isArray(_data["graphicLocationValidationFailures"])) {
                this.graphicLocationValidationFailures = [] as any;
                for (let item of _data["graphicLocationValidationFailures"])
                    this.graphicLocationValidationFailures!.push(OlmMessageGraphicLocationFailure.fromJS(item));
            }
            if (Array.isArray(_data["graphicLocationTextWrapValidationFailures"])) {
                this.graphicLocationTextWrapValidationFailures = [] as any;
                for (let item of _data["graphicLocationTextWrapValidationFailures"])
                    this.graphicLocationTextWrapValidationFailures!.push(OlmMessageGraphicLocationTextWrapFailure.fromJS(item));
            }
            if (Array.isArray(_data["graphicIdValidationFailures"])) {
                this.graphicIdValidationFailures = [] as any;
                for (let item of _data["graphicIdValidationFailures"])
                    this.graphicIdValidationFailures!.push(OlmMessageGraphicNumberFailure.fromJS(item));
            }
            if (Array.isArray(_data["replacementVariableValidationFailures"])) {
                this.replacementVariableValidationFailures = [] as any;
                for (let item of _data["replacementVariableValidationFailures"])
                    this.replacementVariableValidationFailures!.push(OlmMessageReplacementVariableFailure.fromJS(item));
            }
            if (Array.isArray(_data["generalValidationFailures"])) {
                this.generalValidationFailures = [] as any;
                for (let item of _data["generalValidationFailures"])
                    this.generalValidationFailures!.push(OlmMessageGeneralFailure.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): OlmMessageValidationResults {
        data = typeof data === 'object' ? data : {};
        let result = new OlmMessageValidationResults();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.validationFailureGroups) {
            data["validationFailureGroups"] = {};
            for (let key in this.validationFailureGroups) {
                if (this.validationFailureGroups.hasOwnProperty(key))
                    (<any>data["validationFailureGroups"])[key] = (<any>this.validationFailureGroups)[key];
            }
        }
        data["selectivityValidationResults"] = this.selectivityValidationResults ? this.selectivityValidationResults.toJSON() : <any>undefined;
        if (Array.isArray(this.pdfPreviewValidationExceptions)) {
            data["pdfPreviewValidationExceptions"] = [];
            for (let item of this.pdfPreviewValidationExceptions)
                data["pdfPreviewValidationExceptions"].push(item.toJSON());
        }
        if (Array.isArray(this.accessValidationFailures)) {
            data["accessValidationFailures"] = [];
            for (let item of this.accessValidationFailures)
                data["accessValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.sysPrinValidationFailures)) {
            data["sysPrinValidationFailures"] = [];
            for (let item of this.sysPrinValidationFailures)
                data["sysPrinValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.requestorFirstNameFailures)) {
            data["requestorFirstNameFailures"] = [];
            for (let item of this.requestorFirstNameFailures)
                data["requestorFirstNameFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.requestorLastNameFailures)) {
            data["requestorLastNameFailures"] = [];
            for (let item of this.requestorLastNameFailures)
                data["requestorLastNameFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.requestorEmailFailures)) {
            data["requestorEmailFailures"] = [];
            for (let item of this.requestorEmailFailures)
                data["requestorEmailFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.departmentFailures)) {
            data["departmentFailures"] = [];
            for (let item of this.departmentFailures)
                data["departmentFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.notesValidationFailures)) {
            data["notesValidationFailures"] = [];
            for (let item of this.notesValidationFailures)
                data["notesValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.titleValidationFailures)) {
            data["titleValidationFailures"] = [];
            for (let item of this.titleValidationFailures)
                data["titleValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.messageIdValidationFailures)) {
            data["messageIdValidationFailures"] = [];
            for (let item of this.messageIdValidationFailures)
                data["messageIdValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.messageTypeValidationFailures)) {
            data["messageTypeValidationFailures"] = [];
            for (let item of this.messageTypeValidationFailures)
                data["messageTypeValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.messageLinkingValidationFailures)) {
            data["messageLinkingValidationFailures"] = [];
            for (let item of this.messageLinkingValidationFailures)
                data["messageLinkingValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.rankValidationFailures)) {
            data["rankValidationFailures"] = [];
            for (let item of this.rankValidationFailures)
                data["rankValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.requirementValidationFailures)) {
            data["requirementValidationFailures"] = [];
            for (let item of this.requirementValidationFailures)
                data["requirementValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.forceHardcopyValidationFailures)) {
            data["forceHardcopyValidationFailures"] = [];
            for (let item of this.forceHardcopyValidationFailures)
                data["forceHardcopyValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.locationSelectionValidationFailures)) {
            data["locationSelectionValidationFailures"] = [];
            for (let item of this.locationSelectionValidationFailures)
                data["locationSelectionValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.beginDateValidationFailures)) {
            data["beginDateValidationFailures"] = [];
            for (let item of this.beginDateValidationFailures)
                data["beginDateValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.endDateValidationFailures)) {
            data["endDateValidationFailures"] = [];
            for (let item of this.endDateValidationFailures)
                data["endDateValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.overflowValidationFailures)) {
            data["overflowValidationFailures"] = [];
            for (let item of this.overflowValidationFailures)
                data["overflowValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.vantageQueryValidationFailures)) {
            data["vantageQueryValidationFailures"] = [];
            for (let item of this.vantageQueryValidationFailures)
                data["vantageQueryValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.externalClientGroupValidationFailures)) {
            data["externalClientGroupValidationFailures"] = [];
            for (let item of this.externalClientGroupValidationFailures)
                data["externalClientGroupValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.backgroundColorValidationFailures)) {
            data["backgroundColorValidationFailures"] = [];
            for (let item of this.backgroundColorValidationFailures)
                data["backgroundColorValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.lineSpacingValidationFailures)) {
            data["lineSpacingValidationFailures"] = [];
            for (let item of this.lineSpacingValidationFailures)
                data["lineSpacingValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.primaryLanguageValidationFailures)) {
            data["primaryLanguageValidationFailures"] = [];
            for (let item of this.primaryLanguageValidationFailures)
                data["primaryLanguageValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.languageValidationFailures)) {
            data["languageValidationFailures"] = [];
            for (let item of this.languageValidationFailures)
                data["languageValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.messageTextValidationFailures)) {
            data["messageTextValidationFailures"] = [];
            for (let item of this.messageTextValidationFailures)
                data["messageTextValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.stuffCodeValidationFailures)) {
            data["stuffCodeValidationFailures"] = [];
            for (let item of this.stuffCodeValidationFailures)
                data["stuffCodeValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.inViewHoldIdValidationFailures)) {
            data["inViewHoldIdValidationFailures"] = [];
            for (let item of this.inViewHoldIdValidationFailures)
                data["inViewHoldIdValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.graphicLocationValidationFailures)) {
            data["graphicLocationValidationFailures"] = [];
            for (let item of this.graphicLocationValidationFailures)
                data["graphicLocationValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.graphicLocationTextWrapValidationFailures)) {
            data["graphicLocationTextWrapValidationFailures"] = [];
            for (let item of this.graphicLocationTextWrapValidationFailures)
                data["graphicLocationTextWrapValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.graphicIdValidationFailures)) {
            data["graphicIdValidationFailures"] = [];
            for (let item of this.graphicIdValidationFailures)
                data["graphicIdValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.replacementVariableValidationFailures)) {
            data["replacementVariableValidationFailures"] = [];
            for (let item of this.replacementVariableValidationFailures)
                data["replacementVariableValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.generalValidationFailures)) {
            data["generalValidationFailures"] = [];
            for (let item of this.generalValidationFailures)
                data["generalValidationFailures"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IOlmMessageValidationResults extends IValidationResults {
    validationFailureGroups?: { [key: string]: Anonymous[]; } | undefined;
    selectivityValidationResults?: OlmSelectivityValidationResults | undefined;
    pdfPreviewValidationExceptions?: PdfPreviewException[] | undefined;
    accessValidationFailures?: OlmMessageAccessFailure[] | undefined;
    sysPrinValidationFailures?: OlmMessageSysPrinFailure[] | undefined;
    requestorFirstNameFailures?: OlmMessageRequestorFirstNameFailure[] | undefined;
    requestorLastNameFailures?: OlmMessageRequestorLastNameFailure[] | undefined;
    requestorEmailFailures?: OlmMessageRequestorEmailFailure[] | undefined;
    departmentFailures?: OlmMessageDepartmentFailure[] | undefined;
    notesValidationFailures?: OlmMessageNotesFailure[] | undefined;
    titleValidationFailures?: OlmMessageTitleFailure[] | undefined;
    messageIdValidationFailures?: OlmMessageIdFailure[] | undefined;
    messageTypeValidationFailures?: OlmMessageTypeFailure[] | undefined;
    messageLinkingValidationFailures?: OlmMessageLinkingFailure[] | undefined;
    rankValidationFailures?: OlmMessageRankFailure[] | undefined;
    requirementValidationFailures?: OlmMessageRequirementFailure[] | undefined;
    forceHardcopyValidationFailures?: OlmMessageForceHardcopyFailure[] | undefined;
    locationSelectionValidationFailures?: OlmMessageLocationSelectionFailure[] | undefined;
    beginDateValidationFailures?: OlmMessageBeginDateFailure[] | undefined;
    endDateValidationFailures?: OlmMessageEndDateFailure[] | undefined;
    overflowValidationFailures?: OlmMessageOverflowFailure[] | undefined;
    vantageQueryValidationFailures?: OlmMessageVantageQueryFailure[] | undefined;
    externalClientGroupValidationFailures?: OlmMessageExternalClientGroupFailure[] | undefined;
    backgroundColorValidationFailures?: OlmMessageBackgroundColorFailure[] | undefined;
    lineSpacingValidationFailures?: OlmMessageLineSpacingFailure[] | undefined;
    primaryLanguageValidationFailures?: OlmMessagePrimaryLanguageFailure[] | undefined;
    languageValidationFailures?: OlmMessageLanguageFailure[] | undefined;
    messageTextValidationFailures?: OlmMessageTextFailure[] | undefined;
    stuffCodeValidationFailures?: OlmStuffCodeFailure[] | undefined;
    inViewHoldIdValidationFailures?: OlmMessageInViewHoldIdFailure[] | undefined;
    graphicLocationValidationFailures?: OlmMessageGraphicLocationFailure[] | undefined;
    graphicLocationTextWrapValidationFailures?: OlmMessageGraphicLocationTextWrapFailure[] | undefined;
    graphicIdValidationFailures?: OlmMessageGraphicNumberFailure[] | undefined;
    replacementVariableValidationFailures?: OlmMessageReplacementVariableFailure[] | undefined;
    generalValidationFailures?: OlmMessageGeneralFailure[] | undefined;
}

export class OlmSelectivityValidationResults extends ValidationResults implements IOlmSelectivityValidationResults {
    validationFailureGroups?: { [key: string]: Anonymous2[]; } | undefined;
    accessValidationFailures?: OlmSelectivityAccessFailure[] | undefined;
    selectivityIsRequiredValidationFailures?: OlmSelectivityIsRequiredFailure[] | undefined;
    nameValidationFailures?: OlmSelectivityNameFailure[] | undefined;
    criteriaCountValidationFailures?: OlmSelectivityCriteriaCountFailure[] | undefined;
    selectivityCriteriaValidationFailures?: OlmSelectivityCriteriaFailure[] | undefined;
    criterionValuesCountValidationFailures?: OlmSelectivityCriterionValuesCountFailure[] | undefined;
    criterionFieldValidationFailures?: OlmSelectivityCriterionFieldFailure[] | undefined;
    criterionExtendedFieldSequenceValidationFailures?: OlmSelectivityCriterionExtendedFieldSequenceFailure[] | undefined;
    criterionOperandValidationFailures?: OlmSelectivityCriterionOperandFailure[] | undefined;
    criterionValuesRelationshipValidationFailures?: OlmSelectivityCriterionValuesRelationshipFailure[] | undefined;
    criterionValueValidationFailures?: OlmSelectivityCriterionValueFailure[] | undefined;
    evaluationNeverMatchesValidationFailures?: OlmSelectivityEvaluationNeverMatchesFailure[] | undefined;
    evaluationAlwaysMatchesValidationFailures?: OlmSelectivityEvaluationAlwaysMatchesFailure[] | undefined;
    criterionCombinedGroupIdValidationFailures?: OlmSelectivityCriterionCombinedGroupIdFailure[] | undefined;
    criterionCombinationValidationFailures?: OlmSelectivityCriterionCombinationFailure[] | undefined;
    criterionNextCriterionRelationshipValidationFailures?: OlmSelectivityCriterionNextCriterionRelationshipFailure[] | undefined;
    criterionNotesValidationFailures?: OlmSelectivityCriterionNotesFailure[] | undefined;
    criterionLogicalBlockIdValidationFailures?: OlmSelectivityCriterionLogicalBlockIdFailure[] | undefined;
    highestRecordedLogicalBlockIdFailures?: OlmSelectivityHighestRecordedLogicalBlockIdFailure[] | undefined;

    constructor(data?: IOlmSelectivityValidationResults) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["validationFailureGroups"]) {
                this.validationFailureGroups = {} as any;
                for (let key in _data["validationFailureGroups"]) {
                    if (_data["validationFailureGroups"].hasOwnProperty(key))
                        (<any>this.validationFailureGroups)![key] = _data["validationFailureGroups"][key] !== undefined ? _data["validationFailureGroups"][key] : [];
                }
            }
            if (Array.isArray(_data["accessValidationFailures"])) {
                this.accessValidationFailures = [] as any;
                for (let item of _data["accessValidationFailures"])
                    this.accessValidationFailures!.push(OlmSelectivityAccessFailure.fromJS(item));
            }
            if (Array.isArray(_data["selectivityIsRequiredValidationFailures"])) {
                this.selectivityIsRequiredValidationFailures = [] as any;
                for (let item of _data["selectivityIsRequiredValidationFailures"])
                    this.selectivityIsRequiredValidationFailures!.push(OlmSelectivityIsRequiredFailure.fromJS(item));
            }
            if (Array.isArray(_data["nameValidationFailures"])) {
                this.nameValidationFailures = [] as any;
                for (let item of _data["nameValidationFailures"])
                    this.nameValidationFailures!.push(OlmSelectivityNameFailure.fromJS(item));
            }
            if (Array.isArray(_data["criteriaCountValidationFailures"])) {
                this.criteriaCountValidationFailures = [] as any;
                for (let item of _data["criteriaCountValidationFailures"])
                    this.criteriaCountValidationFailures!.push(OlmSelectivityCriteriaCountFailure.fromJS(item));
            }
            if (Array.isArray(_data["selectivityCriteriaValidationFailures"])) {
                this.selectivityCriteriaValidationFailures = [] as any;
                for (let item of _data["selectivityCriteriaValidationFailures"])
                    this.selectivityCriteriaValidationFailures!.push(OlmSelectivityCriteriaFailure.fromJS(item));
            }
            if (Array.isArray(_data["criterionValuesCountValidationFailures"])) {
                this.criterionValuesCountValidationFailures = [] as any;
                for (let item of _data["criterionValuesCountValidationFailures"])
                    this.criterionValuesCountValidationFailures!.push(OlmSelectivityCriterionValuesCountFailure.fromJS(item));
            }
            if (Array.isArray(_data["criterionFieldValidationFailures"])) {
                this.criterionFieldValidationFailures = [] as any;
                for (let item of _data["criterionFieldValidationFailures"])
                    this.criterionFieldValidationFailures!.push(OlmSelectivityCriterionFieldFailure.fromJS(item));
            }
            if (Array.isArray(_data["criterionExtendedFieldSequenceValidationFailures"])) {
                this.criterionExtendedFieldSequenceValidationFailures = [] as any;
                for (let item of _data["criterionExtendedFieldSequenceValidationFailures"])
                    this.criterionExtendedFieldSequenceValidationFailures!.push(OlmSelectivityCriterionExtendedFieldSequenceFailure.fromJS(item));
            }
            if (Array.isArray(_data["criterionOperandValidationFailures"])) {
                this.criterionOperandValidationFailures = [] as any;
                for (let item of _data["criterionOperandValidationFailures"])
                    this.criterionOperandValidationFailures!.push(OlmSelectivityCriterionOperandFailure.fromJS(item));
            }
            if (Array.isArray(_data["criterionValuesRelationshipValidationFailures"])) {
                this.criterionValuesRelationshipValidationFailures = [] as any;
                for (let item of _data["criterionValuesRelationshipValidationFailures"])
                    this.criterionValuesRelationshipValidationFailures!.push(OlmSelectivityCriterionValuesRelationshipFailure.fromJS(item));
            }
            if (Array.isArray(_data["criterionValueValidationFailures"])) {
                this.criterionValueValidationFailures = [] as any;
                for (let item of _data["criterionValueValidationFailures"])
                    this.criterionValueValidationFailures!.push(OlmSelectivityCriterionValueFailure.fromJS(item));
            }
            if (Array.isArray(_data["evaluationNeverMatchesValidationFailures"])) {
                this.evaluationNeverMatchesValidationFailures = [] as any;
                for (let item of _data["evaluationNeverMatchesValidationFailures"])
                    this.evaluationNeverMatchesValidationFailures!.push(OlmSelectivityEvaluationNeverMatchesFailure.fromJS(item));
            }
            if (Array.isArray(_data["evaluationAlwaysMatchesValidationFailures"])) {
                this.evaluationAlwaysMatchesValidationFailures = [] as any;
                for (let item of _data["evaluationAlwaysMatchesValidationFailures"])
                    this.evaluationAlwaysMatchesValidationFailures!.push(OlmSelectivityEvaluationAlwaysMatchesFailure.fromJS(item));
            }
            if (Array.isArray(_data["criterionCombinedGroupIdValidationFailures"])) {
                this.criterionCombinedGroupIdValidationFailures = [] as any;
                for (let item of _data["criterionCombinedGroupIdValidationFailures"])
                    this.criterionCombinedGroupIdValidationFailures!.push(OlmSelectivityCriterionCombinedGroupIdFailure.fromJS(item));
            }
            if (Array.isArray(_data["criterionCombinationValidationFailures"])) {
                this.criterionCombinationValidationFailures = [] as any;
                for (let item of _data["criterionCombinationValidationFailures"])
                    this.criterionCombinationValidationFailures!.push(OlmSelectivityCriterionCombinationFailure.fromJS(item));
            }
            if (Array.isArray(_data["criterionNextCriterionRelationshipValidationFailures"])) {
                this.criterionNextCriterionRelationshipValidationFailures = [] as any;
                for (let item of _data["criterionNextCriterionRelationshipValidationFailures"])
                    this.criterionNextCriterionRelationshipValidationFailures!.push(OlmSelectivityCriterionNextCriterionRelationshipFailure.fromJS(item));
            }
            if (Array.isArray(_data["criterionNotesValidationFailures"])) {
                this.criterionNotesValidationFailures = [] as any;
                for (let item of _data["criterionNotesValidationFailures"])
                    this.criterionNotesValidationFailures!.push(OlmSelectivityCriterionNotesFailure.fromJS(item));
            }
            if (Array.isArray(_data["criterionLogicalBlockIdValidationFailures"])) {
                this.criterionLogicalBlockIdValidationFailures = [] as any;
                for (let item of _data["criterionLogicalBlockIdValidationFailures"])
                    this.criterionLogicalBlockIdValidationFailures!.push(OlmSelectivityCriterionLogicalBlockIdFailure.fromJS(item));
            }
            if (Array.isArray(_data["highestRecordedLogicalBlockIdFailures"])) {
                this.highestRecordedLogicalBlockIdFailures = [] as any;
                for (let item of _data["highestRecordedLogicalBlockIdFailures"])
                    this.highestRecordedLogicalBlockIdFailures!.push(OlmSelectivityHighestRecordedLogicalBlockIdFailure.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): OlmSelectivityValidationResults {
        data = typeof data === 'object' ? data : {};
        let result = new OlmSelectivityValidationResults();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.validationFailureGroups) {
            data["validationFailureGroups"] = {};
            for (let key in this.validationFailureGroups) {
                if (this.validationFailureGroups.hasOwnProperty(key))
                    (<any>data["validationFailureGroups"])[key] = (<any>this.validationFailureGroups)[key];
            }
        }
        if (Array.isArray(this.accessValidationFailures)) {
            data["accessValidationFailures"] = [];
            for (let item of this.accessValidationFailures)
                data["accessValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.selectivityIsRequiredValidationFailures)) {
            data["selectivityIsRequiredValidationFailures"] = [];
            for (let item of this.selectivityIsRequiredValidationFailures)
                data["selectivityIsRequiredValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.nameValidationFailures)) {
            data["nameValidationFailures"] = [];
            for (let item of this.nameValidationFailures)
                data["nameValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.criteriaCountValidationFailures)) {
            data["criteriaCountValidationFailures"] = [];
            for (let item of this.criteriaCountValidationFailures)
                data["criteriaCountValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.selectivityCriteriaValidationFailures)) {
            data["selectivityCriteriaValidationFailures"] = [];
            for (let item of this.selectivityCriteriaValidationFailures)
                data["selectivityCriteriaValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.criterionValuesCountValidationFailures)) {
            data["criterionValuesCountValidationFailures"] = [];
            for (let item of this.criterionValuesCountValidationFailures)
                data["criterionValuesCountValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.criterionFieldValidationFailures)) {
            data["criterionFieldValidationFailures"] = [];
            for (let item of this.criterionFieldValidationFailures)
                data["criterionFieldValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.criterionExtendedFieldSequenceValidationFailures)) {
            data["criterionExtendedFieldSequenceValidationFailures"] = [];
            for (let item of this.criterionExtendedFieldSequenceValidationFailures)
                data["criterionExtendedFieldSequenceValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.criterionOperandValidationFailures)) {
            data["criterionOperandValidationFailures"] = [];
            for (let item of this.criterionOperandValidationFailures)
                data["criterionOperandValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.criterionValuesRelationshipValidationFailures)) {
            data["criterionValuesRelationshipValidationFailures"] = [];
            for (let item of this.criterionValuesRelationshipValidationFailures)
                data["criterionValuesRelationshipValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.criterionValueValidationFailures)) {
            data["criterionValueValidationFailures"] = [];
            for (let item of this.criterionValueValidationFailures)
                data["criterionValueValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.evaluationNeverMatchesValidationFailures)) {
            data["evaluationNeverMatchesValidationFailures"] = [];
            for (let item of this.evaluationNeverMatchesValidationFailures)
                data["evaluationNeverMatchesValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.evaluationAlwaysMatchesValidationFailures)) {
            data["evaluationAlwaysMatchesValidationFailures"] = [];
            for (let item of this.evaluationAlwaysMatchesValidationFailures)
                data["evaluationAlwaysMatchesValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.criterionCombinedGroupIdValidationFailures)) {
            data["criterionCombinedGroupIdValidationFailures"] = [];
            for (let item of this.criterionCombinedGroupIdValidationFailures)
                data["criterionCombinedGroupIdValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.criterionCombinationValidationFailures)) {
            data["criterionCombinationValidationFailures"] = [];
            for (let item of this.criterionCombinationValidationFailures)
                data["criterionCombinationValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.criterionNextCriterionRelationshipValidationFailures)) {
            data["criterionNextCriterionRelationshipValidationFailures"] = [];
            for (let item of this.criterionNextCriterionRelationshipValidationFailures)
                data["criterionNextCriterionRelationshipValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.criterionNotesValidationFailures)) {
            data["criterionNotesValidationFailures"] = [];
            for (let item of this.criterionNotesValidationFailures)
                data["criterionNotesValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.criterionLogicalBlockIdValidationFailures)) {
            data["criterionLogicalBlockIdValidationFailures"] = [];
            for (let item of this.criterionLogicalBlockIdValidationFailures)
                data["criterionLogicalBlockIdValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.highestRecordedLogicalBlockIdFailures)) {
            data["highestRecordedLogicalBlockIdFailures"] = [];
            for (let item of this.highestRecordedLogicalBlockIdFailures)
                data["highestRecordedLogicalBlockIdFailures"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IOlmSelectivityValidationResults extends IValidationResults {
    validationFailureGroups?: { [key: string]: Anonymous2[]; } | undefined;
    accessValidationFailures?: OlmSelectivityAccessFailure[] | undefined;
    selectivityIsRequiredValidationFailures?: OlmSelectivityIsRequiredFailure[] | undefined;
    nameValidationFailures?: OlmSelectivityNameFailure[] | undefined;
    criteriaCountValidationFailures?: OlmSelectivityCriteriaCountFailure[] | undefined;
    selectivityCriteriaValidationFailures?: OlmSelectivityCriteriaFailure[] | undefined;
    criterionValuesCountValidationFailures?: OlmSelectivityCriterionValuesCountFailure[] | undefined;
    criterionFieldValidationFailures?: OlmSelectivityCriterionFieldFailure[] | undefined;
    criterionExtendedFieldSequenceValidationFailures?: OlmSelectivityCriterionExtendedFieldSequenceFailure[] | undefined;
    criterionOperandValidationFailures?: OlmSelectivityCriterionOperandFailure[] | undefined;
    criterionValuesRelationshipValidationFailures?: OlmSelectivityCriterionValuesRelationshipFailure[] | undefined;
    criterionValueValidationFailures?: OlmSelectivityCriterionValueFailure[] | undefined;
    evaluationNeverMatchesValidationFailures?: OlmSelectivityEvaluationNeverMatchesFailure[] | undefined;
    evaluationAlwaysMatchesValidationFailures?: OlmSelectivityEvaluationAlwaysMatchesFailure[] | undefined;
    criterionCombinedGroupIdValidationFailures?: OlmSelectivityCriterionCombinedGroupIdFailure[] | undefined;
    criterionCombinationValidationFailures?: OlmSelectivityCriterionCombinationFailure[] | undefined;
    criterionNextCriterionRelationshipValidationFailures?: OlmSelectivityCriterionNextCriterionRelationshipFailure[] | undefined;
    criterionNotesValidationFailures?: OlmSelectivityCriterionNotesFailure[] | undefined;
    criterionLogicalBlockIdValidationFailures?: OlmSelectivityCriterionLogicalBlockIdFailure[] | undefined;
    highestRecordedLogicalBlockIdFailures?: OlmSelectivityHighestRecordedLogicalBlockIdFailure[] | undefined;
}

export abstract class ValidationFailure implements IValidationFailure {
    field?: string | undefined;
    reactField?: string | undefined;
    reason?: string | undefined;

    constructor(data?: IValidationFailure) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.reactField = _data["reactField"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): ValidationFailure {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ValidationFailure' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["reactField"] = this.reactField;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IValidationFailure {
    field?: string | undefined;
    reactField?: string | undefined;
    reason?: string | undefined;
}

export class OlmSelectivityAccessFailure extends ValidationFailure implements IOlmSelectivityAccessFailure {

    constructor(data?: IOlmSelectivityAccessFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmSelectivityAccessFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmSelectivityAccessFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmSelectivityAccessFailure extends IValidationFailure {
}

export class OlmSelectivityIsRequiredFailure extends ValidationFailure implements IOlmSelectivityIsRequiredFailure {

    constructor(data?: IOlmSelectivityIsRequiredFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmSelectivityIsRequiredFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmSelectivityIsRequiredFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmSelectivityIsRequiredFailure extends IValidationFailure {
}

export class OlmSelectivityNameFailure extends ValidationFailure implements IOlmSelectivityNameFailure {

    constructor(data?: IOlmSelectivityNameFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmSelectivityNameFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmSelectivityNameFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmSelectivityNameFailure extends IValidationFailure {
}

export class OlmSelectivityCriteriaCountFailure extends ValidationFailure implements IOlmSelectivityCriteriaCountFailure {

    constructor(data?: IOlmSelectivityCriteriaCountFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmSelectivityCriteriaCountFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmSelectivityCriteriaCountFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmSelectivityCriteriaCountFailure extends IValidationFailure {
}

export class OlmSelectivityCriteriaFailure extends ValidationFailure implements IOlmSelectivityCriteriaFailure {

    constructor(data?: IOlmSelectivityCriteriaFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmSelectivityCriteriaFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmSelectivityCriteriaFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmSelectivityCriteriaFailure extends IValidationFailure {
}

export abstract class OlmSelectivityCriterionFailure extends ValidationFailure implements IOlmSelectivityCriterionFailure {
    criterionSequence!: number;

    constructor(data?: IOlmSelectivityCriterionFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.criterionSequence = _data["criterionSequence"];
        }
    }

    static override fromJS(data: any): OlmSelectivityCriterionFailure {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'OlmSelectivityCriterionFailure' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["criterionSequence"] = this.criterionSequence;
        super.toJSON(data);
        return data;
    }
}

export interface IOlmSelectivityCriterionFailure extends IValidationFailure {
    criterionSequence: number;
}

export class OlmSelectivityCriterionValuesCountFailure extends OlmSelectivityCriterionFailure implements IOlmSelectivityCriterionValuesCountFailure {

    constructor(data?: IOlmSelectivityCriterionValuesCountFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmSelectivityCriterionValuesCountFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmSelectivityCriterionValuesCountFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmSelectivityCriterionValuesCountFailure extends IOlmSelectivityCriterionFailure {
}

export class OlmSelectivityCriterionFieldFailure extends OlmSelectivityCriterionFailure implements IOlmSelectivityCriterionFieldFailure {

    constructor(data?: IOlmSelectivityCriterionFieldFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmSelectivityCriterionFieldFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmSelectivityCriterionFieldFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmSelectivityCriterionFieldFailure extends IOlmSelectivityCriterionFailure {
}

export class OlmSelectivityCriterionExtendedFieldSequenceFailure extends OlmSelectivityCriterionFailure implements IOlmSelectivityCriterionExtendedFieldSequenceFailure {

    constructor(data?: IOlmSelectivityCriterionExtendedFieldSequenceFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmSelectivityCriterionExtendedFieldSequenceFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmSelectivityCriterionExtendedFieldSequenceFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmSelectivityCriterionExtendedFieldSequenceFailure extends IOlmSelectivityCriterionFailure {
}

export class OlmSelectivityCriterionOperandFailure extends OlmSelectivityCriterionFailure implements IOlmSelectivityCriterionOperandFailure {

    constructor(data?: IOlmSelectivityCriterionOperandFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmSelectivityCriterionOperandFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmSelectivityCriterionOperandFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmSelectivityCriterionOperandFailure extends IOlmSelectivityCriterionFailure {
}

export class OlmSelectivityCriterionValuesRelationshipFailure extends OlmSelectivityCriterionFailure implements IOlmSelectivityCriterionValuesRelationshipFailure {

    constructor(data?: IOlmSelectivityCriterionValuesRelationshipFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmSelectivityCriterionValuesRelationshipFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmSelectivityCriterionValuesRelationshipFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmSelectivityCriterionValuesRelationshipFailure extends IOlmSelectivityCriterionFailure {
}

export class OlmSelectivityCriterionValueFailure extends OlmSelectivityCriterionFailure implements IOlmSelectivityCriterionValueFailure {
    criterionValueSequence!: number;

    constructor(data?: IOlmSelectivityCriterionValueFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.criterionValueSequence = _data["criterionValueSequence"];
        }
    }

    static override fromJS(data: any): OlmSelectivityCriterionValueFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmSelectivityCriterionValueFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["criterionValueSequence"] = this.criterionValueSequence;
        super.toJSON(data);
        return data;
    }
}

export interface IOlmSelectivityCriterionValueFailure extends IOlmSelectivityCriterionFailure {
    criterionValueSequence: number;
}

export abstract class OlmSelectivityEvaluationFailure extends OlmSelectivityCriterionFailure implements IOlmSelectivityEvaluationFailure {
    criterionValueSequence?: number | undefined;

    constructor(data?: IOlmSelectivityEvaluationFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.criterionValueSequence = _data["criterionValueSequence"];
        }
    }

    static override fromJS(data: any): OlmSelectivityEvaluationFailure {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'OlmSelectivityEvaluationFailure' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["criterionValueSequence"] = this.criterionValueSequence;
        super.toJSON(data);
        return data;
    }
}

export interface IOlmSelectivityEvaluationFailure extends IOlmSelectivityCriterionFailure {
    criterionValueSequence?: number | undefined;
}

export class OlmSelectivityEvaluationNeverMatchesFailure extends OlmSelectivityEvaluationFailure implements IOlmSelectivityEvaluationNeverMatchesFailure {

    constructor(data?: IOlmSelectivityEvaluationNeverMatchesFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmSelectivityEvaluationNeverMatchesFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmSelectivityEvaluationNeverMatchesFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmSelectivityEvaluationNeverMatchesFailure extends IOlmSelectivityEvaluationFailure {
}

export class OlmSelectivityEvaluationAlwaysMatchesFailure extends OlmSelectivityEvaluationFailure implements IOlmSelectivityEvaluationAlwaysMatchesFailure {

    constructor(data?: IOlmSelectivityEvaluationAlwaysMatchesFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmSelectivityEvaluationAlwaysMatchesFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmSelectivityEvaluationAlwaysMatchesFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmSelectivityEvaluationAlwaysMatchesFailure extends IOlmSelectivityEvaluationFailure {
}

export class OlmSelectivityCriterionCombinedGroupIdFailure extends OlmSelectivityCriterionFailure implements IOlmSelectivityCriterionCombinedGroupIdFailure {

    constructor(data?: IOlmSelectivityCriterionCombinedGroupIdFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmSelectivityCriterionCombinedGroupIdFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmSelectivityCriterionCombinedGroupIdFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmSelectivityCriterionCombinedGroupIdFailure extends IOlmSelectivityCriterionFailure {
}

export class OlmSelectivityCriterionCombinationFailure extends OlmSelectivityCriterionFailure implements IOlmSelectivityCriterionCombinationFailure {

    constructor(data?: IOlmSelectivityCriterionCombinationFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmSelectivityCriterionCombinationFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmSelectivityCriterionCombinationFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmSelectivityCriterionCombinationFailure extends IOlmSelectivityCriterionFailure {
}

export class OlmSelectivityCriterionNextCriterionRelationshipFailure extends OlmSelectivityCriterionFailure implements IOlmSelectivityCriterionNextCriterionRelationshipFailure {

    constructor(data?: IOlmSelectivityCriterionNextCriterionRelationshipFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmSelectivityCriterionNextCriterionRelationshipFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmSelectivityCriterionNextCriterionRelationshipFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmSelectivityCriterionNextCriterionRelationshipFailure extends IOlmSelectivityCriterionFailure {
}

export class OlmSelectivityCriterionNotesFailure extends OlmSelectivityCriterionFailure implements IOlmSelectivityCriterionNotesFailure {

    constructor(data?: IOlmSelectivityCriterionNotesFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmSelectivityCriterionNotesFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmSelectivityCriterionNotesFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmSelectivityCriterionNotesFailure extends IOlmSelectivityCriterionFailure {
}

export class OlmSelectivityCriterionLogicalBlockIdFailure extends OlmSelectivityCriterionFailure implements IOlmSelectivityCriterionLogicalBlockIdFailure {

    constructor(data?: IOlmSelectivityCriterionLogicalBlockIdFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmSelectivityCriterionLogicalBlockIdFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmSelectivityCriterionLogicalBlockIdFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmSelectivityCriterionLogicalBlockIdFailure extends IOlmSelectivityCriterionFailure {
}

export class OlmSelectivityHighestRecordedLogicalBlockIdFailure extends ValidationFailure implements IOlmSelectivityHighestRecordedLogicalBlockIdFailure {

    constructor(data?: IOlmSelectivityHighestRecordedLogicalBlockIdFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmSelectivityHighestRecordedLogicalBlockIdFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmSelectivityHighestRecordedLogicalBlockIdFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmSelectivityHighestRecordedLogicalBlockIdFailure extends IValidationFailure {
}

export class Exception implements IException {
    targetSite?: MethodBase | undefined;
    message!: string;
    data!: Data[];
    innerException?: Exception | undefined;
    helpLink?: string | undefined;
    source?: string | undefined;
    hResult!: number;
    stackTrace?: string | undefined;

    constructor(data?: IException) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetSite = _data["targetSite"] ? MethodBase.fromJS(_data["targetSite"]) : <any>undefined;
            this.message = _data["message"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(item);
            }
            this.innerException = _data["innerException"] ? Exception.fromJS(_data["innerException"]) : <any>undefined;
            this.helpLink = _data["helpLink"];
            this.source = _data["source"];
            this.hResult = _data["hResult"];
            this.stackTrace = _data["stackTrace"];
        }
    }

    static fromJS(data: any): Exception {
        data = typeof data === 'object' ? data : {};
        let result = new Exception();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetSite"] = this.targetSite ? this.targetSite.toJSON() : <any>undefined;
        data["message"] = this.message;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        data["innerException"] = this.innerException ? this.innerException.toJSON() : <any>undefined;
        data["helpLink"] = this.helpLink;
        data["source"] = this.source;
        data["hResult"] = this.hResult;
        data["stackTrace"] = this.stackTrace;
        return data;
    }
}

export interface IException {
    targetSite?: MethodBase | undefined;
    message: string;
    data: Data[];
    innerException?: Exception | undefined;
    helpLink?: string | undefined;
    source?: string | undefined;
    hResult: number;
    stackTrace?: string | undefined;
}

export class PdfPreviewException extends Exception implements IPdfPreviewException {
    errorId?: number | undefined;
    olmMessageTextLanguage?: string | undefined;
    errorAdditionalDetails?: string | undefined;

    constructor(data?: IPdfPreviewException) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.errorId = _data["errorId"];
            this.olmMessageTextLanguage = _data["olmMessageTextLanguage"];
            this.errorAdditionalDetails = _data["errorAdditionalDetails"];
        }
    }

    static override fromJS(data: any): PdfPreviewException {
        data = typeof data === 'object' ? data : {};
        let result = new PdfPreviewException();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorId"] = this.errorId;
        data["olmMessageTextLanguage"] = this.olmMessageTextLanguage;
        data["errorAdditionalDetails"] = this.errorAdditionalDetails;
        super.toJSON(data);
        return data;
    }
}

export interface IPdfPreviewException extends IException {
    errorId?: number | undefined;
    olmMessageTextLanguage?: string | undefined;
    errorAdditionalDetails?: string | undefined;
}

export abstract class MemberInfo implements IMemberInfo {
    memberType!: MemberTypes;
    name!: string;
    declaringType?: string | undefined;
    reflectedType?: string | undefined;
    module!: Module;
    customAttributes!: CustomAttributeData[];
    isCollectible!: boolean;
    metadataToken!: number;

    constructor(data?: IMemberInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.customAttributes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberType = _data["memberType"];
            this.name = _data["name"];
            this.declaringType = _data["declaringType"];
            this.reflectedType = _data["reflectedType"];
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                this.customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    this.customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            this.isCollectible = _data["isCollectible"];
            this.metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): MemberInfo {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MemberInfo' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["name"] = this.name;
        data["declaringType"] = this.declaringType;
        data["reflectedType"] = this.reflectedType;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IMemberInfo {
    memberType: MemberTypes;
    name: string;
    declaringType?: string | undefined;
    reflectedType?: string | undefined;
    module: Module;
    customAttributes: CustomAttributeData[];
    isCollectible: boolean;
    metadataToken: number;
}

export abstract class MethodBase extends MemberInfo implements IMethodBase {
    attributes!: MethodAttributes;
    methodImplementationFlags!: MethodImplAttributes;
    callingConvention!: CallingConventions;
    isAbstract!: boolean;
    isConstructor!: boolean;
    isFinal!: boolean;
    isHideBySig!: boolean;
    isSpecialName!: boolean;
    isStatic!: boolean;
    isVirtual!: boolean;
    isAssembly!: boolean;
    isFamily!: boolean;
    isFamilyAndAssembly!: boolean;
    isFamilyOrAssembly!: boolean;
    isPrivate!: boolean;
    isPublic!: boolean;
    isConstructedGenericMethod!: boolean;
    isGenericMethod!: boolean;
    isGenericMethodDefinition!: boolean;
    containsGenericParameters!: boolean;
    methodHandle!: RuntimeMethodHandle;
    isSecurityCritical!: boolean;
    isSecuritySafeCritical!: boolean;
    isSecurityTransparent!: boolean;

    constructor(data?: IMethodBase) {
        super(data);
        if (!data) {
            this.methodHandle = new RuntimeMethodHandle();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.attributes = _data["attributes"];
            this.methodImplementationFlags = _data["methodImplementationFlags"];
            this.callingConvention = _data["callingConvention"];
            this.isAbstract = _data["isAbstract"];
            this.isConstructor = _data["isConstructor"];
            this.isFinal = _data["isFinal"];
            this.isHideBySig = _data["isHideBySig"];
            this.isSpecialName = _data["isSpecialName"];
            this.isStatic = _data["isStatic"];
            this.isVirtual = _data["isVirtual"];
            this.isAssembly = _data["isAssembly"];
            this.isFamily = _data["isFamily"];
            this.isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            this.isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            this.isPrivate = _data["isPrivate"];
            this.isPublic = _data["isPublic"];
            this.isConstructedGenericMethod = _data["isConstructedGenericMethod"];
            this.isGenericMethod = _data["isGenericMethod"];
            this.isGenericMethodDefinition = _data["isGenericMethodDefinition"];
            this.containsGenericParameters = _data["containsGenericParameters"];
            this.methodHandle = _data["methodHandle"] ? RuntimeMethodHandle.fromJS(_data["methodHandle"]) : new RuntimeMethodHandle();
            this.isSecurityCritical = _data["isSecurityCritical"];
            this.isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            this.isSecurityTransparent = _data["isSecurityTransparent"];
        }
    }

    static override fromJS(data: any): MethodBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MethodBase' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributes"] = this.attributes;
        data["methodImplementationFlags"] = this.methodImplementationFlags;
        data["callingConvention"] = this.callingConvention;
        data["isAbstract"] = this.isAbstract;
        data["isConstructor"] = this.isConstructor;
        data["isFinal"] = this.isFinal;
        data["isHideBySig"] = this.isHideBySig;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isVirtual"] = this.isVirtual;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod;
        data["isGenericMethod"] = this.isGenericMethod;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["methodHandle"] = this.methodHandle ? this.methodHandle.toJSON() : <any>undefined;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        super.toJSON(data);
        return data;
    }
}

export interface IMethodBase extends IMemberInfo {
    attributes: MethodAttributes;
    methodImplementationFlags: MethodImplAttributes;
    callingConvention: CallingConventions;
    isAbstract: boolean;
    isConstructor: boolean;
    isFinal: boolean;
    isHideBySig: boolean;
    isSpecialName: boolean;
    isStatic: boolean;
    isVirtual: boolean;
    isAssembly: boolean;
    isFamily: boolean;
    isFamilyAndAssembly: boolean;
    isFamilyOrAssembly: boolean;
    isPrivate: boolean;
    isPublic: boolean;
    isConstructedGenericMethod: boolean;
    isGenericMethod: boolean;
    isGenericMethodDefinition: boolean;
    containsGenericParameters: boolean;
    methodHandle: RuntimeMethodHandle;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
}

export enum MethodAttributes {
    PrivateScope = 0,
    ReuseSlot = 0,
    Private = 1,
    FamANDAssem = 2,
    Assembly = 3,
    Family = 4,
    FamORAssem = 5,
    Public = 6,
    MemberAccessMask = 7,
    UnmanagedExport = 8,
    Static = 16,
    Final = 32,
    Virtual = 64,
    HideBySig = 128,
    NewSlot = 256,
    VtableLayoutMask = 256,
    CheckAccessOnOverride = 512,
    Abstract = 1024,
    SpecialName = 2048,
    RTSpecialName = 4096,
    PinvokeImpl = 8192,
    HasSecurity = 16384,
    RequireSecObject = 32768,
    ReservedMask = 53248,
}

export enum MethodImplAttributes {
    IL = 0,
    Managed = 0,
    Native = 1,
    OPTIL = 2,
    CodeTypeMask = 3,
    Runtime = 3,
    ManagedMask = 4,
    Unmanaged = 4,
    NoInlining = 8,
    ForwardRef = 16,
    Synchronized = 32,
    NoOptimization = 64,
    PreserveSig = 128,
    AggressiveInlining = 256,
    AggressiveOptimization = 512,
    InternalCall = 4096,
    MaxMethodImplVal = 65535,
}

export enum CallingConventions {
    Standard = 1,
    VarArgs = 2,
    Any = 3,
    HasThis = 32,
    ExplicitThis = 64,
}

export class RuntimeMethodHandle implements IRuntimeMethodHandle {
    value!: IntPtr;

    constructor(data?: IRuntimeMethodHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.value = new IntPtr();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? IntPtr.fromJS(_data["value"]) : new IntPtr();
        }
    }

    static fromJS(data: any): RuntimeMethodHandle {
        data = typeof data === 'object' ? data : {};
        let result = new RuntimeMethodHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRuntimeMethodHandle {
    value: IntPtr;
}

export class IntPtr implements IIntPtr {

    constructor(data?: IIntPtr) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IntPtr {
        data = typeof data === 'object' ? data : {};
        let result = new IntPtr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IIntPtr {
}

export enum MemberTypes {
    Constructor = 1,
    Event = 2,
    Field = 4,
    Method = 8,
    Property = 16,
    TypeInfo = 32,
    Custom = 64,
    NestedType = 128,
    All = 191,
}

export abstract class Module implements IModule {
    assembly!: Assembly;
    fullyQualifiedName!: string;
    name!: string;
    mdStreamVersion!: number;
    moduleVersionId!: string;
    scopeName!: string;
    moduleHandle!: ModuleHandle;
    customAttributes!: CustomAttributeData[];
    metadataToken!: number;

    constructor(data?: IModule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.moduleHandle = new ModuleHandle();
            this.customAttributes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assembly = _data["assembly"] ? Assembly.fromJS(_data["assembly"]) : <any>undefined;
            this.fullyQualifiedName = _data["fullyQualifiedName"];
            this.name = _data["name"];
            this.mdStreamVersion = _data["mdStreamVersion"];
            this.moduleVersionId = _data["moduleVersionId"];
            this.scopeName = _data["scopeName"];
            this.moduleHandle = _data["moduleHandle"] ? ModuleHandle.fromJS(_data["moduleHandle"]) : new ModuleHandle();
            if (Array.isArray(_data["customAttributes"])) {
                this.customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    this.customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            this.metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): Module {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'Module' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assembly"] = this.assembly ? this.assembly.toJSON() : <any>undefined;
        data["fullyQualifiedName"] = this.fullyQualifiedName;
        data["name"] = this.name;
        data["mdStreamVersion"] = this.mdStreamVersion;
        data["moduleVersionId"] = this.moduleVersionId;
        data["scopeName"] = this.scopeName;
        data["moduleHandle"] = this.moduleHandle ? this.moduleHandle.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IModule {
    assembly: Assembly;
    fullyQualifiedName: string;
    name: string;
    mdStreamVersion: number;
    moduleVersionId: string;
    scopeName: string;
    moduleHandle: ModuleHandle;
    customAttributes: CustomAttributeData[];
    metadataToken: number;
}

export abstract class Assembly implements IAssembly {
    definedTypes!: TypeInfo[];
    exportedTypes!: string[];
    codeBase?: string | undefined;
    entryPoint?: MethodInfo | undefined;
    fullName?: string | undefined;
    imageRuntimeVersion!: string;
    isDynamic!: boolean;
    location!: string;
    reflectionOnly!: boolean;
    isCollectible!: boolean;
    isFullyTrusted!: boolean;
    customAttributes!: CustomAttributeData[];
    escapedCodeBase!: string;
    manifestModule!: Module;
    modules!: Module[];
    globalAssemblyCache!: boolean;
    hostContext!: number;
    securityRuleSet!: SecurityRuleSet;

    constructor(data?: IAssembly) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.definedTypes = [];
            this.exportedTypes = [];
            this.customAttributes = [];
            this.modules = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["definedTypes"])) {
                this.definedTypes = [] as any;
                for (let item of _data["definedTypes"])
                    this.definedTypes!.push(TypeInfo.fromJS(item));
            }
            if (Array.isArray(_data["exportedTypes"])) {
                this.exportedTypes = [] as any;
                for (let item of _data["exportedTypes"])
                    this.exportedTypes!.push(item);
            }
            this.codeBase = _data["codeBase"];
            this.entryPoint = _data["entryPoint"] ? MethodInfo.fromJS(_data["entryPoint"]) : <any>undefined;
            this.fullName = _data["fullName"];
            this.imageRuntimeVersion = _data["imageRuntimeVersion"];
            this.isDynamic = _data["isDynamic"];
            this.location = _data["location"];
            this.reflectionOnly = _data["reflectionOnly"];
            this.isCollectible = _data["isCollectible"];
            this.isFullyTrusted = _data["isFullyTrusted"];
            if (Array.isArray(_data["customAttributes"])) {
                this.customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    this.customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            this.escapedCodeBase = _data["escapedCodeBase"];
            this.manifestModule = _data["manifestModule"] ? Module.fromJS(_data["manifestModule"]) : <any>undefined;
            if (Array.isArray(_data["modules"])) {
                this.modules = [] as any;
                for (let item of _data["modules"])
                    this.modules!.push(Module.fromJS(item));
            }
            this.globalAssemblyCache = _data["globalAssemblyCache"];
            this.hostContext = _data["hostContext"];
            this.securityRuleSet = _data["securityRuleSet"];
        }
    }

    static fromJS(data: any): Assembly {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'Assembly' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.definedTypes)) {
            data["definedTypes"] = [];
            for (let item of this.definedTypes)
                data["definedTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.exportedTypes)) {
            data["exportedTypes"] = [];
            for (let item of this.exportedTypes)
                data["exportedTypes"].push(item);
        }
        data["codeBase"] = this.codeBase;
        data["entryPoint"] = this.entryPoint ? this.entryPoint.toJSON() : <any>undefined;
        data["fullName"] = this.fullName;
        data["imageRuntimeVersion"] = this.imageRuntimeVersion;
        data["isDynamic"] = this.isDynamic;
        data["location"] = this.location;
        data["reflectionOnly"] = this.reflectionOnly;
        data["isCollectible"] = this.isCollectible;
        data["isFullyTrusted"] = this.isFullyTrusted;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["escapedCodeBase"] = this.escapedCodeBase;
        data["manifestModule"] = this.manifestModule ? this.manifestModule.toJSON() : <any>undefined;
        if (Array.isArray(this.modules)) {
            data["modules"] = [];
            for (let item of this.modules)
                data["modules"].push(item.toJSON());
        }
        data["globalAssemblyCache"] = this.globalAssemblyCache;
        data["hostContext"] = this.hostContext;
        data["securityRuleSet"] = this.securityRuleSet;
        return data;
    }
}

export interface IAssembly {
    definedTypes: TypeInfo[];
    exportedTypes: string[];
    codeBase?: string | undefined;
    entryPoint?: MethodInfo | undefined;
    fullName?: string | undefined;
    imageRuntimeVersion: string;
    isDynamic: boolean;
    location: string;
    reflectionOnly: boolean;
    isCollectible: boolean;
    isFullyTrusted: boolean;
    customAttributes: CustomAttributeData[];
    escapedCodeBase: string;
    manifestModule: Module;
    modules: Module[];
    globalAssemblyCache: boolean;
    hostContext: number;
    securityRuleSet: SecurityRuleSet;
}

export abstract class Anonymous4 implements IAnonymous4 {
    genericTypeParameters!: string[];
    declaredConstructors!: ConstructorInfo[];
    declaredEvents!: EventInfo[];
    declaredFields!: FieldInfo[];
    declaredMembers!: MemberInfo[];
    declaredMethods!: MethodInfo[];
    declaredNestedTypes!: TypeInfo[];
    declaredProperties!: PropertyInfo[];
    implementedInterfaces!: string[];

    constructor(data?: IAnonymous4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.genericTypeParameters = [];
            this.declaredConstructors = [];
            this.declaredEvents = [];
            this.declaredFields = [];
            this.declaredMembers = [];
            this.declaredMethods = [];
            this.declaredNestedTypes = [];
            this.declaredProperties = [];
            this.implementedInterfaces = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["genericTypeParameters"])) {
                this.genericTypeParameters = [] as any;
                for (let item of _data["genericTypeParameters"])
                    this.genericTypeParameters!.push(item);
            }
            if (Array.isArray(_data["declaredConstructors"])) {
                this.declaredConstructors = [] as any;
                for (let item of _data["declaredConstructors"])
                    this.declaredConstructors!.push(ConstructorInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredEvents"])) {
                this.declaredEvents = [] as any;
                for (let item of _data["declaredEvents"])
                    this.declaredEvents!.push(EventInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredFields"])) {
                this.declaredFields = [] as any;
                for (let item of _data["declaredFields"])
                    this.declaredFields!.push(FieldInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredMembers"])) {
                this.declaredMembers = [] as any;
                for (let item of _data["declaredMembers"])
                    this.declaredMembers!.push(MemberInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredMethods"])) {
                this.declaredMethods = [] as any;
                for (let item of _data["declaredMethods"])
                    this.declaredMethods!.push(MethodInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredNestedTypes"])) {
                this.declaredNestedTypes = [] as any;
                for (let item of _data["declaredNestedTypes"])
                    this.declaredNestedTypes!.push(TypeInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredProperties"])) {
                this.declaredProperties = [] as any;
                for (let item of _data["declaredProperties"])
                    this.declaredProperties!.push(PropertyInfo.fromJS(item));
            }
            if (Array.isArray(_data["implementedInterfaces"])) {
                this.implementedInterfaces = [] as any;
                for (let item of _data["implementedInterfaces"])
                    this.implementedInterfaces!.push(item);
            }
        }
    }

    static fromJS(data: any): Anonymous4 {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'Anonymous4' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.genericTypeParameters)) {
            data["genericTypeParameters"] = [];
            for (let item of this.genericTypeParameters)
                data["genericTypeParameters"].push(item);
        }
        if (Array.isArray(this.declaredConstructors)) {
            data["declaredConstructors"] = [];
            for (let item of this.declaredConstructors)
                data["declaredConstructors"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredEvents)) {
            data["declaredEvents"] = [];
            for (let item of this.declaredEvents)
                data["declaredEvents"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredFields)) {
            data["declaredFields"] = [];
            for (let item of this.declaredFields)
                data["declaredFields"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredMembers)) {
            data["declaredMembers"] = [];
            for (let item of this.declaredMembers)
                data["declaredMembers"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredMethods)) {
            data["declaredMethods"] = [];
            for (let item of this.declaredMethods)
                data["declaredMethods"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredNestedTypes)) {
            data["declaredNestedTypes"] = [];
            for (let item of this.declaredNestedTypes)
                data["declaredNestedTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredProperties)) {
            data["declaredProperties"] = [];
            for (let item of this.declaredProperties)
                data["declaredProperties"].push(item.toJSON());
        }
        if (Array.isArray(this.implementedInterfaces)) {
            data["implementedInterfaces"] = [];
            for (let item of this.implementedInterfaces)
                data["implementedInterfaces"].push(item);
        }
        return data;
    }
}

export interface IAnonymous4 {
    genericTypeParameters: string[];
    declaredConstructors: ConstructorInfo[];
    declaredEvents: EventInfo[];
    declaredFields: FieldInfo[];
    declaredMembers: MemberInfo[];
    declaredMethods: MethodInfo[];
    declaredNestedTypes: TypeInfo[];
    declaredProperties: PropertyInfo[];
    implementedInterfaces: string[];
}

export class TypeInfo extends Anonymous4 implements ITypeInfo {

    constructor(data?: ITypeInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): TypeInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TypeInfo();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ITypeInfo extends IAnonymous4 {
}

export abstract class ConstructorInfo extends MethodBase implements IConstructorInfo {
    memberType!: MemberTypes;

    constructor(data?: IConstructorInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.memberType = _data["memberType"];
        }
    }

    static override fromJS(data: any): ConstructorInfo {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ConstructorInfo' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        super.toJSON(data);
        return data;
    }
}

export interface IConstructorInfo extends IMethodBase {
    memberType: MemberTypes;
}

export abstract class EventInfo extends MemberInfo implements IEventInfo {
    memberType!: MemberTypes;
    attributes!: EventAttributes;
    isSpecialName!: boolean;
    addMethod?: MethodInfo | undefined;
    removeMethod?: MethodInfo | undefined;
    raiseMethod?: MethodInfo | undefined;
    isMulticast!: boolean;
    eventHandlerType?: string | undefined;

    constructor(data?: IEventInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.memberType = _data["memberType"];
            this.attributes = _data["attributes"];
            this.isSpecialName = _data["isSpecialName"];
            this.addMethod = _data["addMethod"] ? MethodInfo.fromJS(_data["addMethod"]) : <any>undefined;
            this.removeMethod = _data["removeMethod"] ? MethodInfo.fromJS(_data["removeMethod"]) : <any>undefined;
            this.raiseMethod = _data["raiseMethod"] ? MethodInfo.fromJS(_data["raiseMethod"]) : <any>undefined;
            this.isMulticast = _data["isMulticast"];
            this.eventHandlerType = _data["eventHandlerType"];
        }
    }

    static override fromJS(data: any): EventInfo {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'EventInfo' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["attributes"] = this.attributes;
        data["isSpecialName"] = this.isSpecialName;
        data["addMethod"] = this.addMethod ? this.addMethod.toJSON() : <any>undefined;
        data["removeMethod"] = this.removeMethod ? this.removeMethod.toJSON() : <any>undefined;
        data["raiseMethod"] = this.raiseMethod ? this.raiseMethod.toJSON() : <any>undefined;
        data["isMulticast"] = this.isMulticast;
        data["eventHandlerType"] = this.eventHandlerType;
        super.toJSON(data);
        return data;
    }
}

export interface IEventInfo extends IMemberInfo {
    memberType: MemberTypes;
    attributes: EventAttributes;
    isSpecialName: boolean;
    addMethod?: MethodInfo | undefined;
    removeMethod?: MethodInfo | undefined;
    raiseMethod?: MethodInfo | undefined;
    isMulticast: boolean;
    eventHandlerType?: string | undefined;
}

export enum EventAttributes {
    None = 0,
    SpecialName = 512,
    RTSpecialName = 1024,
    ReservedMask = 1024,
}

export abstract class MethodInfo extends MethodBase implements IMethodInfo {
    memberType!: MemberTypes;
    returnParameter!: ParameterInfo;
    returnType!: string;
    returnTypeCustomAttributes!: ICustomAttributeProvider;
    genericParameterCount!: number;

    constructor(data?: IMethodInfo) {
        super(data);
        if (!data) {
            this.returnParameter = new ParameterInfo();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.memberType = _data["memberType"];
            this.returnParameter = _data["returnParameter"] ? ParameterInfo.fromJS(_data["returnParameter"]) : new ParameterInfo();
            this.returnType = _data["returnType"];
            this.returnTypeCustomAttributes = _data["returnTypeCustomAttributes"] ? ICustomAttributeProvider.fromJS(_data["returnTypeCustomAttributes"]) : <any>undefined;
            this.genericParameterCount = _data["genericParameterCount"];
        }
    }

    static override fromJS(data: any): MethodInfo {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MethodInfo' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["returnParameter"] = this.returnParameter ? this.returnParameter.toJSON() : <any>undefined;
        data["returnType"] = this.returnType;
        data["returnTypeCustomAttributes"] = this.returnTypeCustomAttributes ? this.returnTypeCustomAttributes.toJSON() : <any>undefined;
        data["genericParameterCount"] = this.genericParameterCount;
        super.toJSON(data);
        return data;
    }
}

export interface IMethodInfo extends IMethodBase {
    memberType: MemberTypes;
    returnParameter: ParameterInfo;
    returnType: string;
    returnTypeCustomAttributes: ICustomAttributeProvider;
    genericParameterCount: number;
}

export class ParameterInfo implements IParameterInfo {
    attributes!: ParameterAttributes;
    member!: MemberInfo;
    name?: string | undefined;
    parameterType!: string;
    position!: number;
    isIn!: boolean;
    isLcid!: boolean;
    isOptional!: boolean;
    isOut!: boolean;
    isRetval!: boolean;
    defaultValue?: any | undefined;
    rawDefaultValue?: any | undefined;
    hasDefaultValue!: boolean;
    customAttributes!: CustomAttributeData[];
    metadataToken!: number;

    constructor(data?: IParameterInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.customAttributes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributes = _data["attributes"];
            this.member = _data["member"] ? MemberInfo.fromJS(_data["member"]) : <any>undefined;
            this.name = _data["name"];
            this.parameterType = _data["parameterType"];
            this.position = _data["position"];
            this.isIn = _data["isIn"];
            this.isLcid = _data["isLcid"];
            this.isOptional = _data["isOptional"];
            this.isOut = _data["isOut"];
            this.isRetval = _data["isRetval"];
            this.defaultValue = _data["defaultValue"];
            this.rawDefaultValue = _data["rawDefaultValue"];
            this.hasDefaultValue = _data["hasDefaultValue"];
            if (Array.isArray(_data["customAttributes"])) {
                this.customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    this.customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            this.metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): ParameterInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributes"] = this.attributes;
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["parameterType"] = this.parameterType;
        data["position"] = this.position;
        data["isIn"] = this.isIn;
        data["isLcid"] = this.isLcid;
        data["isOptional"] = this.isOptional;
        data["isOut"] = this.isOut;
        data["isRetval"] = this.isRetval;
        data["defaultValue"] = this.defaultValue;
        data["rawDefaultValue"] = this.rawDefaultValue;
        data["hasDefaultValue"] = this.hasDefaultValue;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IParameterInfo {
    attributes: ParameterAttributes;
    member: MemberInfo;
    name?: string | undefined;
    parameterType: string;
    position: number;
    isIn: boolean;
    isLcid: boolean;
    isOptional: boolean;
    isOut: boolean;
    isRetval: boolean;
    defaultValue?: any | undefined;
    rawDefaultValue?: any | undefined;
    hasDefaultValue: boolean;
    customAttributes: CustomAttributeData[];
    metadataToken: number;
}

export enum ParameterAttributes {
    None = 0,
    In = 1,
    Out = 2,
    Lcid = 4,
    Retval = 8,
    Optional = 16,
    HasDefault = 4096,
    HasFieldMarshal = 8192,
    Reserved3 = 16384,
    Reserved4 = 32768,
    ReservedMask = 61440,
}

export class CustomAttributeData implements ICustomAttributeData {
    attributeType!: string;
    constructor_!: ConstructorInfo;
    constructorArguments!: CustomAttributeTypedArgument[];
    namedArguments!: CustomAttributeNamedArgument[];

    constructor(data?: ICustomAttributeData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.constructorArguments = [];
            this.namedArguments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributeType = _data["attributeType"];
            this.constructor_ = _data["constructor"] ? ConstructorInfo.fromJS(_data["constructor"]) : <any>undefined;
            if (Array.isArray(_data["constructorArguments"])) {
                this.constructorArguments = [] as any;
                for (let item of _data["constructorArguments"])
                    this.constructorArguments!.push(CustomAttributeTypedArgument.fromJS(item));
            }
            if (Array.isArray(_data["namedArguments"])) {
                this.namedArguments = [] as any;
                for (let item of _data["namedArguments"])
                    this.namedArguments!.push(CustomAttributeNamedArgument.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomAttributeData {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributeType"] = this.attributeType;
        data["constructor"] = this.constructor_ ? this.constructor_.toJSON() : <any>undefined;
        if (Array.isArray(this.constructorArguments)) {
            data["constructorArguments"] = [];
            for (let item of this.constructorArguments)
                data["constructorArguments"].push(item.toJSON());
        }
        if (Array.isArray(this.namedArguments)) {
            data["namedArguments"] = [];
            for (let item of this.namedArguments)
                data["namedArguments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomAttributeData {
    attributeType: string;
    constructor_: ConstructorInfo;
    constructorArguments: CustomAttributeTypedArgument[];
    namedArguments: CustomAttributeNamedArgument[];
}

export class CustomAttributeTypedArgument implements ICustomAttributeTypedArgument {
    argumentType!: string;
    value?: any | undefined;

    constructor(data?: ICustomAttributeTypedArgument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.argumentType = _data["argumentType"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CustomAttributeTypedArgument {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeTypedArgument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["argumentType"] = this.argumentType;
        data["value"] = this.value;
        return data;
    }
}

export interface ICustomAttributeTypedArgument {
    argumentType: string;
    value?: any | undefined;
}

export class CustomAttributeNamedArgument implements ICustomAttributeNamedArgument {
    argumentType!: string;
    memberInfo!: MemberInfo;
    typedValue!: CustomAttributeTypedArgument;
    memberName!: string;
    isField!: boolean;

    constructor(data?: ICustomAttributeNamedArgument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.typedValue = new CustomAttributeTypedArgument();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.argumentType = _data["argumentType"];
            this.memberInfo = _data["memberInfo"] ? MemberInfo.fromJS(_data["memberInfo"]) : <any>undefined;
            this.typedValue = _data["typedValue"] ? CustomAttributeTypedArgument.fromJS(_data["typedValue"]) : new CustomAttributeTypedArgument();
            this.memberName = _data["memberName"];
            this.isField = _data["isField"];
        }
    }

    static fromJS(data: any): CustomAttributeNamedArgument {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeNamedArgument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["argumentType"] = this.argumentType;
        data["memberInfo"] = this.memberInfo ? this.memberInfo.toJSON() : <any>undefined;
        data["typedValue"] = this.typedValue ? this.typedValue.toJSON() : <any>undefined;
        data["memberName"] = this.memberName;
        data["isField"] = this.isField;
        return data;
    }
}

export interface ICustomAttributeNamedArgument {
    argumentType: string;
    memberInfo: MemberInfo;
    typedValue: CustomAttributeTypedArgument;
    memberName: string;
    isField: boolean;
}

export abstract class ICustomAttributeProvider implements IICustomAttributeProvider {

    constructor(data?: IICustomAttributeProvider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ICustomAttributeProvider {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ICustomAttributeProvider' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IICustomAttributeProvider {
}

export abstract class FieldInfo extends MemberInfo implements IFieldInfo {
    memberType!: MemberTypes;
    attributes!: FieldAttributes;
    fieldType!: string;
    isInitOnly!: boolean;
    isLiteral!: boolean;
    isNotSerialized!: boolean;
    isPinvokeImpl!: boolean;
    isSpecialName!: boolean;
    isStatic!: boolean;
    isAssembly!: boolean;
    isFamily!: boolean;
    isFamilyAndAssembly!: boolean;
    isFamilyOrAssembly!: boolean;
    isPrivate!: boolean;
    isPublic!: boolean;
    isSecurityCritical!: boolean;
    isSecuritySafeCritical!: boolean;
    isSecurityTransparent!: boolean;
    fieldHandle!: RuntimeFieldHandle;

    constructor(data?: IFieldInfo) {
        super(data);
        if (!data) {
            this.fieldHandle = new RuntimeFieldHandle();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.memberType = _data["memberType"];
            this.attributes = _data["attributes"];
            this.fieldType = _data["fieldType"];
            this.isInitOnly = _data["isInitOnly"];
            this.isLiteral = _data["isLiteral"];
            this.isNotSerialized = _data["isNotSerialized"];
            this.isPinvokeImpl = _data["isPinvokeImpl"];
            this.isSpecialName = _data["isSpecialName"];
            this.isStatic = _data["isStatic"];
            this.isAssembly = _data["isAssembly"];
            this.isFamily = _data["isFamily"];
            this.isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            this.isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            this.isPrivate = _data["isPrivate"];
            this.isPublic = _data["isPublic"];
            this.isSecurityCritical = _data["isSecurityCritical"];
            this.isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            this.isSecurityTransparent = _data["isSecurityTransparent"];
            this.fieldHandle = _data["fieldHandle"] ? RuntimeFieldHandle.fromJS(_data["fieldHandle"]) : new RuntimeFieldHandle();
        }
    }

    static override fromJS(data: any): FieldInfo {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'FieldInfo' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["attributes"] = this.attributes;
        data["fieldType"] = this.fieldType;
        data["isInitOnly"] = this.isInitOnly;
        data["isLiteral"] = this.isLiteral;
        data["isNotSerialized"] = this.isNotSerialized;
        data["isPinvokeImpl"] = this.isPinvokeImpl;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["fieldHandle"] = this.fieldHandle ? this.fieldHandle.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFieldInfo extends IMemberInfo {
    memberType: MemberTypes;
    attributes: FieldAttributes;
    fieldType: string;
    isInitOnly: boolean;
    isLiteral: boolean;
    isNotSerialized: boolean;
    isPinvokeImpl: boolean;
    isSpecialName: boolean;
    isStatic: boolean;
    isAssembly: boolean;
    isFamily: boolean;
    isFamilyAndAssembly: boolean;
    isFamilyOrAssembly: boolean;
    isPrivate: boolean;
    isPublic: boolean;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
    fieldHandle: RuntimeFieldHandle;
}

export enum FieldAttributes {
    PrivateScope = 0,
    Private = 1,
    FamANDAssem = 2,
    Assembly = 3,
    Family = 4,
    FamORAssem = 5,
    Public = 6,
    FieldAccessMask = 7,
    Static = 16,
    InitOnly = 32,
    Literal = 64,
    NotSerialized = 128,
    HasFieldRVA = 256,
    SpecialName = 512,
    RTSpecialName = 1024,
    HasFieldMarshal = 4096,
    PinvokeImpl = 8192,
    HasDefault = 32768,
    ReservedMask = 38144,
}

export class RuntimeFieldHandle implements IRuntimeFieldHandle {
    value!: IntPtr;

    constructor(data?: IRuntimeFieldHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.value = new IntPtr();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? IntPtr.fromJS(_data["value"]) : new IntPtr();
        }
    }

    static fromJS(data: any): RuntimeFieldHandle {
        data = typeof data === 'object' ? data : {};
        let result = new RuntimeFieldHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRuntimeFieldHandle {
    value: IntPtr;
}

export abstract class PropertyInfo extends MemberInfo implements IPropertyInfo {
    memberType!: MemberTypes;
    propertyType!: string;
    attributes!: PropertyAttributes;
    isSpecialName!: boolean;
    canRead!: boolean;
    canWrite!: boolean;
    getMethod?: MethodInfo | undefined;
    setMethod?: MethodInfo | undefined;

    constructor(data?: IPropertyInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.memberType = _data["memberType"];
            this.propertyType = _data["propertyType"];
            this.attributes = _data["attributes"];
            this.isSpecialName = _data["isSpecialName"];
            this.canRead = _data["canRead"];
            this.canWrite = _data["canWrite"];
            this.getMethod = _data["getMethod"] ? MethodInfo.fromJS(_data["getMethod"]) : <any>undefined;
            this.setMethod = _data["setMethod"] ? MethodInfo.fromJS(_data["setMethod"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): PropertyInfo {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'PropertyInfo' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["propertyType"] = this.propertyType;
        data["attributes"] = this.attributes;
        data["isSpecialName"] = this.isSpecialName;
        data["canRead"] = this.canRead;
        data["canWrite"] = this.canWrite;
        data["getMethod"] = this.getMethod ? this.getMethod.toJSON() : <any>undefined;
        data["setMethod"] = this.setMethod ? this.setMethod.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPropertyInfo extends IMemberInfo {
    memberType: MemberTypes;
    propertyType: string;
    attributes: PropertyAttributes;
    isSpecialName: boolean;
    canRead: boolean;
    canWrite: boolean;
    getMethod?: MethodInfo | undefined;
    setMethod?: MethodInfo | undefined;
}

export enum PropertyAttributes {
    None = 0,
    SpecialName = 512,
    RTSpecialName = 1024,
    HasDefault = 4096,
    Reserved2 = 8192,
    Reserved3 = 16384,
    Reserved4 = 32768,
    ReservedMask = 62464,
}

export enum SecurityRuleSet {
    None = 0,
    Level1 = 1,
    Level2 = 2,
}

export class ModuleHandle implements IModuleHandle {
    mdStreamVersion!: number;

    constructor(data?: IModuleHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mdStreamVersion = _data["mdStreamVersion"];
        }
    }

    static fromJS(data: any): ModuleHandle {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mdStreamVersion"] = this.mdStreamVersion;
        return data;
    }
}

export interface IModuleHandle {
    mdStreamVersion: number;
}

export class OlmMessageAccessFailure extends ValidationFailure implements IOlmMessageAccessFailure {

    constructor(data?: IOlmMessageAccessFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmMessageAccessFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmMessageAccessFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmMessageAccessFailure extends IValidationFailure {
}

export class OlmMessageSysPrinFailure extends ValidationFailure implements IOlmMessageSysPrinFailure {

    constructor(data?: IOlmMessageSysPrinFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmMessageSysPrinFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmMessageSysPrinFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmMessageSysPrinFailure extends IValidationFailure {
}

export class OlmMessageRequestorFirstNameFailure extends ValidationFailure implements IOlmMessageRequestorFirstNameFailure {

    constructor(data?: IOlmMessageRequestorFirstNameFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmMessageRequestorFirstNameFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmMessageRequestorFirstNameFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmMessageRequestorFirstNameFailure extends IValidationFailure {
}

export class OlmMessageRequestorLastNameFailure extends ValidationFailure implements IOlmMessageRequestorLastNameFailure {

    constructor(data?: IOlmMessageRequestorLastNameFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmMessageRequestorLastNameFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmMessageRequestorLastNameFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmMessageRequestorLastNameFailure extends IValidationFailure {
}

export class OlmMessageRequestorEmailFailure extends ValidationFailure implements IOlmMessageRequestorEmailFailure {

    constructor(data?: IOlmMessageRequestorEmailFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmMessageRequestorEmailFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmMessageRequestorEmailFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmMessageRequestorEmailFailure extends IValidationFailure {
}

export class OlmMessageDepartmentFailure extends ValidationFailure implements IOlmMessageDepartmentFailure {

    constructor(data?: IOlmMessageDepartmentFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmMessageDepartmentFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmMessageDepartmentFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmMessageDepartmentFailure extends IValidationFailure {
}

export class OlmMessageNotesFailure extends ValidationFailure implements IOlmMessageNotesFailure {

    constructor(data?: IOlmMessageNotesFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmMessageNotesFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmMessageNotesFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmMessageNotesFailure extends IValidationFailure {
}

export class OlmMessageTitleFailure extends ValidationFailure implements IOlmMessageTitleFailure {

    constructor(data?: IOlmMessageTitleFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmMessageTitleFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmMessageTitleFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmMessageTitleFailure extends IValidationFailure {
}

export class OlmMessageIdFailure extends ValidationFailure implements IOlmMessageIdFailure {

    constructor(data?: IOlmMessageIdFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmMessageIdFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmMessageIdFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmMessageIdFailure extends IValidationFailure {
}

export class OlmMessageTypeFailure extends ValidationFailure implements IOlmMessageTypeFailure {

    constructor(data?: IOlmMessageTypeFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmMessageTypeFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmMessageTypeFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmMessageTypeFailure extends IValidationFailure {
}

export class OlmMessageLinkingFailure extends ValidationFailure implements IOlmMessageLinkingFailure {

    constructor(data?: IOlmMessageLinkingFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmMessageLinkingFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmMessageLinkingFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmMessageLinkingFailure extends IValidationFailure {
}

export class OlmMessageRankFailure extends ValidationFailure implements IOlmMessageRankFailure {

    constructor(data?: IOlmMessageRankFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmMessageRankFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmMessageRankFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmMessageRankFailure extends IValidationFailure {
}

export class OlmMessageRequirementFailure extends ValidationFailure implements IOlmMessageRequirementFailure {

    constructor(data?: IOlmMessageRequirementFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmMessageRequirementFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmMessageRequirementFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmMessageRequirementFailure extends IValidationFailure {
}

export class OlmMessageForceHardcopyFailure extends ValidationFailure implements IOlmMessageForceHardcopyFailure {

    constructor(data?: IOlmMessageForceHardcopyFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmMessageForceHardcopyFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmMessageForceHardcopyFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmMessageForceHardcopyFailure extends IValidationFailure {
}

export class OlmMessageLocationSelectionFailure extends ValidationFailure implements IOlmMessageLocationSelectionFailure {

    constructor(data?: IOlmMessageLocationSelectionFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmMessageLocationSelectionFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmMessageLocationSelectionFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmMessageLocationSelectionFailure extends IValidationFailure {
}

export class OlmMessageBeginDateFailure extends ValidationFailure implements IOlmMessageBeginDateFailure {

    constructor(data?: IOlmMessageBeginDateFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmMessageBeginDateFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmMessageBeginDateFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmMessageBeginDateFailure extends IValidationFailure {
}

export class OlmMessageEndDateFailure extends ValidationFailure implements IOlmMessageEndDateFailure {

    constructor(data?: IOlmMessageEndDateFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmMessageEndDateFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmMessageEndDateFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmMessageEndDateFailure extends IValidationFailure {
}

export class OlmMessageOverflowFailure extends ValidationFailure implements IOlmMessageOverflowFailure {

    constructor(data?: IOlmMessageOverflowFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmMessageOverflowFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmMessageOverflowFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmMessageOverflowFailure extends IValidationFailure {
}

export class OlmMessageVantageQueryFailure extends ValidationFailure implements IOlmMessageVantageQueryFailure {

    constructor(data?: IOlmMessageVantageQueryFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmMessageVantageQueryFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmMessageVantageQueryFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmMessageVantageQueryFailure extends IValidationFailure {
}

export class OlmMessageExternalClientGroupFailure extends ValidationFailure implements IOlmMessageExternalClientGroupFailure {

    constructor(data?: IOlmMessageExternalClientGroupFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmMessageExternalClientGroupFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmMessageExternalClientGroupFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmMessageExternalClientGroupFailure extends IValidationFailure {
}

export class OlmMessageBackgroundColorFailure extends ValidationFailure implements IOlmMessageBackgroundColorFailure {

    constructor(data?: IOlmMessageBackgroundColorFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmMessageBackgroundColorFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmMessageBackgroundColorFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmMessageBackgroundColorFailure extends IValidationFailure {
}

export class OlmMessageLineSpacingFailure extends ValidationFailure implements IOlmMessageLineSpacingFailure {

    constructor(data?: IOlmMessageLineSpacingFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmMessageLineSpacingFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmMessageLineSpacingFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmMessageLineSpacingFailure extends IValidationFailure {
}

export class OlmMessagePrimaryLanguageFailure extends ValidationFailure implements IOlmMessagePrimaryLanguageFailure {

    constructor(data?: IOlmMessagePrimaryLanguageFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmMessagePrimaryLanguageFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmMessagePrimaryLanguageFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmMessagePrimaryLanguageFailure extends IValidationFailure {
}

export abstract class OlmMessageDetailFailure extends ValidationFailure implements IOlmMessageDetailFailure {
    language?: string | undefined;

    constructor(data?: IOlmMessageDetailFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.language = _data["language"];
        }
    }

    static override fromJS(data: any): OlmMessageDetailFailure {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'OlmMessageDetailFailure' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        super.toJSON(data);
        return data;
    }
}

export interface IOlmMessageDetailFailure extends IValidationFailure {
    language?: string | undefined;
}

export class OlmMessageLanguageFailure extends OlmMessageDetailFailure implements IOlmMessageLanguageFailure {

    constructor(data?: IOlmMessageLanguageFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmMessageLanguageFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmMessageLanguageFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmMessageLanguageFailure extends IOlmMessageDetailFailure {
}

export class OlmMessageTextFailure extends OlmMessageDetailFailure implements IOlmMessageTextFailure {

    constructor(data?: IOlmMessageTextFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmMessageTextFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmMessageTextFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmMessageTextFailure extends IOlmMessageDetailFailure {
}

export class OlmStuffCodeFailure extends ValidationFailure implements IOlmStuffCodeFailure {

    constructor(data?: IOlmStuffCodeFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmStuffCodeFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmStuffCodeFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmStuffCodeFailure extends IValidationFailure {
}

export class OlmMessageInViewHoldIdFailure extends ValidationFailure implements IOlmMessageInViewHoldIdFailure {

    constructor(data?: IOlmMessageInViewHoldIdFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmMessageInViewHoldIdFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmMessageInViewHoldIdFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmMessageInViewHoldIdFailure extends IValidationFailure {
}

export class OlmMessageGraphicLocationFailure extends OlmMessageDetailFailure implements IOlmMessageGraphicLocationFailure {

    constructor(data?: IOlmMessageGraphicLocationFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmMessageGraphicLocationFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmMessageGraphicLocationFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmMessageGraphicLocationFailure extends IOlmMessageDetailFailure {
}

export class OlmMessageGraphicLocationTextWrapFailure extends OlmMessageDetailFailure implements IOlmMessageGraphicLocationTextWrapFailure {

    constructor(data?: IOlmMessageGraphicLocationTextWrapFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmMessageGraphicLocationTextWrapFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmMessageGraphicLocationTextWrapFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmMessageGraphicLocationTextWrapFailure extends IOlmMessageDetailFailure {
}

export class OlmMessageGraphicNumberFailure extends OlmMessageDetailFailure implements IOlmMessageGraphicNumberFailure {

    constructor(data?: IOlmMessageGraphicNumberFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmMessageGraphicNumberFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmMessageGraphicNumberFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmMessageGraphicNumberFailure extends IOlmMessageDetailFailure {
}

export class OlmMessageReplacementVariableFailure extends OlmMessageDetailFailure implements IOlmMessageReplacementVariableFailure {

    constructor(data?: IOlmMessageReplacementVariableFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmMessageReplacementVariableFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmMessageReplacementVariableFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmMessageReplacementVariableFailure extends IOlmMessageDetailFailure {
}

export class OlmMessageGeneralFailure extends ValidationFailure implements IOlmMessageGeneralFailure {

    constructor(data?: IOlmMessageGeneralFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OlmMessageGeneralFailure {
        data = typeof data === 'object' ? data : {};
        let result = new OlmMessageGeneralFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOlmMessageGeneralFailure extends IValidationFailure {
}

export class MessageValidationRequest implements IMessageValidationRequest {
    message!: OlmMessage;

    constructor(data?: IMessageValidationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.message = new OlmMessage();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"] ? OlmMessage.fromJS(_data["message"]) : new OlmMessage();
        }
    }

    static fromJS(data: any): MessageValidationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MessageValidationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message ? this.message.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMessageValidationRequest {
    message: OlmMessage;
}

export class GetSecondaryMessagesAvailableForLinkingResponse implements IGetSecondaryMessagesAvailableForLinkingResponse {
    availableSecondaryMessages!: SecondaryMessageInfoForLinking[];

    constructor(data?: IGetSecondaryMessagesAvailableForLinkingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.availableSecondaryMessages = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["availableSecondaryMessages"])) {
                this.availableSecondaryMessages = [] as any;
                for (let item of _data["availableSecondaryMessages"])
                    this.availableSecondaryMessages!.push(SecondaryMessageInfoForLinking.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSecondaryMessagesAvailableForLinkingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSecondaryMessagesAvailableForLinkingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.availableSecondaryMessages)) {
            data["availableSecondaryMessages"] = [];
            for (let item of this.availableSecondaryMessages)
                data["availableSecondaryMessages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSecondaryMessagesAvailableForLinkingResponse {
    availableSecondaryMessages: SecondaryMessageInfoForLinking[];
}

export class GetSecondaryMessagesAvailableForLinkingRequest implements IGetSecondaryMessagesAvailableForLinkingRequest {
    docTypeUniqueId!: number;
    currentMessageUniqueId?: number | undefined;
    currentMessageSysPrins!: SysPrin[];
    currentMessageBeginDate!: Date;
    currentMessageEndDate?: Date | undefined;

    constructor(data?: IGetSecondaryMessagesAvailableForLinkingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.currentMessageSysPrins = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.docTypeUniqueId = _data["docTypeUniqueId"];
            this.currentMessageUniqueId = _data["currentMessageUniqueId"];
            if (Array.isArray(_data["currentMessageSysPrins"])) {
                this.currentMessageSysPrins = [] as any;
                for (let item of _data["currentMessageSysPrins"])
                    this.currentMessageSysPrins!.push(SysPrin.fromJS(item));
            }
            this.currentMessageBeginDate = _data["currentMessageBeginDate"] ? new Date(_data["currentMessageBeginDate"].toString()) : <any>undefined;
            this.currentMessageEndDate = _data["currentMessageEndDate"] ? new Date(_data["currentMessageEndDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSecondaryMessagesAvailableForLinkingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSecondaryMessagesAvailableForLinkingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docTypeUniqueId"] = this.docTypeUniqueId;
        data["currentMessageUniqueId"] = this.currentMessageUniqueId;
        if (Array.isArray(this.currentMessageSysPrins)) {
            data["currentMessageSysPrins"] = [];
            for (let item of this.currentMessageSysPrins)
                data["currentMessageSysPrins"].push(item.toJSON());
        }
        data["currentMessageBeginDate"] = this.currentMessageBeginDate ? this.currentMessageBeginDate.toISOString() : <any>undefined;
        data["currentMessageEndDate"] = this.currentMessageEndDate ? this.currentMessageEndDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetSecondaryMessagesAvailableForLinkingRequest {
    docTypeUniqueId: number;
    currentMessageUniqueId?: number | undefined;
    currentMessageSysPrins: SysPrin[];
    currentMessageBeginDate: Date;
    currentMessageEndDate?: Date | undefined;
}

export class GetAvailableMessageTypesResponse implements IGetAvailableMessageTypesResponse {
    messageTypes!: string[];

    constructor(data?: IGetAvailableMessageTypesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messageTypes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messageTypes"])) {
                this.messageTypes = [] as any;
                for (let item of _data["messageTypes"])
                    this.messageTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): GetAvailableMessageTypesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvailableMessageTypesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messageTypes)) {
            data["messageTypes"] = [];
            for (let item of this.messageTypes)
                data["messageTypes"].push(item);
        }
        return data;
    }
}

export interface IGetAvailableMessageTypesResponse {
    messageTypes: string[];
}

export class GetDuplicateRankWarningMessageResponse implements IGetDuplicateRankWarningMessageResponse {
    duplicateRankCount!: number;
    message!: string;

    constructor(data?: IGetDuplicateRankWarningMessageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.duplicateRankCount = _data["duplicateRankCount"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): GetDuplicateRankWarningMessageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDuplicateRankWarningMessageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["duplicateRankCount"] = this.duplicateRankCount;
        data["message"] = this.message;
        return data;
    }
}

export interface IGetDuplicateRankWarningMessageResponse {
    duplicateRankCount: number;
    message: string;
}

export class GetDuplicateRankWarningMessageRequest implements IGetDuplicateRankWarningMessageRequest {
    rank?: number | undefined;
    locationId!: number;
    messageId?: number | undefined;
    sysPrins!: SysPrinDto[];

    constructor(data?: IGetDuplicateRankWarningMessageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sysPrins = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rank = _data["rank"];
            this.locationId = _data["locationId"];
            this.messageId = _data["messageId"];
            if (Array.isArray(_data["sysPrins"])) {
                this.sysPrins = [] as any;
                for (let item of _data["sysPrins"])
                    this.sysPrins!.push(SysPrinDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDuplicateRankWarningMessageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDuplicateRankWarningMessageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rank"] = this.rank;
        data["locationId"] = this.locationId;
        data["messageId"] = this.messageId;
        if (Array.isArray(this.sysPrins)) {
            data["sysPrins"] = [];
            for (let item of this.sysPrins)
                data["sysPrins"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDuplicateRankWarningMessageRequest {
    rank?: number | undefined;
    locationId: number;
    messageId?: number | undefined;
    sysPrins: SysPrinDto[];
}

export class GetMessageSearchResultResponse implements IGetMessageSearchResultResponse {
    searchResults!: MessageDto[];

    constructor(data?: IGetMessageSearchResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.searchResults = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["searchResults"])) {
                this.searchResults = [] as any;
                for (let item of _data["searchResults"])
                    this.searchResults!.push(MessageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMessageSearchResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMessageSearchResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.searchResults)) {
            data["searchResults"] = [];
            for (let item of this.searchResults)
                data["searchResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMessageSearchResultResponse {
    searchResults: MessageDto[];
}

export class MessageSearchDto implements IMessageSearchDto {
    keyWord!: string;
    searchBy!: string;
    searchFields!: MessageSearchFieldsDto;
    standAloneSearchFields!: StandAloneSearchFieldsDto;

    constructor(data?: IMessageSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.searchFields = new MessageSearchFieldsDto();
            this.standAloneSearchFields = new StandAloneSearchFieldsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyWord = _data["keyWord"];
            this.searchBy = _data["searchBy"];
            this.searchFields = _data["searchFields"] ? MessageSearchFieldsDto.fromJS(_data["searchFields"]) : new MessageSearchFieldsDto();
            this.standAloneSearchFields = _data["standAloneSearchFields"] ? StandAloneSearchFieldsDto.fromJS(_data["standAloneSearchFields"]) : new StandAloneSearchFieldsDto();
        }
    }

    static fromJS(data: any): MessageSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyWord"] = this.keyWord;
        data["searchBy"] = this.searchBy;
        data["searchFields"] = this.searchFields ? this.searchFields.toJSON() : <any>undefined;
        data["standAloneSearchFields"] = this.standAloneSearchFields ? this.standAloneSearchFields.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMessageSearchDto {
    keyWord: string;
    searchBy: string;
    searchFields: MessageSearchFieldsDto;
    standAloneSearchFields: StandAloneSearchFieldsDto;
}

export class GetMessageSearchResultRequest extends MessageSearchDto implements IGetMessageSearchResultRequest {

    constructor(data?: IGetMessageSearchResultRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetMessageSearchResultRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMessageSearchResultRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetMessageSearchResultRequest extends IMessageSearchDto {
}

export class MessageSearchFieldsDto implements IMessageSearchFieldsDto {
    location!: boolean;
    title!: boolean;
    messageId!: boolean;
    graphicId!: boolean;
    creatorUserId!: boolean;
    approverUserId!: boolean;
    requestorEmail!: boolean;
    requestorFirstName!: boolean;
    requestorLastName!: boolean;
    requestorDepartment!: boolean;

    constructor(data?: IMessageSearchFieldsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location = _data["location"];
            this.title = _data["title"];
            this.messageId = _data["messageId"];
            this.graphicId = _data["graphicId"];
            this.creatorUserId = _data["creatorUserId"];
            this.approverUserId = _data["approverUserId"];
            this.requestorEmail = _data["requestorEmail"];
            this.requestorFirstName = _data["requestorFirstName"];
            this.requestorLastName = _data["requestorLastName"];
            this.requestorDepartment = _data["requestorDepartment"];
        }
    }

    static fromJS(data: any): MessageSearchFieldsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageSearchFieldsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location;
        data["title"] = this.title;
        data["messageId"] = this.messageId;
        data["graphicId"] = this.graphicId;
        data["creatorUserId"] = this.creatorUserId;
        data["approverUserId"] = this.approverUserId;
        data["requestorEmail"] = this.requestorEmail;
        data["requestorFirstName"] = this.requestorFirstName;
        data["requestorLastName"] = this.requestorLastName;
        data["requestorDepartment"] = this.requestorDepartment;
        return data;
    }
}

export interface IMessageSearchFieldsDto {
    location: boolean;
    title: boolean;
    messageId: boolean;
    graphicId: boolean;
    creatorUserId: boolean;
    approverUserId: boolean;
    requestorEmail: boolean;
    requestorFirstName: boolean;
    requestorLastName: boolean;
    requestorDepartment: boolean;
}

export class StandAloneSearchFieldsDto implements IStandAloneSearchFieldsDto {
    messageText!: boolean;
    selectivityFieldName!: boolean;
    selectivityValue!: boolean;

    constructor(data?: IStandAloneSearchFieldsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageText = _data["messageText"];
            this.selectivityFieldName = _data["selectivityFieldName"];
            this.selectivityValue = _data["selectivityValue"];
        }
    }

    static fromJS(data: any): StandAloneSearchFieldsDto {
        data = typeof data === 'object' ? data : {};
        let result = new StandAloneSearchFieldsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageText"] = this.messageText;
        data["selectivityFieldName"] = this.selectivityFieldName;
        data["selectivityValue"] = this.selectivityValue;
        return data;
    }
}

export interface IStandAloneSearchFieldsDto {
    messageText: boolean;
    selectivityFieldName: boolean;
    selectivityValue: boolean;
}

export class GetAvailableSearchCriteriaForMessagesReportResponse implements IGetAvailableSearchCriteriaForMessagesReportResponse {
    availableSysPrins?: SysPrin[] | undefined;
    availableDocumentTypes?: { [key: string]: string; } | undefined;
    availableLocations?: { [key: string]: string; } | undefined;
    availableMessageRequirementOptions?: RequirementRestriction[] | undefined;
    availableRequestorDepartments?: { [key: string]: string; } | undefined;
    availableSelectivityInclusionOperators?: KeyValuePairOfInclusionOperatorAndString[] | undefined;
    availableMessageStatuses?: OlmMessageStatus[] | undefined;
    availableLanguages?: string[] | undefined;
    availableGraphicIds?: string[] | undefined;

    constructor(data?: IGetAvailableSearchCriteriaForMessagesReportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["availableSysPrins"])) {
                this.availableSysPrins = [] as any;
                for (let item of _data["availableSysPrins"])
                    this.availableSysPrins!.push(SysPrin.fromJS(item));
            }
            if (_data["availableDocumentTypes"]) {
                this.availableDocumentTypes = {} as any;
                for (let key in _data["availableDocumentTypes"]) {
                    if (_data["availableDocumentTypes"].hasOwnProperty(key))
                        (<any>this.availableDocumentTypes)![key] = _data["availableDocumentTypes"][key];
                }
            }
            if (_data["availableLocations"]) {
                this.availableLocations = {} as any;
                for (let key in _data["availableLocations"]) {
                    if (_data["availableLocations"].hasOwnProperty(key))
                        (<any>this.availableLocations)![key] = _data["availableLocations"][key];
                }
            }
            if (Array.isArray(_data["availableMessageRequirementOptions"])) {
                this.availableMessageRequirementOptions = [] as any;
                for (let item of _data["availableMessageRequirementOptions"])
                    this.availableMessageRequirementOptions!.push(item);
            }
            if (_data["availableRequestorDepartments"]) {
                this.availableRequestorDepartments = {} as any;
                for (let key in _data["availableRequestorDepartments"]) {
                    if (_data["availableRequestorDepartments"].hasOwnProperty(key))
                        (<any>this.availableRequestorDepartments)![key] = _data["availableRequestorDepartments"][key];
                }
            }
            if (Array.isArray(_data["availableSelectivityInclusionOperators"])) {
                this.availableSelectivityInclusionOperators = [] as any;
                for (let item of _data["availableSelectivityInclusionOperators"])
                    this.availableSelectivityInclusionOperators!.push(KeyValuePairOfInclusionOperatorAndString.fromJS(item));
            }
            if (Array.isArray(_data["availableMessageStatuses"])) {
                this.availableMessageStatuses = [] as any;
                for (let item of _data["availableMessageStatuses"])
                    this.availableMessageStatuses!.push(item);
            }
            if (Array.isArray(_data["availableLanguages"])) {
                this.availableLanguages = [] as any;
                for (let item of _data["availableLanguages"])
                    this.availableLanguages!.push(item);
            }
            if (Array.isArray(_data["availableGraphicIds"])) {
                this.availableGraphicIds = [] as any;
                for (let item of _data["availableGraphicIds"])
                    this.availableGraphicIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetAvailableSearchCriteriaForMessagesReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvailableSearchCriteriaForMessagesReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.availableSysPrins)) {
            data["availableSysPrins"] = [];
            for (let item of this.availableSysPrins)
                data["availableSysPrins"].push(item.toJSON());
        }
        if (this.availableDocumentTypes) {
            data["availableDocumentTypes"] = {};
            for (let key in this.availableDocumentTypes) {
                if (this.availableDocumentTypes.hasOwnProperty(key))
                    (<any>data["availableDocumentTypes"])[key] = (<any>this.availableDocumentTypes)[key];
            }
        }
        if (this.availableLocations) {
            data["availableLocations"] = {};
            for (let key in this.availableLocations) {
                if (this.availableLocations.hasOwnProperty(key))
                    (<any>data["availableLocations"])[key] = (<any>this.availableLocations)[key];
            }
        }
        if (Array.isArray(this.availableMessageRequirementOptions)) {
            data["availableMessageRequirementOptions"] = [];
            for (let item of this.availableMessageRequirementOptions)
                data["availableMessageRequirementOptions"].push(item);
        }
        if (this.availableRequestorDepartments) {
            data["availableRequestorDepartments"] = {};
            for (let key in this.availableRequestorDepartments) {
                if (this.availableRequestorDepartments.hasOwnProperty(key))
                    (<any>data["availableRequestorDepartments"])[key] = (<any>this.availableRequestorDepartments)[key];
            }
        }
        if (Array.isArray(this.availableSelectivityInclusionOperators)) {
            data["availableSelectivityInclusionOperators"] = [];
            for (let item of this.availableSelectivityInclusionOperators)
                data["availableSelectivityInclusionOperators"].push(item.toJSON());
        }
        if (Array.isArray(this.availableMessageStatuses)) {
            data["availableMessageStatuses"] = [];
            for (let item of this.availableMessageStatuses)
                data["availableMessageStatuses"].push(item);
        }
        if (Array.isArray(this.availableLanguages)) {
            data["availableLanguages"] = [];
            for (let item of this.availableLanguages)
                data["availableLanguages"].push(item);
        }
        if (Array.isArray(this.availableGraphicIds)) {
            data["availableGraphicIds"] = [];
            for (let item of this.availableGraphicIds)
                data["availableGraphicIds"].push(item);
        }
        return data;
    }
}

export interface IGetAvailableSearchCriteriaForMessagesReportResponse {
    availableSysPrins?: SysPrin[] | undefined;
    availableDocumentTypes?: { [key: string]: string; } | undefined;
    availableLocations?: { [key: string]: string; } | undefined;
    availableMessageRequirementOptions?: RequirementRestriction[] | undefined;
    availableRequestorDepartments?: { [key: string]: string; } | undefined;
    availableSelectivityInclusionOperators?: KeyValuePairOfInclusionOperatorAndString[] | undefined;
    availableMessageStatuses?: OlmMessageStatus[] | undefined;
    availableLanguages?: string[] | undefined;
    availableGraphicIds?: string[] | undefined;
}

export class KeyValuePairOfInclusionOperatorAndString implements IKeyValuePairOfInclusionOperatorAndString {
    key!: InclusionOperator;
    value?: string | undefined;

    constructor(data?: IKeyValuePairOfInclusionOperatorAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): KeyValuePairOfInclusionOperatorAndString {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePairOfInclusionOperatorAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IKeyValuePairOfInclusionOperatorAndString {
    key: InclusionOperator;
    value?: string | undefined;
}

export class GetAvailableSearchCriteriaForMessagesReportRequest implements IGetAvailableSearchCriteriaForMessagesReportRequest {
    optionalSelectedSysPrins!: SysPrin[];
    optionalSelectedDocTypeUniqueId?: number | undefined;

    constructor(data?: IGetAvailableSearchCriteriaForMessagesReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.optionalSelectedSysPrins = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["optionalSelectedSysPrins"])) {
                this.optionalSelectedSysPrins = [] as any;
                for (let item of _data["optionalSelectedSysPrins"])
                    this.optionalSelectedSysPrins!.push(SysPrin.fromJS(item));
            }
            this.optionalSelectedDocTypeUniqueId = _data["optionalSelectedDocTypeUniqueId"];
        }
    }

    static fromJS(data: any): GetAvailableSearchCriteriaForMessagesReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvailableSearchCriteriaForMessagesReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.optionalSelectedSysPrins)) {
            data["optionalSelectedSysPrins"] = [];
            for (let item of this.optionalSelectedSysPrins)
                data["optionalSelectedSysPrins"].push(item.toJSON());
        }
        data["optionalSelectedDocTypeUniqueId"] = this.optionalSelectedDocTypeUniqueId;
        return data;
    }
}

export interface IGetAvailableSearchCriteriaForMessagesReportRequest {
    optionalSelectedSysPrins: SysPrin[];
    optionalSelectedDocTypeUniqueId?: number | undefined;
}

export class ValidateUserSelectionsforMessageReportResponse implements IValidateUserSelectionsforMessageReportResponse {
    validationResults!: MessagesReportSearchCriteriaValidationResults;

    constructor(data?: IValidateUserSelectionsforMessageReportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.validationResults = new MessagesReportSearchCriteriaValidationResults();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.validationResults = _data["validationResults"] ? MessagesReportSearchCriteriaValidationResults.fromJS(_data["validationResults"]) : new MessagesReportSearchCriteriaValidationResults();
        }
    }

    static fromJS(data: any): ValidateUserSelectionsforMessageReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateUserSelectionsforMessageReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validationResults"] = this.validationResults ? this.validationResults.toJSON() : <any>undefined;
        return data;
    }
}

export interface IValidateUserSelectionsforMessageReportResponse {
    validationResults: MessagesReportSearchCriteriaValidationResults;
}

export class MessagesReportSearchCriteriaValidationResults extends ValidationResults implements IMessagesReportSearchCriteriaValidationResults {
    validationFailureGroups?: { [key: string]: Anonymous5[]; } | undefined;
    sysPrinValidationFailures?: MessagesReportSysPrinFailure[] | undefined;
    beginDateFailures?: MessagesReportBeginDateFailure[] | undefined;
    endDateFailures?: MessagesReportEndDateFailure[] | undefined;
    messageIdFailures?: MessagesReportMessageIdFailure[] | undefined;
    docTypeFailures?: MessagesReportDoctypeFailure[] | undefined;
    locationFailures?: MessagesReportLocationFailure[] | undefined;
    languageFailures?: MessagesReportLanguageFailure[] | undefined;
    graphicFailures?: MessagesReportGraphicFailure[] | undefined;
    departmentFailures?: MessagesReportDepartmentFailure[] | undefined;

    constructor(data?: IMessagesReportSearchCriteriaValidationResults) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["validationFailureGroups"]) {
                this.validationFailureGroups = {} as any;
                for (let key in _data["validationFailureGroups"]) {
                    if (_data["validationFailureGroups"].hasOwnProperty(key))
                        (<any>this.validationFailureGroups)![key] = _data["validationFailureGroups"][key] !== undefined ? _data["validationFailureGroups"][key] : [];
                }
            }
            if (Array.isArray(_data["sysPrinValidationFailures"])) {
                this.sysPrinValidationFailures = [] as any;
                for (let item of _data["sysPrinValidationFailures"])
                    this.sysPrinValidationFailures!.push(MessagesReportSysPrinFailure.fromJS(item));
            }
            if (Array.isArray(_data["beginDateFailures"])) {
                this.beginDateFailures = [] as any;
                for (let item of _data["beginDateFailures"])
                    this.beginDateFailures!.push(MessagesReportBeginDateFailure.fromJS(item));
            }
            if (Array.isArray(_data["endDateFailures"])) {
                this.endDateFailures = [] as any;
                for (let item of _data["endDateFailures"])
                    this.endDateFailures!.push(MessagesReportEndDateFailure.fromJS(item));
            }
            if (Array.isArray(_data["messageIdFailures"])) {
                this.messageIdFailures = [] as any;
                for (let item of _data["messageIdFailures"])
                    this.messageIdFailures!.push(MessagesReportMessageIdFailure.fromJS(item));
            }
            if (Array.isArray(_data["docTypeFailures"])) {
                this.docTypeFailures = [] as any;
                for (let item of _data["docTypeFailures"])
                    this.docTypeFailures!.push(MessagesReportDoctypeFailure.fromJS(item));
            }
            if (Array.isArray(_data["locationFailures"])) {
                this.locationFailures = [] as any;
                for (let item of _data["locationFailures"])
                    this.locationFailures!.push(MessagesReportLocationFailure.fromJS(item));
            }
            if (Array.isArray(_data["languageFailures"])) {
                this.languageFailures = [] as any;
                for (let item of _data["languageFailures"])
                    this.languageFailures!.push(MessagesReportLanguageFailure.fromJS(item));
            }
            if (Array.isArray(_data["graphicFailures"])) {
                this.graphicFailures = [] as any;
                for (let item of _data["graphicFailures"])
                    this.graphicFailures!.push(MessagesReportGraphicFailure.fromJS(item));
            }
            if (Array.isArray(_data["departmentFailures"])) {
                this.departmentFailures = [] as any;
                for (let item of _data["departmentFailures"])
                    this.departmentFailures!.push(MessagesReportDepartmentFailure.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): MessagesReportSearchCriteriaValidationResults {
        data = typeof data === 'object' ? data : {};
        let result = new MessagesReportSearchCriteriaValidationResults();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.validationFailureGroups) {
            data["validationFailureGroups"] = {};
            for (let key in this.validationFailureGroups) {
                if (this.validationFailureGroups.hasOwnProperty(key))
                    (<any>data["validationFailureGroups"])[key] = (<any>this.validationFailureGroups)[key];
            }
        }
        if (Array.isArray(this.sysPrinValidationFailures)) {
            data["sysPrinValidationFailures"] = [];
            for (let item of this.sysPrinValidationFailures)
                data["sysPrinValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.beginDateFailures)) {
            data["beginDateFailures"] = [];
            for (let item of this.beginDateFailures)
                data["beginDateFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.endDateFailures)) {
            data["endDateFailures"] = [];
            for (let item of this.endDateFailures)
                data["endDateFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.messageIdFailures)) {
            data["messageIdFailures"] = [];
            for (let item of this.messageIdFailures)
                data["messageIdFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.docTypeFailures)) {
            data["docTypeFailures"] = [];
            for (let item of this.docTypeFailures)
                data["docTypeFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.locationFailures)) {
            data["locationFailures"] = [];
            for (let item of this.locationFailures)
                data["locationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.languageFailures)) {
            data["languageFailures"] = [];
            for (let item of this.languageFailures)
                data["languageFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.graphicFailures)) {
            data["graphicFailures"] = [];
            for (let item of this.graphicFailures)
                data["graphicFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.departmentFailures)) {
            data["departmentFailures"] = [];
            for (let item of this.departmentFailures)
                data["departmentFailures"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IMessagesReportSearchCriteriaValidationResults extends IValidationResults {
    validationFailureGroups?: { [key: string]: Anonymous5[]; } | undefined;
    sysPrinValidationFailures?: MessagesReportSysPrinFailure[] | undefined;
    beginDateFailures?: MessagesReportBeginDateFailure[] | undefined;
    endDateFailures?: MessagesReportEndDateFailure[] | undefined;
    messageIdFailures?: MessagesReportMessageIdFailure[] | undefined;
    docTypeFailures?: MessagesReportDoctypeFailure[] | undefined;
    locationFailures?: MessagesReportLocationFailure[] | undefined;
    languageFailures?: MessagesReportLanguageFailure[] | undefined;
    graphicFailures?: MessagesReportGraphicFailure[] | undefined;
    departmentFailures?: MessagesReportDepartmentFailure[] | undefined;
}

export class MessagesReportSysPrinFailure extends ValidationFailure implements IMessagesReportSysPrinFailure {

    constructor(data?: IMessagesReportSysPrinFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): MessagesReportSysPrinFailure {
        data = typeof data === 'object' ? data : {};
        let result = new MessagesReportSysPrinFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMessagesReportSysPrinFailure extends IValidationFailure {
}

export class MessagesReportBeginDateFailure extends ValidationFailure implements IMessagesReportBeginDateFailure {

    constructor(data?: IMessagesReportBeginDateFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): MessagesReportBeginDateFailure {
        data = typeof data === 'object' ? data : {};
        let result = new MessagesReportBeginDateFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMessagesReportBeginDateFailure extends IValidationFailure {
}

export class MessagesReportEndDateFailure extends ValidationFailure implements IMessagesReportEndDateFailure {

    constructor(data?: IMessagesReportEndDateFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): MessagesReportEndDateFailure {
        data = typeof data === 'object' ? data : {};
        let result = new MessagesReportEndDateFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMessagesReportEndDateFailure extends IValidationFailure {
}

export class MessagesReportMessageIdFailure extends ValidationFailure implements IMessagesReportMessageIdFailure {

    constructor(data?: IMessagesReportMessageIdFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): MessagesReportMessageIdFailure {
        data = typeof data === 'object' ? data : {};
        let result = new MessagesReportMessageIdFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMessagesReportMessageIdFailure extends IValidationFailure {
}

export class MessagesReportDoctypeFailure extends ValidationFailure implements IMessagesReportDoctypeFailure {

    constructor(data?: IMessagesReportDoctypeFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): MessagesReportDoctypeFailure {
        data = typeof data === 'object' ? data : {};
        let result = new MessagesReportDoctypeFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMessagesReportDoctypeFailure extends IValidationFailure {
}

export class MessagesReportLocationFailure extends ValidationFailure implements IMessagesReportLocationFailure {

    constructor(data?: IMessagesReportLocationFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): MessagesReportLocationFailure {
        data = typeof data === 'object' ? data : {};
        let result = new MessagesReportLocationFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMessagesReportLocationFailure extends IValidationFailure {
}

export class MessagesReportLanguageFailure extends ValidationFailure implements IMessagesReportLanguageFailure {

    constructor(data?: IMessagesReportLanguageFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): MessagesReportLanguageFailure {
        data = typeof data === 'object' ? data : {};
        let result = new MessagesReportLanguageFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMessagesReportLanguageFailure extends IValidationFailure {
}

export class MessagesReportGraphicFailure extends ValidationFailure implements IMessagesReportGraphicFailure {

    constructor(data?: IMessagesReportGraphicFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): MessagesReportGraphicFailure {
        data = typeof data === 'object' ? data : {};
        let result = new MessagesReportGraphicFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMessagesReportGraphicFailure extends IValidationFailure {
}

export class MessagesReportDepartmentFailure extends ValidationFailure implements IMessagesReportDepartmentFailure {

    constructor(data?: IMessagesReportDepartmentFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): MessagesReportDepartmentFailure {
        data = typeof data === 'object' ? data : {};
        let result = new MessagesReportDepartmentFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMessagesReportDepartmentFailure extends IValidationFailure {
}

export class ValidateUserSelectionsforMessageReportRequest implements IValidateUserSelectionsforMessageReportRequest {
    sysPrins!: SysPrinDto[];
    documentTypeId?: number | undefined;
    locationId?: number | undefined;
    messageId!: string;
    messageStatus?: MessageStatus | undefined;
    language!: string;
    graphicId!: string;
    hiddenInECare!: boolean;
    beginDate?: Date | undefined;
    beginDateUserEntry!: string;
    endDate?: Date | undefined;
    endDateUserEntry!: string;
    requestorLastName!: string;
    departmentPk!: string;
    messageRequirement?: RequirementRestriction | undefined;
    selectivityInclusionOperator?: InclusionOperator | undefined;

    constructor(data?: IValidateUserSelectionsforMessageReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sysPrins = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sysPrins"])) {
                this.sysPrins = [] as any;
                for (let item of _data["sysPrins"])
                    this.sysPrins!.push(SysPrinDto.fromJS(item));
            }
            this.documentTypeId = _data["documentTypeId"];
            this.locationId = _data["locationId"];
            this.messageId = _data["messageId"];
            this.messageStatus = _data["messageStatus"];
            this.language = _data["language"];
            this.graphicId = _data["graphicId"];
            this.hiddenInECare = _data["hiddenInECare"];
            this.beginDate = _data["beginDate"] ? new Date(_data["beginDate"].toString()) : <any>undefined;
            this.beginDateUserEntry = _data["beginDateUserEntry"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.endDateUserEntry = _data["endDateUserEntry"];
            this.requestorLastName = _data["requestorLastName"];
            this.departmentPk = _data["departmentPk"];
            this.messageRequirement = _data["messageRequirement"];
            this.selectivityInclusionOperator = _data["selectivityInclusionOperator"];
        }
    }

    static fromJS(data: any): ValidateUserSelectionsforMessageReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateUserSelectionsforMessageReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sysPrins)) {
            data["sysPrins"] = [];
            for (let item of this.sysPrins)
                data["sysPrins"].push(item.toJSON());
        }
        data["documentTypeId"] = this.documentTypeId;
        data["locationId"] = this.locationId;
        data["messageId"] = this.messageId;
        data["messageStatus"] = this.messageStatus;
        data["language"] = this.language;
        data["graphicId"] = this.graphicId;
        data["hiddenInECare"] = this.hiddenInECare;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["beginDateUserEntry"] = this.beginDateUserEntry;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["endDateUserEntry"] = this.endDateUserEntry;
        data["requestorLastName"] = this.requestorLastName;
        data["departmentPk"] = this.departmentPk;
        data["messageRequirement"] = this.messageRequirement;
        data["selectivityInclusionOperator"] = this.selectivityInclusionOperator;
        return data;
    }
}

export interface IValidateUserSelectionsforMessageReportRequest {
    sysPrins: SysPrinDto[];
    documentTypeId?: number | undefined;
    locationId?: number | undefined;
    messageId: string;
    messageStatus?: MessageStatus | undefined;
    language: string;
    graphicId: string;
    hiddenInECare: boolean;
    beginDate?: Date | undefined;
    beginDateUserEntry: string;
    endDate?: Date | undefined;
    endDateUserEntry: string;
    requestorLastName: string;
    departmentPk: string;
    messageRequirement?: RequirementRestriction | undefined;
    selectivityInclusionOperator?: InclusionOperator | undefined;
}

export class ExportMessageReportRequest extends ValidateUserSelectionsforMessageReportRequest implements IExportMessageReportRequest {

    constructor(data?: IExportMessageReportRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ExportMessageReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExportMessageReportRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IExportMessageReportRequest extends IValidateUserSelectionsforMessageReportRequest {
}

export class GetAvailableSearchCriteriaForPostQualReportResponse implements IGetAvailableSearchCriteriaForPostQualReportResponse {
    availableSysPrins?: SysPrin[] | undefined;
    availableRequestorDepartments?: { [key: string]: string; } | undefined;
    showStatementValidationDataSourceOption!: boolean;

    constructor(data?: IGetAvailableSearchCriteriaForPostQualReportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["availableSysPrins"])) {
                this.availableSysPrins = [] as any;
                for (let item of _data["availableSysPrins"])
                    this.availableSysPrins!.push(SysPrin.fromJS(item));
            }
            if (_data["availableRequestorDepartments"]) {
                this.availableRequestorDepartments = {} as any;
                for (let key in _data["availableRequestorDepartments"]) {
                    if (_data["availableRequestorDepartments"].hasOwnProperty(key))
                        (<any>this.availableRequestorDepartments)![key] = _data["availableRequestorDepartments"][key];
                }
            }
            this.showStatementValidationDataSourceOption = _data["showStatementValidationDataSourceOption"];
        }
    }

    static fromJS(data: any): GetAvailableSearchCriteriaForPostQualReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvailableSearchCriteriaForPostQualReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.availableSysPrins)) {
            data["availableSysPrins"] = [];
            for (let item of this.availableSysPrins)
                data["availableSysPrins"].push(item.toJSON());
        }
        if (this.availableRequestorDepartments) {
            data["availableRequestorDepartments"] = {};
            for (let key in this.availableRequestorDepartments) {
                if (this.availableRequestorDepartments.hasOwnProperty(key))
                    (<any>data["availableRequestorDepartments"])[key] = (<any>this.availableRequestorDepartments)[key];
            }
        }
        data["showStatementValidationDataSourceOption"] = this.showStatementValidationDataSourceOption;
        return data;
    }
}

export interface IGetAvailableSearchCriteriaForPostQualReportResponse {
    availableSysPrins?: SysPrin[] | undefined;
    availableRequestorDepartments?: { [key: string]: string; } | undefined;
    showStatementValidationDataSourceOption: boolean;
}

export class GetAvailableSearchCriteriaForPostQualReportRequest implements IGetAvailableSearchCriteriaForPostQualReportRequest {
    optionalSelectedSysPrins!: SysPrin[];
    optionalSelectedDocTypeUniqueId?: number | undefined;

    constructor(data?: IGetAvailableSearchCriteriaForPostQualReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.optionalSelectedSysPrins = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["optionalSelectedSysPrins"])) {
                this.optionalSelectedSysPrins = [] as any;
                for (let item of _data["optionalSelectedSysPrins"])
                    this.optionalSelectedSysPrins!.push(SysPrin.fromJS(item));
            }
            this.optionalSelectedDocTypeUniqueId = _data["optionalSelectedDocTypeUniqueId"];
        }
    }

    static fromJS(data: any): GetAvailableSearchCriteriaForPostQualReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvailableSearchCriteriaForPostQualReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.optionalSelectedSysPrins)) {
            data["optionalSelectedSysPrins"] = [];
            for (let item of this.optionalSelectedSysPrins)
                data["optionalSelectedSysPrins"].push(item.toJSON());
        }
        data["optionalSelectedDocTypeUniqueId"] = this.optionalSelectedDocTypeUniqueId;
        return data;
    }
}

export interface IGetAvailableSearchCriteriaForPostQualReportRequest {
    optionalSelectedSysPrins: SysPrin[];
    optionalSelectedDocTypeUniqueId?: number | undefined;
}

export class ValidateUserSelectionsforPostQualReportResponse implements IValidateUserSelectionsforPostQualReportResponse {
    validationResults!: PostCycleMessageQualificationReportSearchCriteriaValidationResults;

    constructor(data?: IValidateUserSelectionsforPostQualReportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.validationResults = new PostCycleMessageQualificationReportSearchCriteriaValidationResults();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.validationResults = _data["validationResults"] ? PostCycleMessageQualificationReportSearchCriteriaValidationResults.fromJS(_data["validationResults"]) : new PostCycleMessageQualificationReportSearchCriteriaValidationResults();
        }
    }

    static fromJS(data: any): ValidateUserSelectionsforPostQualReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateUserSelectionsforPostQualReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validationResults"] = this.validationResults ? this.validationResults.toJSON() : <any>undefined;
        return data;
    }
}

export interface IValidateUserSelectionsforPostQualReportResponse {
    validationResults: PostCycleMessageQualificationReportSearchCriteriaValidationResults;
}

export class PostCycleMessageQualificationReportSearchCriteriaValidationResults extends ValidationResults implements IPostCycleMessageQualificationReportSearchCriteriaValidationResults {
    validationFailureGroups?: { [key: string]: Anonymous6[]; } | undefined;
    sysPrinValidationFailures?: PostCycleMessageQualificationReportSysPrinFailure[] | undefined;
    cycleDateFailures?: PostCycleMessageQualificationReportCycleDateFailure[] | undefined;
    messageIdFailures?: PostCycleMessageQualificationReportMessageIdFailure[] | undefined;
    departmentLNameFailures?: PostCycleMessageQualificationReportDepartmentFailure[] | undefined;
    locationIdFailures?: PostCycleMessageQualificationReportLocationIdFailure[] | undefined;
    accountNumberFailures?: PostCycleMessageQualificationReportAccountNumberFailure[] | undefined;
    requestorLNameFailures?: PostCycleMessageQualificationReportRequestorLNameFailure[] | undefined;
    uniqueIdFailures?: PostCycleMessageQualificationReportUniqueIdFailure[] | undefined;
    beginDateFailures?: PostCycleMessageQualificationReportBeginDateFailure[] | undefined;
    endDateFailures?: PostCycleMessageQualificationReportEndDateFailure[] | undefined;
    statementValidationDataSourceFailures?: PostCycleMessageQualificationReportStatementValidationDataSourceFailure[] | undefined;

    constructor(data?: IPostCycleMessageQualificationReportSearchCriteriaValidationResults) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["validationFailureGroups"]) {
                this.validationFailureGroups = {} as any;
                for (let key in _data["validationFailureGroups"]) {
                    if (_data["validationFailureGroups"].hasOwnProperty(key))
                        (<any>this.validationFailureGroups)![key] = _data["validationFailureGroups"][key] !== undefined ? _data["validationFailureGroups"][key] : [];
                }
            }
            if (Array.isArray(_data["sysPrinValidationFailures"])) {
                this.sysPrinValidationFailures = [] as any;
                for (let item of _data["sysPrinValidationFailures"])
                    this.sysPrinValidationFailures!.push(PostCycleMessageQualificationReportSysPrinFailure.fromJS(item));
            }
            if (Array.isArray(_data["cycleDateFailures"])) {
                this.cycleDateFailures = [] as any;
                for (let item of _data["cycleDateFailures"])
                    this.cycleDateFailures!.push(PostCycleMessageQualificationReportCycleDateFailure.fromJS(item));
            }
            if (Array.isArray(_data["messageIdFailures"])) {
                this.messageIdFailures = [] as any;
                for (let item of _data["messageIdFailures"])
                    this.messageIdFailures!.push(PostCycleMessageQualificationReportMessageIdFailure.fromJS(item));
            }
            if (Array.isArray(_data["departmentLNameFailures"])) {
                this.departmentLNameFailures = [] as any;
                for (let item of _data["departmentLNameFailures"])
                    this.departmentLNameFailures!.push(PostCycleMessageQualificationReportDepartmentFailure.fromJS(item));
            }
            if (Array.isArray(_data["locationIdFailures"])) {
                this.locationIdFailures = [] as any;
                for (let item of _data["locationIdFailures"])
                    this.locationIdFailures!.push(PostCycleMessageQualificationReportLocationIdFailure.fromJS(item));
            }
            if (Array.isArray(_data["accountNumberFailures"])) {
                this.accountNumberFailures = [] as any;
                for (let item of _data["accountNumberFailures"])
                    this.accountNumberFailures!.push(PostCycleMessageQualificationReportAccountNumberFailure.fromJS(item));
            }
            if (Array.isArray(_data["requestorLNameFailures"])) {
                this.requestorLNameFailures = [] as any;
                for (let item of _data["requestorLNameFailures"])
                    this.requestorLNameFailures!.push(PostCycleMessageQualificationReportRequestorLNameFailure.fromJS(item));
            }
            if (Array.isArray(_data["uniqueIdFailures"])) {
                this.uniqueIdFailures = [] as any;
                for (let item of _data["uniqueIdFailures"])
                    this.uniqueIdFailures!.push(PostCycleMessageQualificationReportUniqueIdFailure.fromJS(item));
            }
            if (Array.isArray(_data["beginDateFailures"])) {
                this.beginDateFailures = [] as any;
                for (let item of _data["beginDateFailures"])
                    this.beginDateFailures!.push(PostCycleMessageQualificationReportBeginDateFailure.fromJS(item));
            }
            if (Array.isArray(_data["endDateFailures"])) {
                this.endDateFailures = [] as any;
                for (let item of _data["endDateFailures"])
                    this.endDateFailures!.push(PostCycleMessageQualificationReportEndDateFailure.fromJS(item));
            }
            if (Array.isArray(_data["statementValidationDataSourceFailures"])) {
                this.statementValidationDataSourceFailures = [] as any;
                for (let item of _data["statementValidationDataSourceFailures"])
                    this.statementValidationDataSourceFailures!.push(PostCycleMessageQualificationReportStatementValidationDataSourceFailure.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PostCycleMessageQualificationReportSearchCriteriaValidationResults {
        data = typeof data === 'object' ? data : {};
        let result = new PostCycleMessageQualificationReportSearchCriteriaValidationResults();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.validationFailureGroups) {
            data["validationFailureGroups"] = {};
            for (let key in this.validationFailureGroups) {
                if (this.validationFailureGroups.hasOwnProperty(key))
                    (<any>data["validationFailureGroups"])[key] = (<any>this.validationFailureGroups)[key];
            }
        }
        if (Array.isArray(this.sysPrinValidationFailures)) {
            data["sysPrinValidationFailures"] = [];
            for (let item of this.sysPrinValidationFailures)
                data["sysPrinValidationFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.cycleDateFailures)) {
            data["cycleDateFailures"] = [];
            for (let item of this.cycleDateFailures)
                data["cycleDateFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.messageIdFailures)) {
            data["messageIdFailures"] = [];
            for (let item of this.messageIdFailures)
                data["messageIdFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.departmentLNameFailures)) {
            data["departmentLNameFailures"] = [];
            for (let item of this.departmentLNameFailures)
                data["departmentLNameFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.locationIdFailures)) {
            data["locationIdFailures"] = [];
            for (let item of this.locationIdFailures)
                data["locationIdFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.accountNumberFailures)) {
            data["accountNumberFailures"] = [];
            for (let item of this.accountNumberFailures)
                data["accountNumberFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.requestorLNameFailures)) {
            data["requestorLNameFailures"] = [];
            for (let item of this.requestorLNameFailures)
                data["requestorLNameFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.uniqueIdFailures)) {
            data["uniqueIdFailures"] = [];
            for (let item of this.uniqueIdFailures)
                data["uniqueIdFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.beginDateFailures)) {
            data["beginDateFailures"] = [];
            for (let item of this.beginDateFailures)
                data["beginDateFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.endDateFailures)) {
            data["endDateFailures"] = [];
            for (let item of this.endDateFailures)
                data["endDateFailures"].push(item.toJSON());
        }
        if (Array.isArray(this.statementValidationDataSourceFailures)) {
            data["statementValidationDataSourceFailures"] = [];
            for (let item of this.statementValidationDataSourceFailures)
                data["statementValidationDataSourceFailures"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPostCycleMessageQualificationReportSearchCriteriaValidationResults extends IValidationResults {
    validationFailureGroups?: { [key: string]: Anonymous6[]; } | undefined;
    sysPrinValidationFailures?: PostCycleMessageQualificationReportSysPrinFailure[] | undefined;
    cycleDateFailures?: PostCycleMessageQualificationReportCycleDateFailure[] | undefined;
    messageIdFailures?: PostCycleMessageQualificationReportMessageIdFailure[] | undefined;
    departmentLNameFailures?: PostCycleMessageQualificationReportDepartmentFailure[] | undefined;
    locationIdFailures?: PostCycleMessageQualificationReportLocationIdFailure[] | undefined;
    accountNumberFailures?: PostCycleMessageQualificationReportAccountNumberFailure[] | undefined;
    requestorLNameFailures?: PostCycleMessageQualificationReportRequestorLNameFailure[] | undefined;
    uniqueIdFailures?: PostCycleMessageQualificationReportUniqueIdFailure[] | undefined;
    beginDateFailures?: PostCycleMessageQualificationReportBeginDateFailure[] | undefined;
    endDateFailures?: PostCycleMessageQualificationReportEndDateFailure[] | undefined;
    statementValidationDataSourceFailures?: PostCycleMessageQualificationReportStatementValidationDataSourceFailure[] | undefined;
}

export class PostCycleMessageQualificationReportSysPrinFailure extends ValidationFailure implements IPostCycleMessageQualificationReportSysPrinFailure {

    constructor(data?: IPostCycleMessageQualificationReportSysPrinFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PostCycleMessageQualificationReportSysPrinFailure {
        data = typeof data === 'object' ? data : {};
        let result = new PostCycleMessageQualificationReportSysPrinFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPostCycleMessageQualificationReportSysPrinFailure extends IValidationFailure {
}

export class PostCycleMessageQualificationReportCycleDateFailure extends ValidationFailure implements IPostCycleMessageQualificationReportCycleDateFailure {

    constructor(data?: IPostCycleMessageQualificationReportCycleDateFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PostCycleMessageQualificationReportCycleDateFailure {
        data = typeof data === 'object' ? data : {};
        let result = new PostCycleMessageQualificationReportCycleDateFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPostCycleMessageQualificationReportCycleDateFailure extends IValidationFailure {
}

export class PostCycleMessageQualificationReportMessageIdFailure extends ValidationFailure implements IPostCycleMessageQualificationReportMessageIdFailure {

    constructor(data?: IPostCycleMessageQualificationReportMessageIdFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PostCycleMessageQualificationReportMessageIdFailure {
        data = typeof data === 'object' ? data : {};
        let result = new PostCycleMessageQualificationReportMessageIdFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPostCycleMessageQualificationReportMessageIdFailure extends IValidationFailure {
}

export class PostCycleMessageQualificationReportDepartmentFailure extends ValidationFailure implements IPostCycleMessageQualificationReportDepartmentFailure {

    constructor(data?: IPostCycleMessageQualificationReportDepartmentFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PostCycleMessageQualificationReportDepartmentFailure {
        data = typeof data === 'object' ? data : {};
        let result = new PostCycleMessageQualificationReportDepartmentFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPostCycleMessageQualificationReportDepartmentFailure extends IValidationFailure {
}

export class PostCycleMessageQualificationReportLocationIdFailure extends ValidationFailure implements IPostCycleMessageQualificationReportLocationIdFailure {

    constructor(data?: IPostCycleMessageQualificationReportLocationIdFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PostCycleMessageQualificationReportLocationIdFailure {
        data = typeof data === 'object' ? data : {};
        let result = new PostCycleMessageQualificationReportLocationIdFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPostCycleMessageQualificationReportLocationIdFailure extends IValidationFailure {
}

export class PostCycleMessageQualificationReportAccountNumberFailure extends ValidationFailure implements IPostCycleMessageQualificationReportAccountNumberFailure {

    constructor(data?: IPostCycleMessageQualificationReportAccountNumberFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PostCycleMessageQualificationReportAccountNumberFailure {
        data = typeof data === 'object' ? data : {};
        let result = new PostCycleMessageQualificationReportAccountNumberFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPostCycleMessageQualificationReportAccountNumberFailure extends IValidationFailure {
}

export class PostCycleMessageQualificationReportRequestorLNameFailure extends ValidationFailure implements IPostCycleMessageQualificationReportRequestorLNameFailure {

    constructor(data?: IPostCycleMessageQualificationReportRequestorLNameFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PostCycleMessageQualificationReportRequestorLNameFailure {
        data = typeof data === 'object' ? data : {};
        let result = new PostCycleMessageQualificationReportRequestorLNameFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPostCycleMessageQualificationReportRequestorLNameFailure extends IValidationFailure {
}

export class PostCycleMessageQualificationReportUniqueIdFailure extends ValidationFailure implements IPostCycleMessageQualificationReportUniqueIdFailure {

    constructor(data?: IPostCycleMessageQualificationReportUniqueIdFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PostCycleMessageQualificationReportUniqueIdFailure {
        data = typeof data === 'object' ? data : {};
        let result = new PostCycleMessageQualificationReportUniqueIdFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPostCycleMessageQualificationReportUniqueIdFailure extends IValidationFailure {
}

export class PostCycleMessageQualificationReportBeginDateFailure extends ValidationFailure implements IPostCycleMessageQualificationReportBeginDateFailure {

    constructor(data?: IPostCycleMessageQualificationReportBeginDateFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PostCycleMessageQualificationReportBeginDateFailure {
        data = typeof data === 'object' ? data : {};
        let result = new PostCycleMessageQualificationReportBeginDateFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPostCycleMessageQualificationReportBeginDateFailure extends IValidationFailure {
}

export class PostCycleMessageQualificationReportEndDateFailure extends ValidationFailure implements IPostCycleMessageQualificationReportEndDateFailure {

    constructor(data?: IPostCycleMessageQualificationReportEndDateFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PostCycleMessageQualificationReportEndDateFailure {
        data = typeof data === 'object' ? data : {};
        let result = new PostCycleMessageQualificationReportEndDateFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPostCycleMessageQualificationReportEndDateFailure extends IValidationFailure {
}

export class PostCycleMessageQualificationReportStatementValidationDataSourceFailure extends ValidationFailure implements IPostCycleMessageQualificationReportStatementValidationDataSourceFailure {

    constructor(data?: IPostCycleMessageQualificationReportStatementValidationDataSourceFailure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PostCycleMessageQualificationReportStatementValidationDataSourceFailure {
        data = typeof data === 'object' ? data : {};
        let result = new PostCycleMessageQualificationReportStatementValidationDataSourceFailure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPostCycleMessageQualificationReportStatementValidationDataSourceFailure extends IValidationFailure {
}

export class ValidateUserSelectionsforPostQualReportRequest implements IValidateUserSelectionsforPostQualReportRequest {
    messageId!: string;
    locationId!: string;
    uniqueId!: string;
    accountNumber!: string;
    includeMessageText!: boolean;
    postCycleMessageQualificationReportCounts!: boolean;
    qualifiedMessages!: string;
    first500Records!: boolean;
    beginDate?: Date | undefined;
    beginDateUserEntry!: string;
    endDate?: Date | undefined;
    endDateUserEntry!: string;
    cycleDate?: Date | undefined;
    requestorLName!: string;
    departmentName!: string;
    emailAddress!: string;
    sysPrins!: SysPrinDto[];
    useStatementValidationDataSource!: boolean;

    constructor(data?: IValidateUserSelectionsforPostQualReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sysPrins = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageId = _data["messageId"];
            this.locationId = _data["locationId"];
            this.uniqueId = _data["uniqueId"];
            this.accountNumber = _data["accountNumber"];
            this.includeMessageText = _data["includeMessageText"];
            this.postCycleMessageQualificationReportCounts = _data["postCycleMessageQualificationReportCounts"];
            this.qualifiedMessages = _data["qualifiedMessages"];
            this.first500Records = _data["first500Records"];
            this.beginDate = _data["beginDate"] ? new Date(_data["beginDate"].toString()) : <any>undefined;
            this.beginDateUserEntry = _data["beginDateUserEntry"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.endDateUserEntry = _data["endDateUserEntry"];
            this.cycleDate = _data["cycleDate"] ? new Date(_data["cycleDate"].toString()) : <any>undefined;
            this.requestorLName = _data["requestorLName"];
            this.departmentName = _data["departmentName"];
            this.emailAddress = _data["emailAddress"];
            if (Array.isArray(_data["sysPrins"])) {
                this.sysPrins = [] as any;
                for (let item of _data["sysPrins"])
                    this.sysPrins!.push(SysPrinDto.fromJS(item));
            }
            this.useStatementValidationDataSource = _data["useStatementValidationDataSource"];
        }
    }

    static fromJS(data: any): ValidateUserSelectionsforPostQualReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateUserSelectionsforPostQualReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageId"] = this.messageId;
        data["locationId"] = this.locationId;
        data["uniqueId"] = this.uniqueId;
        data["accountNumber"] = this.accountNumber;
        data["includeMessageText"] = this.includeMessageText;
        data["postCycleMessageQualificationReportCounts"] = this.postCycleMessageQualificationReportCounts;
        data["qualifiedMessages"] = this.qualifiedMessages;
        data["first500Records"] = this.first500Records;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["beginDateUserEntry"] = this.beginDateUserEntry;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["endDateUserEntry"] = this.endDateUserEntry;
        data["cycleDate"] = this.cycleDate ? this.cycleDate.toISOString() : <any>undefined;
        data["requestorLName"] = this.requestorLName;
        data["departmentName"] = this.departmentName;
        data["emailAddress"] = this.emailAddress;
        if (Array.isArray(this.sysPrins)) {
            data["sysPrins"] = [];
            for (let item of this.sysPrins)
                data["sysPrins"].push(item.toJSON());
        }
        data["useStatementValidationDataSource"] = this.useStatementValidationDataSource;
        return data;
    }
}

export interface IValidateUserSelectionsforPostQualReportRequest {
    messageId: string;
    locationId: string;
    uniqueId: string;
    accountNumber: string;
    includeMessageText: boolean;
    postCycleMessageQualificationReportCounts: boolean;
    qualifiedMessages: string;
    first500Records: boolean;
    beginDate?: Date | undefined;
    beginDateUserEntry: string;
    endDate?: Date | undefined;
    endDateUserEntry: string;
    cycleDate?: Date | undefined;
    requestorLName: string;
    departmentName: string;
    emailAddress: string;
    sysPrins: SysPrinDto[];
    useStatementValidationDataSource: boolean;
}

export class ExportPostQualReportRequest extends ValidateUserSelectionsforPostQualReportRequest implements IExportPostQualReportRequest {

    constructor(data?: IExportPostQualReportRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ExportPostQualReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExportPostQualReportRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IExportPostQualReportRequest extends IValidateUserSelectionsforPostQualReportRequest {
}

export class GetNonQualifiedMessageReportResponse implements IGetNonQualifiedMessageReportResponse {
    nonQualifiedMessages!: NonQualifiedMessageDto[];

    constructor(data?: IGetNonQualifiedMessageReportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.nonQualifiedMessages = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["nonQualifiedMessages"])) {
                this.nonQualifiedMessages = [] as any;
                for (let item of _data["nonQualifiedMessages"])
                    this.nonQualifiedMessages!.push(NonQualifiedMessageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNonQualifiedMessageReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetNonQualifiedMessageReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.nonQualifiedMessages)) {
            data["nonQualifiedMessages"] = [];
            for (let item of this.nonQualifiedMessages)
                data["nonQualifiedMessages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetNonQualifiedMessageReportResponse {
    nonQualifiedMessages: NonQualifiedMessageDto[];
}

export class NonQualifiedMessageDto implements INonQualifiedMessageDto {
    sysPrin!: SysPrinDto;
    messageUniqueId!: number;
    description!: string;
    messageId!: string;
    beginDateUserEntry!: string;
    beginDate?: Date | undefined;
    endDateUserEntry!: string;
    endDate?: Date | undefined;
    location!: string;
    docType!: string;
    createdOn?: Date | undefined;
    createdOnUserEntry!: string;
    nonQualifiedOn?: Date | undefined;
    nonQualifiedOnUserEntry!: string;
    loadedOn?: Date | undefined;
    lastUpdatedOn?: Date | undefined;
    lastUpdatedOnUserEntry!: string;
    lastUpdatedBy!: string;

    constructor(data?: INonQualifiedMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sysPrin = new SysPrinDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sysPrin = _data["sysPrin"] ? SysPrinDto.fromJS(_data["sysPrin"]) : new SysPrinDto();
            this.messageUniqueId = _data["messageUniqueId"];
            this.description = _data["description"];
            this.messageId = _data["messageId"];
            this.beginDateUserEntry = _data["beginDateUserEntry"];
            this.beginDate = _data["beginDate"] ? new Date(_data["beginDate"].toString()) : <any>undefined;
            this.endDateUserEntry = _data["endDateUserEntry"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.location = _data["location"];
            this.docType = _data["docType"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdOnUserEntry = _data["createdOnUserEntry"];
            this.nonQualifiedOn = _data["nonQualifiedOn"] ? new Date(_data["nonQualifiedOn"].toString()) : <any>undefined;
            this.nonQualifiedOnUserEntry = _data["nonQualifiedOnUserEntry"];
            this.loadedOn = _data["loadedOn"] ? new Date(_data["loadedOn"].toString()) : <any>undefined;
            this.lastUpdatedOn = _data["lastUpdatedOn"] ? new Date(_data["lastUpdatedOn"].toString()) : <any>undefined;
            this.lastUpdatedOnUserEntry = _data["lastUpdatedOnUserEntry"];
            this.lastUpdatedBy = _data["lastUpdatedBy"];
        }
    }

    static fromJS(data: any): NonQualifiedMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new NonQualifiedMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sysPrin"] = this.sysPrin ? this.sysPrin.toJSON() : <any>undefined;
        data["messageUniqueId"] = this.messageUniqueId;
        data["description"] = this.description;
        data["messageId"] = this.messageId;
        data["beginDateUserEntry"] = this.beginDateUserEntry;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDateUserEntry"] = this.endDateUserEntry;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["location"] = this.location;
        data["docType"] = this.docType;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdOnUserEntry"] = this.createdOnUserEntry;
        data["nonQualifiedOn"] = this.nonQualifiedOn ? this.nonQualifiedOn.toISOString() : <any>undefined;
        data["nonQualifiedOnUserEntry"] = this.nonQualifiedOnUserEntry;
        data["loadedOn"] = this.loadedOn ? this.loadedOn.toISOString() : <any>undefined;
        data["lastUpdatedOn"] = this.lastUpdatedOn ? this.lastUpdatedOn.toISOString() : <any>undefined;
        data["lastUpdatedOnUserEntry"] = this.lastUpdatedOnUserEntry;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        return data;
    }
}

export interface INonQualifiedMessageDto {
    sysPrin: SysPrinDto;
    messageUniqueId: number;
    description: string;
    messageId: string;
    beginDateUserEntry: string;
    beginDate?: Date | undefined;
    endDateUserEntry: string;
    endDate?: Date | undefined;
    location: string;
    docType: string;
    createdOn?: Date | undefined;
    createdOnUserEntry: string;
    nonQualifiedOn?: Date | undefined;
    nonQualifiedOnUserEntry: string;
    loadedOn?: Date | undefined;
    lastUpdatedOn?: Date | undefined;
    lastUpdatedOnUserEntry: string;
    lastUpdatedBy: string;
}

export class GetNonQualifiedMessageReportRequest implements IGetNonQualifiedMessageReportRequest {
    sysPrins!: SysPrinDto[];
    docTypeId!: number;
    beginDate?: Date | undefined;
    beginDateUserEntry!: string;
    endDate?: Date | undefined;
    endDateUserEntry!: string;

    constructor(data?: IGetNonQualifiedMessageReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sysPrins = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sysPrins"])) {
                this.sysPrins = [] as any;
                for (let item of _data["sysPrins"])
                    this.sysPrins!.push(SysPrinDto.fromJS(item));
            }
            this.docTypeId = _data["docTypeId"];
            this.beginDate = _data["beginDate"] ? new Date(_data["beginDate"].toString()) : <any>undefined;
            this.beginDateUserEntry = _data["beginDateUserEntry"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.endDateUserEntry = _data["endDateUserEntry"];
        }
    }

    static fromJS(data: any): GetNonQualifiedMessageReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetNonQualifiedMessageReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sysPrins)) {
            data["sysPrins"] = [];
            for (let item of this.sysPrins)
                data["sysPrins"].push(item.toJSON());
        }
        data["docTypeId"] = this.docTypeId;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["beginDateUserEntry"] = this.beginDateUserEntry;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["endDateUserEntry"] = this.endDateUserEntry;
        return data;
    }
}

export interface IGetNonQualifiedMessageReportRequest {
    sysPrins: SysPrinDto[];
    docTypeId: number;
    beginDate?: Date | undefined;
    beginDateUserEntry: string;
    endDate?: Date | undefined;
    endDateUserEntry: string;
}

export class GetNonQualifiedMessageChartDataResponse implements IGetNonQualifiedMessageChartDataResponse {
    nonQualifiedMessagesChartData!: NonQualifiedMessagesChartDto[];

    constructor(data?: IGetNonQualifiedMessageChartDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.nonQualifiedMessagesChartData = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["nonQualifiedMessagesChartData"])) {
                this.nonQualifiedMessagesChartData = [] as any;
                for (let item of _data["nonQualifiedMessagesChartData"])
                    this.nonQualifiedMessagesChartData!.push(NonQualifiedMessagesChartDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNonQualifiedMessageChartDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetNonQualifiedMessageChartDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.nonQualifiedMessagesChartData)) {
            data["nonQualifiedMessagesChartData"] = [];
            for (let item of this.nonQualifiedMessagesChartData)
                data["nonQualifiedMessagesChartData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetNonQualifiedMessageChartDataResponse {
    nonQualifiedMessagesChartData: NonQualifiedMessagesChartDto[];
}

export class NonQualifiedMessagesChartDto implements INonQualifiedMessagesChartDto {
    nonQualifiedDate?: Date | undefined;
    messageCount?: number | undefined;

    constructor(data?: INonQualifiedMessagesChartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nonQualifiedDate = _data["nonQualifiedDate"] ? new Date(_data["nonQualifiedDate"].toString()) : <any>undefined;
            this.messageCount = _data["messageCount"];
        }
    }

    static fromJS(data: any): NonQualifiedMessagesChartDto {
        data = typeof data === 'object' ? data : {};
        let result = new NonQualifiedMessagesChartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nonQualifiedDate"] = this.nonQualifiedDate ? this.nonQualifiedDate.toISOString() : <any>undefined;
        data["messageCount"] = this.messageCount;
        return data;
    }
}

export interface INonQualifiedMessagesChartDto {
    nonQualifiedDate?: Date | undefined;
    messageCount?: number | undefined;
}

export class GetNonQualifiedMessageChartDataRequest extends GetNonQualifiedMessageReportRequest implements IGetNonQualifiedMessageChartDataRequest {

    constructor(data?: IGetNonQualifiedMessageChartDataRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetNonQualifiedMessageChartDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetNonQualifiedMessageChartDataRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetNonQualifiedMessageChartDataRequest extends IGetNonQualifiedMessageReportRequest {
}

export class GetOlmStartEndMessageCountChartDataResponse implements IGetOlmStartEndMessageCountChartDataResponse {
    startingSoonMessageCount!: number;
    endingSoonMessageCount!: number;
    totalMessageCount!: number;

    constructor(data?: IGetOlmStartEndMessageCountChartDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startingSoonMessageCount = _data["startingSoonMessageCount"];
            this.endingSoonMessageCount = _data["endingSoonMessageCount"];
            this.totalMessageCount = _data["totalMessageCount"];
        }
    }

    static fromJS(data: any): GetOlmStartEndMessageCountChartDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOlmStartEndMessageCountChartDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startingSoonMessageCount"] = this.startingSoonMessageCount;
        data["endingSoonMessageCount"] = this.endingSoonMessageCount;
        data["totalMessageCount"] = this.totalMessageCount;
        return data;
    }
}

export interface IGetOlmStartEndMessageCountChartDataResponse {
    startingSoonMessageCount: number;
    endingSoonMessageCount: number;
    totalMessageCount: number;
}

export class GetOlmStartEndMessageCountChartDataRequest extends GetNonQualifiedMessageReportRequest implements IGetOlmStartEndMessageCountChartDataRequest {

    constructor(data?: IGetOlmStartEndMessageCountChartDataRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetOlmStartEndMessageCountChartDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetOlmStartEndMessageCountChartDataRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetOlmStartEndMessageCountChartDataRequest extends IGetNonQualifiedMessageReportRequest {
}

export class GetQualifiedAppliedMessageChartDataResponse implements IGetQualifiedAppliedMessageChartDataResponse {
    qualifiedAppliedMessagesChartData!: QualifiedAppliedMessagesChartDto[];

    constructor(data?: IGetQualifiedAppliedMessageChartDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.qualifiedAppliedMessagesChartData = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["qualifiedAppliedMessagesChartData"])) {
                this.qualifiedAppliedMessagesChartData = [] as any;
                for (let item of _data["qualifiedAppliedMessagesChartData"])
                    this.qualifiedAppliedMessagesChartData!.push(QualifiedAppliedMessagesChartDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetQualifiedAppliedMessageChartDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetQualifiedAppliedMessageChartDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.qualifiedAppliedMessagesChartData)) {
            data["qualifiedAppliedMessagesChartData"] = [];
            for (let item of this.qualifiedAppliedMessagesChartData)
                data["qualifiedAppliedMessagesChartData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetQualifiedAppliedMessageChartDataResponse {
    qualifiedAppliedMessagesChartData: QualifiedAppliedMessagesChartDto[];
}

export class QualifiedAppliedMessagesChartDto implements IQualifiedAppliedMessagesChartDto {
    month!: string;
    qualifiedMsgCount!: number;
    appliedMsgCount!: number;
    nonQualifiedMsgCount!: number;

    constructor(data?: IQualifiedAppliedMessagesChartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"];
            this.qualifiedMsgCount = _data["qualifiedMsgCount"];
            this.appliedMsgCount = _data["appliedMsgCount"];
            this.nonQualifiedMsgCount = _data["nonQualifiedMsgCount"];
        }
    }

    static fromJS(data: any): QualifiedAppliedMessagesChartDto {
        data = typeof data === 'object' ? data : {};
        let result = new QualifiedAppliedMessagesChartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["qualifiedMsgCount"] = this.qualifiedMsgCount;
        data["appliedMsgCount"] = this.appliedMsgCount;
        data["nonQualifiedMsgCount"] = this.nonQualifiedMsgCount;
        return data;
    }
}

export interface IQualifiedAppliedMessagesChartDto {
    month: string;
    qualifiedMsgCount: number;
    appliedMsgCount: number;
    nonQualifiedMsgCount: number;
}

export class GetQualifiedAppliedMessageChartDataRequest extends GetNonQualifiedMessageReportRequest implements IGetQualifiedAppliedMessageChartDataRequest {

    constructor(data?: IGetQualifiedAppliedMessageChartDataRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetQualifiedAppliedMessageChartDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetQualifiedAppliedMessageChartDataRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetQualifiedAppliedMessageChartDataRequest extends IGetNonQualifiedMessageReportRequest {
}

export class GetSelectivityChangesReportResponse implements IGetSelectivityChangesReportResponse {
    selectivityChangesReport!: MessagesWithSelectivityChange[];

    constructor(data?: IGetSelectivityChangesReportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.selectivityChangesReport = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["selectivityChangesReport"])) {
                this.selectivityChangesReport = [] as any;
                for (let item of _data["selectivityChangesReport"])
                    this.selectivityChangesReport!.push(MessagesWithSelectivityChange.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSelectivityChangesReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSelectivityChangesReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.selectivityChangesReport)) {
            data["selectivityChangesReport"] = [];
            for (let item of this.selectivityChangesReport)
                data["selectivityChangesReport"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSelectivityChangesReportResponse {
    selectivityChangesReport: MessagesWithSelectivityChange[];
}

export class MessagesWithSelectivityChange implements IMessagesWithSelectivityChange {
    uniqueId!: number;
    messageId!: string;
    description!: string;
    location!: string;
    status!: string;
    beginDt!: Date;
    beginDtUserEntry!: string;
    endDt?: Date | undefined;
    endDtUserEntry!: string;
    changeDate?: Date | undefined;
    changeDateUserEntry!: string;
    changeUserId!: string;
    sysPrin!: string;
    sysPrinCount!: number;
    graphicId!: string;

    constructor(data?: IMessagesWithSelectivityChange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.messageId = _data["messageId"];
            this.description = _data["description"];
            this.location = _data["location"];
            this.status = _data["status"];
            this.beginDt = _data["beginDt"] ? new Date(_data["beginDt"].toString()) : <any>undefined;
            this.beginDtUserEntry = _data["beginDtUserEntry"];
            this.endDt = _data["endDt"] ? new Date(_data["endDt"].toString()) : <any>undefined;
            this.endDtUserEntry = _data["endDtUserEntry"];
            this.changeDate = _data["changeDate"] ? new Date(_data["changeDate"].toString()) : <any>undefined;
            this.changeDateUserEntry = _data["changeDateUserEntry"];
            this.changeUserId = _data["changeUserId"];
            this.sysPrin = _data["sysPrin"];
            this.sysPrinCount = _data["sysPrinCount"];
            this.graphicId = _data["graphicId"];
        }
    }

    static fromJS(data: any): MessagesWithSelectivityChange {
        data = typeof data === 'object' ? data : {};
        let result = new MessagesWithSelectivityChange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["messageId"] = this.messageId;
        data["description"] = this.description;
        data["location"] = this.location;
        data["status"] = this.status;
        data["beginDt"] = this.beginDt ? this.beginDt.toISOString() : <any>undefined;
        data["beginDtUserEntry"] = this.beginDtUserEntry;
        data["endDt"] = this.endDt ? this.endDt.toISOString() : <any>undefined;
        data["endDtUserEntry"] = this.endDtUserEntry;
        data["changeDate"] = this.changeDate ? this.changeDate.toISOString() : <any>undefined;
        data["changeDateUserEntry"] = this.changeDateUserEntry;
        data["changeUserId"] = this.changeUserId;
        data["sysPrin"] = this.sysPrin;
        data["sysPrinCount"] = this.sysPrinCount;
        data["graphicId"] = this.graphicId;
        return data;
    }
}

export interface IMessagesWithSelectivityChange {
    uniqueId: number;
    messageId: string;
    description: string;
    location: string;
    status: string;
    beginDt: Date;
    beginDtUserEntry: string;
    endDt?: Date | undefined;
    endDtUserEntry: string;
    changeDate?: Date | undefined;
    changeDateUserEntry: string;
    changeUserId: string;
    sysPrin: string;
    sysPrinCount: number;
    graphicId: string;
}

export class GetSelectivityChangesReportRequest implements IGetSelectivityChangesReportRequest {
    sysPrins!: SysPrinDto[];
    docTypeId!: number;

    constructor(data?: IGetSelectivityChangesReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sysPrins = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sysPrins"])) {
                this.sysPrins = [] as any;
                for (let item of _data["sysPrins"])
                    this.sysPrins!.push(SysPrinDto.fromJS(item));
            }
            this.docTypeId = _data["docTypeId"];
        }
    }

    static fromJS(data: any): GetSelectivityChangesReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSelectivityChangesReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sysPrins)) {
            data["sysPrins"] = [];
            for (let item of this.sysPrins)
                data["sysPrins"].push(item.toJSON());
        }
        data["docTypeId"] = this.docTypeId;
        return data;
    }
}

export interface IGetSelectivityChangesReportRequest {
    sysPrins: SysPrinDto[];
    docTypeId: number;
}

export class GetMessagesWithHardcopyFlagReportResponse implements IGetMessagesWithHardcopyFlagReportResponse {
    messagesWithHardcopyReport!: MessageWithHardcopyDto[];

    constructor(data?: IGetMessagesWithHardcopyFlagReportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messagesWithHardcopyReport = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messagesWithHardcopyReport"])) {
                this.messagesWithHardcopyReport = [] as any;
                for (let item of _data["messagesWithHardcopyReport"])
                    this.messagesWithHardcopyReport!.push(MessageWithHardcopyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMessagesWithHardcopyFlagReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMessagesWithHardcopyFlagReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messagesWithHardcopyReport)) {
            data["messagesWithHardcopyReport"] = [];
            for (let item of this.messagesWithHardcopyReport)
                data["messagesWithHardcopyReport"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMessagesWithHardcopyFlagReportResponse {
    messagesWithHardcopyReport: MessageWithHardcopyDto[];
}

export class MessageWithHardcopyDto implements IMessageWithHardcopyDto {
    uniqueId!: number;
    messageId!: string;
    graphicId!: string;
    sysPrins!: string;
    messageDescription!: string;
    location!: string;
    status!: string;
    beginDt!: Date;
    beginDtUserEntry!: string;
    endDt?: Date | undefined;
    endDtUserEntry!: string;
    sysPrinCount!: number;

    constructor(data?: IMessageWithHardcopyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.messageId = _data["messageId"];
            this.graphicId = _data["graphicId"];
            this.sysPrins = _data["sysPrins"];
            this.messageDescription = _data["messageDescription"];
            this.location = _data["location"];
            this.status = _data["status"];
            this.beginDt = _data["beginDt"] ? new Date(_data["beginDt"].toString()) : <any>undefined;
            this.beginDtUserEntry = _data["beginDtUserEntry"];
            this.endDt = _data["endDt"] ? new Date(_data["endDt"].toString()) : <any>undefined;
            this.endDtUserEntry = _data["endDtUserEntry"];
            this.sysPrinCount = _data["sysPrinCount"];
        }
    }

    static fromJS(data: any): MessageWithHardcopyDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageWithHardcopyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["messageId"] = this.messageId;
        data["graphicId"] = this.graphicId;
        data["sysPrins"] = this.sysPrins;
        data["messageDescription"] = this.messageDescription;
        data["location"] = this.location;
        data["status"] = this.status;
        data["beginDt"] = this.beginDt ? this.beginDt.toISOString() : <any>undefined;
        data["beginDtUserEntry"] = this.beginDtUserEntry;
        data["endDt"] = this.endDt ? this.endDt.toISOString() : <any>undefined;
        data["endDtUserEntry"] = this.endDtUserEntry;
        data["sysPrinCount"] = this.sysPrinCount;
        return data;
    }
}

export interface IMessageWithHardcopyDto {
    uniqueId: number;
    messageId: string;
    graphicId: string;
    sysPrins: string;
    messageDescription: string;
    location: string;
    status: string;
    beginDt: Date;
    beginDtUserEntry: string;
    endDt?: Date | undefined;
    endDtUserEntry: string;
    sysPrinCount: number;
}

export class GetMessagesWithHardcopyFlagReportRequest extends GetSelectivityChangesReportRequest implements IGetMessagesWithHardcopyFlagReportRequest {

    constructor(data?: IGetMessagesWithHardcopyFlagReportRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetMessagesWithHardcopyFlagReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMessagesWithHardcopyFlagReportRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetMessagesWithHardcopyFlagReportRequest extends IGetSelectivityChangesReportRequest {
}

export class GetSelectivitySourcesResponse implements IGetSelectivitySourcesResponse {
    selectivitySourceDtos!: SelectivitySourceDto[];

    constructor(data?: IGetSelectivitySourcesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.selectivitySourceDtos = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["selectivitySourceDtos"])) {
                this.selectivitySourceDtos = [] as any;
                for (let item of _data["selectivitySourceDtos"])
                    this.selectivitySourceDtos!.push(SelectivitySourceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSelectivitySourcesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSelectivitySourcesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.selectivitySourceDtos)) {
            data["selectivitySourceDtos"] = [];
            for (let item of this.selectivitySourceDtos)
                data["selectivitySourceDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSelectivitySourcesResponse {
    selectivitySourceDtos: SelectivitySourceDto[];
}

export class SelectivitySourceDto implements ISelectivitySourceDto {
    displayName!: string;
    source!: SelectivitySource;

    constructor(data?: ISelectivitySourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.source = _data["source"];
        }
    }

    static fromJS(data: any): SelectivitySourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectivitySourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["source"] = this.source;
        return data;
    }
}

export interface ISelectivitySourceDto {
    displayName: string;
    source: SelectivitySource;
}

export enum SelectivitySource {
    Always = 0,
    ExternalFileOnly = 1,
    MmSelectivityAndExternalFile = 2,
    MmSelectivityOnly = 3,
    MmSelectivityOrExternalFile = 4,
    VantageQueryAndExternalFile = 5,
    VantageQueryOnly = 6,
}

export class GetSelectivitySourcesRequest implements IGetSelectivitySourcesRequest {

    constructor(data?: IGetSelectivitySourcesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetSelectivitySourcesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSelectivitySourcesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetSelectivitySourcesRequest {
}

export class GetAvailableSelectivityCopyActionsResponse implements IGetAvailableSelectivityCopyActionsResponse {
    selectivityCopyActions!: SelectivityCopyActionDto[];

    constructor(data?: IGetAvailableSelectivityCopyActionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.selectivityCopyActions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["selectivityCopyActions"])) {
                this.selectivityCopyActions = [] as any;
                for (let item of _data["selectivityCopyActions"])
                    this.selectivityCopyActions!.push(SelectivityCopyActionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAvailableSelectivityCopyActionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvailableSelectivityCopyActionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.selectivityCopyActions)) {
            data["selectivityCopyActions"] = [];
            for (let item of this.selectivityCopyActions)
                data["selectivityCopyActions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAvailableSelectivityCopyActionsResponse {
    selectivityCopyActions: SelectivityCopyActionDto[];
}

export class SelectivityCopyActionDto implements ISelectivityCopyActionDto {
    displayName!: string;
    selectivityCopyAction!: MessageSelectivityCopyAction;

    constructor(data?: ISelectivityCopyActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.selectivityCopyAction = _data["selectivityCopyAction"];
        }
    }

    static fromJS(data: any): SelectivityCopyActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectivityCopyActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["selectivityCopyAction"] = this.selectivityCopyAction;
        return data;
    }
}

export interface ISelectivityCopyActionDto {
    displayName: string;
    selectivityCopyAction: MessageSelectivityCopyAction;
}

export enum MessageSelectivityCopyAction {
    NoActionSelected = 0,
    ReplaceWithSelectivityFromATemplate = 1,
    ReplaceWithSelectivityFromAnotherMessage = 2,
    AppendWithSelectivityFromATemplateWithAnAnd = 3,
    AppendWithSelectivityFromAMessageWithAnAnd = 4,
    AppendWithSelectivityFromATemplateWithAnOr = 5,
    AppendWithSelectivityFromAMessageWithAnOr = 6,
}

export class GetAvailableSelectivityCopyActionsRequest implements IGetAvailableSelectivityCopyActionsRequest {
    currentMessageInclusionOperator?: InclusionOperator | undefined;

    constructor(data?: IGetAvailableSelectivityCopyActionsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentMessageInclusionOperator = _data["currentMessageInclusionOperator"];
        }
    }

    static fromJS(data: any): GetAvailableSelectivityCopyActionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvailableSelectivityCopyActionsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentMessageInclusionOperator"] = this.currentMessageInclusionOperator;
        return data;
    }
}

export interface IGetAvailableSelectivityCopyActionsRequest {
    currentMessageInclusionOperator?: InclusionOperator | undefined;
}

export class GetAvailableSelectivityProfilesForMergeIntoMessageResponse implements IGetAvailableSelectivityProfilesForMergeIntoMessageResponse {
    availableSelectivityMergeInfos!: MessageSelectivityMergeInfoDto[];

    constructor(data?: IGetAvailableSelectivityProfilesForMergeIntoMessageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.availableSelectivityMergeInfos = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["availableSelectivityMergeInfos"])) {
                this.availableSelectivityMergeInfos = [] as any;
                for (let item of _data["availableSelectivityMergeInfos"])
                    this.availableSelectivityMergeInfos!.push(MessageSelectivityMergeInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAvailableSelectivityProfilesForMergeIntoMessageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvailableSelectivityProfilesForMergeIntoMessageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.availableSelectivityMergeInfos)) {
            data["availableSelectivityMergeInfos"] = [];
            for (let item of this.availableSelectivityMergeInfos)
                data["availableSelectivityMergeInfos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAvailableSelectivityProfilesForMergeIntoMessageResponse {
    availableSelectivityMergeInfos: MessageSelectivityMergeInfoDto[];
}

export class MessageSelectivityMergeInfoDto implements IMessageSelectivityMergeInfoDto {
    displayName!: string;
    selectivityProfileUniqueId!: number;

    constructor(data?: IMessageSelectivityMergeInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.selectivityProfileUniqueId = _data["selectivityProfileUniqueId"];
        }
    }

    static fromJS(data: any): MessageSelectivityMergeInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageSelectivityMergeInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["selectivityProfileUniqueId"] = this.selectivityProfileUniqueId;
        return data;
    }
}

export interface IMessageSelectivityMergeInfoDto {
    displayName: string;
    selectivityProfileUniqueId: number;
}

export class GetAvailableSelectivityProfilesForMergeIntoMessageRequest implements IGetAvailableSelectivityProfilesForMergeIntoMessageRequest {
    uniqueIdForMessageBeingEdited?: number | undefined;
    docTypeUniqueId!: number;
    requestedSysPrin!: SysPrin;
    currentMessageInclusionOperator!: InclusionOperator;
    requestedMessageSelectivityCopyAction!: MessageSelectivityCopyAction;

    constructor(data?: IGetAvailableSelectivityProfilesForMergeIntoMessageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.requestedSysPrin = new SysPrin();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueIdForMessageBeingEdited = _data["uniqueIdForMessageBeingEdited"];
            this.docTypeUniqueId = _data["docTypeUniqueId"];
            this.requestedSysPrin = _data["requestedSysPrin"] ? SysPrin.fromJS(_data["requestedSysPrin"]) : new SysPrin();
            this.currentMessageInclusionOperator = _data["currentMessageInclusionOperator"];
            this.requestedMessageSelectivityCopyAction = _data["requestedMessageSelectivityCopyAction"];
        }
    }

    static fromJS(data: any): GetAvailableSelectivityProfilesForMergeIntoMessageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvailableSelectivityProfilesForMergeIntoMessageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueIdForMessageBeingEdited"] = this.uniqueIdForMessageBeingEdited;
        data["docTypeUniqueId"] = this.docTypeUniqueId;
        data["requestedSysPrin"] = this.requestedSysPrin ? this.requestedSysPrin.toJSON() : <any>undefined;
        data["currentMessageInclusionOperator"] = this.currentMessageInclusionOperator;
        data["requestedMessageSelectivityCopyAction"] = this.requestedMessageSelectivityCopyAction;
        return data;
    }
}

export interface IGetAvailableSelectivityProfilesForMergeIntoMessageRequest {
    uniqueIdForMessageBeingEdited?: number | undefined;
    docTypeUniqueId: number;
    requestedSysPrin: SysPrin;
    currentMessageInclusionOperator: InclusionOperator;
    requestedMessageSelectivityCopyAction: MessageSelectivityCopyAction;
}

export class CopySelectivityIntoMessageResponse implements ICopySelectivityIntoMessageResponse {
    mergedSelectivityProfile!: OlmSelectivityProfile;

    constructor(data?: ICopySelectivityIntoMessageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.mergedSelectivityProfile = new OlmSelectivityProfile();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mergedSelectivityProfile = _data["mergedSelectivityProfile"] ? OlmSelectivityProfile.fromJS(_data["mergedSelectivityProfile"]) : new OlmSelectivityProfile();
        }
    }

    static fromJS(data: any): CopySelectivityIntoMessageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CopySelectivityIntoMessageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mergedSelectivityProfile"] = this.mergedSelectivityProfile ? this.mergedSelectivityProfile.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICopySelectivityIntoMessageResponse {
    mergedSelectivityProfile: OlmSelectivityProfile;
}

export class CopySelectivityIntoMessageRequest implements ICopySelectivityIntoMessageRequest {
    currentMessageSelectivity!: OlmSelectivityProfile;
    uniqueIdOfSelectivityProfileMergeIntoMessage!: number;
    requestedSysPrin!: SysPrin;
    requestedMessageSelectivityCopyAction!: MessageSelectivityCopyAction;

    constructor(data?: ICopySelectivityIntoMessageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.currentMessageSelectivity = new OlmSelectivityProfile();
            this.requestedSysPrin = new SysPrin();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentMessageSelectivity = _data["currentMessageSelectivity"] ? OlmSelectivityProfile.fromJS(_data["currentMessageSelectivity"]) : new OlmSelectivityProfile();
            this.uniqueIdOfSelectivityProfileMergeIntoMessage = _data["uniqueIdOfSelectivityProfileMergeIntoMessage"];
            this.requestedSysPrin = _data["requestedSysPrin"] ? SysPrin.fromJS(_data["requestedSysPrin"]) : new SysPrin();
            this.requestedMessageSelectivityCopyAction = _data["requestedMessageSelectivityCopyAction"];
        }
    }

    static fromJS(data: any): CopySelectivityIntoMessageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CopySelectivityIntoMessageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentMessageSelectivity"] = this.currentMessageSelectivity ? this.currentMessageSelectivity.toJSON() : <any>undefined;
        data["uniqueIdOfSelectivityProfileMergeIntoMessage"] = this.uniqueIdOfSelectivityProfileMergeIntoMessage;
        data["requestedSysPrin"] = this.requestedSysPrin ? this.requestedSysPrin.toJSON() : <any>undefined;
        data["requestedMessageSelectivityCopyAction"] = this.requestedMessageSelectivityCopyAction;
        return data;
    }
}

export interface ICopySelectivityIntoMessageRequest {
    currentMessageSelectivity: OlmSelectivityProfile;
    uniqueIdOfSelectivityProfileMergeIntoMessage: number;
    requestedSysPrin: SysPrin;
    requestedMessageSelectivityCopyAction: MessageSelectivityCopyAction;
}

export class SaveSelectivityProfileAsATemplateResponse implements ISaveSelectivityProfileAsATemplateResponse {

    constructor(data?: ISaveSelectivityProfileAsATemplateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SaveSelectivityProfileAsATemplateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveSelectivityProfileAsATemplateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ISaveSelectivityProfileAsATemplateResponse {
}

export class SaveSelectivityProfileAsATemplateRequest implements ISaveSelectivityProfileAsATemplateRequest {
    messageWithSelectivityProfile!: OlmMessage;
    templateName!: string;
    overwriteExistingTemplateWithSameNameIfItExists!: boolean;

    constructor(data?: ISaveSelectivityProfileAsATemplateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messageWithSelectivityProfile = new OlmMessage();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageWithSelectivityProfile = _data["messageWithSelectivityProfile"] ? OlmMessage.fromJS(_data["messageWithSelectivityProfile"]) : new OlmMessage();
            this.templateName = _data["templateName"];
            this.overwriteExistingTemplateWithSameNameIfItExists = _data["overwriteExistingTemplateWithSameNameIfItExists"];
        }
    }

    static fromJS(data: any): SaveSelectivityProfileAsATemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveSelectivityProfileAsATemplateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageWithSelectivityProfile"] = this.messageWithSelectivityProfile ? this.messageWithSelectivityProfile.toJSON() : <any>undefined;
        data["templateName"] = this.templateName;
        data["overwriteExistingTemplateWithSameNameIfItExists"] = this.overwriteExistingTemplateWithSameNameIfItExists;
        return data;
    }
}

export interface ISaveSelectivityProfileAsATemplateRequest {
    messageWithSelectivityProfile: OlmMessage;
    templateName: string;
    overwriteExistingTemplateWithSameNameIfItExists: boolean;
}

export class GetSelectivityFieldsByDocTypeResponse implements IGetSelectivityFieldsByDocTypeResponse {
    fields!: KeyValuePairOfIntegerAndOlmField[];

    constructor(data?: IGetSelectivityFieldsByDocTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.fields = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(KeyValuePairOfIntegerAndOlmField.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSelectivityFieldsByDocTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSelectivityFieldsByDocTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSelectivityFieldsByDocTypeResponse {
    fields: KeyValuePairOfIntegerAndOlmField[];
}

export class KeyValuePairOfIntegerAndOlmField implements IKeyValuePairOfIntegerAndOlmField {
    key!: number;
    value?: OlmField | undefined;

    constructor(data?: IKeyValuePairOfIntegerAndOlmField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"] ? OlmField.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): KeyValuePairOfIntegerAndOlmField {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePairOfIntegerAndOlmField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IKeyValuePairOfIntegerAndOlmField {
    key: number;
    value?: OlmField | undefined;
}

export class GetSelectivityFieldsByDocTypeRequest implements IGetSelectivityFieldsByDocTypeRequest {
    docTypeUniqueId!: number;
    filterOperands!: boolean;

    constructor(data?: IGetSelectivityFieldsByDocTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.docTypeUniqueId = _data["docTypeUniqueId"];
            this.filterOperands = _data["filterOperands"];
        }
    }

    static fromJS(data: any): GetSelectivityFieldsByDocTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSelectivityFieldsByDocTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docTypeUniqueId"] = this.docTypeUniqueId;
        data["filterOperands"] = this.filterOperands;
        return data;
    }
}

export interface IGetSelectivityFieldsByDocTypeRequest {
    docTypeUniqueId: number;
    filterOperands: boolean;
}

export class GetSelectivityOperandsResponse implements IGetSelectivityOperandsResponse {
    selectivityOperands!: SelectivityOperandDto[];

    constructor(data?: IGetSelectivityOperandsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.selectivityOperands = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["selectivityOperands"])) {
                this.selectivityOperands = [] as any;
                for (let item of _data["selectivityOperands"])
                    this.selectivityOperands!.push(SelectivityOperandDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSelectivityOperandsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSelectivityOperandsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.selectivityOperands)) {
            data["selectivityOperands"] = [];
            for (let item of this.selectivityOperands)
                data["selectivityOperands"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSelectivityOperandsResponse {
    selectivityOperands: SelectivityOperandDto[];
}

export class SelectivityOperandDto implements ISelectivityOperandDto {
    textToDisplay!: string;
    value!: number;

    constructor(data?: ISelectivityOperandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.textToDisplay = _data["textToDisplay"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SelectivityOperandDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectivityOperandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["textToDisplay"] = this.textToDisplay;
        data["value"] = this.value;
        return data;
    }
}

export interface ISelectivityOperandDto {
    textToDisplay: string;
    value: number;
}

export class GetSelectivityOperandsRequest implements IGetSelectivityOperandsRequest {
    docTypeUniqueId!: number;
    fieldId!: number;

    constructor(data?: IGetSelectivityOperandsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.docTypeUniqueId = _data["docTypeUniqueId"];
            this.fieldId = _data["fieldId"];
        }
    }

    static fromJS(data: any): GetSelectivityOperandsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSelectivityOperandsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docTypeUniqueId"] = this.docTypeUniqueId;
        data["fieldId"] = this.fieldId;
        return data;
    }
}

export interface IGetSelectivityOperandsRequest {
    docTypeUniqueId: number;
    fieldId: number;
}

export class AssignCombinedCriteriaIdsResponse implements IAssignCombinedCriteriaIdsResponse {
    selectivityProfile!: OlmSelectivityProfile;

    constructor(data?: IAssignCombinedCriteriaIdsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.selectivityProfile = new OlmSelectivityProfile();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selectivityProfile = _data["selectivityProfile"] ? OlmSelectivityProfile.fromJS(_data["selectivityProfile"]) : new OlmSelectivityProfile();
        }
    }

    static fromJS(data: any): AssignCombinedCriteriaIdsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AssignCombinedCriteriaIdsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selectivityProfile"] = this.selectivityProfile ? this.selectivityProfile.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAssignCombinedCriteriaIdsResponse {
    selectivityProfile: OlmSelectivityProfile;
}

export class AssignCombinedCriteriaIdsRequest implements IAssignCombinedCriteriaIdsRequest {
    selectivityProfile!: OlmSelectivityProfile;

    constructor(data?: IAssignCombinedCriteriaIdsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.selectivityProfile = new OlmSelectivityProfile();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selectivityProfile = _data["selectivityProfile"] ? OlmSelectivityProfile.fromJS(_data["selectivityProfile"]) : new OlmSelectivityProfile();
        }
    }

    static fromJS(data: any): AssignCombinedCriteriaIdsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssignCombinedCriteriaIdsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selectivityProfile"] = this.selectivityProfile ? this.selectivityProfile.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAssignCombinedCriteriaIdsRequest {
    selectivityProfile: OlmSelectivityProfile;
}

export class GetSelectivityTemplatesResponse implements IGetSelectivityTemplatesResponse {
    templates!: SelectivityTemplateGridDto[];

    constructor(data?: IGetSelectivityTemplatesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.templates = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["templates"])) {
                this.templates = [] as any;
                for (let item of _data["templates"])
                    this.templates!.push(SelectivityTemplateGridDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSelectivityTemplatesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSelectivityTemplatesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.templates)) {
            data["templates"] = [];
            for (let item of this.templates)
                data["templates"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSelectivityTemplatesResponse {
    templates: SelectivityTemplateGridDto[];
}

export class SelectivityTemplateGridDto implements ISelectivityTemplateGridDto {
    primaryKey?: number | undefined;
    name!: string;
    inclusion!: InclusionOperator;
    inclusionOperator!: string;
    criteriaCount!: number;
    sysPrinCount!: number;
    lastUpdatedBy!: string;
    lastUpdated!: Date;
    canUserDeleteThisTemplate!: boolean;

    constructor(data?: ISelectivityTemplateGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primaryKey = _data["primaryKey"];
            this.name = _data["name"];
            this.inclusion = _data["inclusion"];
            this.inclusionOperator = _data["inclusionOperator"];
            this.criteriaCount = _data["criteriaCount"];
            this.sysPrinCount = _data["sysPrinCount"];
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : <any>undefined;
            this.canUserDeleteThisTemplate = _data["canUserDeleteThisTemplate"];
        }
    }

    static fromJS(data: any): SelectivityTemplateGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectivityTemplateGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primaryKey"] = this.primaryKey;
        data["name"] = this.name;
        data["inclusion"] = this.inclusion;
        data["inclusionOperator"] = this.inclusionOperator;
        data["criteriaCount"] = this.criteriaCount;
        data["sysPrinCount"] = this.sysPrinCount;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : <any>undefined;
        data["canUserDeleteThisTemplate"] = this.canUserDeleteThisTemplate;
        return data;
    }
}

export interface ISelectivityTemplateGridDto {
    primaryKey?: number | undefined;
    name: string;
    inclusion: InclusionOperator;
    inclusionOperator: string;
    criteriaCount: number;
    sysPrinCount: number;
    lastUpdatedBy: string;
    lastUpdated: Date;
    canUserDeleteThisTemplate: boolean;
}

export class GetSelectivityTemplatesRequest implements IGetSelectivityTemplatesRequest {
    sysPrins!: SysPrinDto[];
    docTypeId!: number;

    constructor(data?: IGetSelectivityTemplatesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sysPrins = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sysPrins"])) {
                this.sysPrins = [] as any;
                for (let item of _data["sysPrins"])
                    this.sysPrins!.push(SysPrinDto.fromJS(item));
            }
            this.docTypeId = _data["docTypeId"];
        }
    }

    static fromJS(data: any): GetSelectivityTemplatesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSelectivityTemplatesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sysPrins)) {
            data["sysPrins"] = [];
            for (let item of this.sysPrins)
                data["sysPrins"].push(item.toJSON());
        }
        data["docTypeId"] = this.docTypeId;
        return data;
    }
}

export interface IGetSelectivityTemplatesRequest {
    sysPrins: SysPrinDto[];
    docTypeId: number;
}

export class GetSelectivityTemplateDetailsResponse implements IGetSelectivityTemplateDetailsResponse {
    templateId!: number;
    profile!: OlmSelectivityProfile;
    history!: ChangeHistoryItem[];

    constructor(data?: IGetSelectivityTemplateDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.profile = new OlmSelectivityProfile();
            this.history = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateId = _data["templateId"];
            this.profile = _data["profile"] ? OlmSelectivityProfile.fromJS(_data["profile"]) : new OlmSelectivityProfile();
            if (Array.isArray(_data["history"])) {
                this.history = [] as any;
                for (let item of _data["history"])
                    this.history!.push(ChangeHistoryItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSelectivityTemplateDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSelectivityTemplateDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId;
        data["profile"] = this.profile ? this.profile.toJSON() : <any>undefined;
        if (Array.isArray(this.history)) {
            data["history"] = [];
            for (let item of this.history)
                data["history"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSelectivityTemplateDetailsResponse {
    templateId: number;
    profile: OlmSelectivityProfile;
    history: ChangeHistoryItem[];
}

export class GetSelectivityTemplateDetailsRequest implements IGetSelectivityTemplateDetailsRequest {
    sysPrin!: SysPrinDto;
    docTypeId!: number;
    selectivityTemplateId!: number;

    constructor(data?: IGetSelectivityTemplateDetailsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sysPrin = new SysPrinDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sysPrin = _data["sysPrin"] ? SysPrinDto.fromJS(_data["sysPrin"]) : new SysPrinDto();
            this.docTypeId = _data["docTypeId"];
            this.selectivityTemplateId = _data["selectivityTemplateId"];
        }
    }

    static fromJS(data: any): GetSelectivityTemplateDetailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSelectivityTemplateDetailsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sysPrin"] = this.sysPrin ? this.sysPrin.toJSON() : <any>undefined;
        data["docTypeId"] = this.docTypeId;
        data["selectivityTemplateId"] = this.selectivityTemplateId;
        return data;
    }
}

export interface IGetSelectivityTemplateDetailsRequest {
    sysPrin: SysPrinDto;
    docTypeId: number;
    selectivityTemplateId: number;
}

export class DeleteSelectivityTemplateRequest implements IDeleteSelectivityTemplateRequest {
    sysPrin!: SysPrinDto;
    docTypeId!: number;
    selectivityTemplateIds!: number[];

    constructor(data?: IDeleteSelectivityTemplateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sysPrin = new SysPrinDto();
            this.selectivityTemplateIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sysPrin = _data["sysPrin"] ? SysPrinDto.fromJS(_data["sysPrin"]) : new SysPrinDto();
            this.docTypeId = _data["docTypeId"];
            if (Array.isArray(_data["selectivityTemplateIds"])) {
                this.selectivityTemplateIds = [] as any;
                for (let item of _data["selectivityTemplateIds"])
                    this.selectivityTemplateIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteSelectivityTemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteSelectivityTemplateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sysPrin"] = this.sysPrin ? this.sysPrin.toJSON() : <any>undefined;
        data["docTypeId"] = this.docTypeId;
        if (Array.isArray(this.selectivityTemplateIds)) {
            data["selectivityTemplateIds"] = [];
            for (let item of this.selectivityTemplateIds)
                data["selectivityTemplateIds"].push(item);
        }
        return data;
    }
}

export interface IDeleteSelectivityTemplateRequest {
    sysPrin: SysPrinDto;
    docTypeId: number;
    selectivityTemplateIds: number[];
}

export class GetTargetDatabaseInstancesResponse implements IGetTargetDatabaseInstancesResponse {
    databaseInstances!: string[];

    constructor(data?: IGetTargetDatabaseInstancesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.databaseInstances = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["databaseInstances"])) {
                this.databaseInstances = [] as any;
                for (let item of _data["databaseInstances"])
                    this.databaseInstances!.push(item);
            }
        }
    }

    static fromJS(data: any): GetTargetDatabaseInstancesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTargetDatabaseInstancesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.databaseInstances)) {
            data["databaseInstances"] = [];
            for (let item of this.databaseInstances)
                data["databaseInstances"].push(item);
        }
        return data;
    }
}

export interface IGetTargetDatabaseInstancesResponse {
    databaseInstances: string[];
}

export class SaveUserPreferencesRequest implements ISaveUserPreferencesRequest {
    preferencesJson!: string;

    constructor(data?: ISaveUserPreferencesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preferencesJson = _data["preferencesJson"];
        }
    }

    static fromJS(data: any): SaveUserPreferencesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveUserPreferencesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preferencesJson"] = this.preferencesJson;
        return data;
    }
}

export interface ISaveUserPreferencesRequest {
    preferencesJson: string;
}

export class SaveLoginRedirectRequest implements ISaveLoginRedirectRequest {
    loginRedirectValue!: boolean;

    constructor(data?: ISaveLoginRedirectRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loginRedirectValue = _data["loginRedirectValue"];
        }
    }

    static fromJS(data: any): SaveLoginRedirectRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveLoginRedirectRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loginRedirectValue"] = this.loginRedirectValue;
        return data;
    }
}

export interface ISaveLoginRedirectRequest {
    loginRedirectValue: boolean;
}

export class Anonymous implements IAnonymous {

    [key: string]: any;

    constructor(data?: IAnonymous) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): Anonymous {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface IAnonymous {

    [key: string]: any;
}

export class Anonymous2 implements IAnonymous2 {

    [key: string]: any;

    constructor(data?: IAnonymous2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): Anonymous2 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface IAnonymous2 {

    [key: string]: any;
}

export class Anonymous3 implements IAnonymous3 {

    [key: string]: any;

    constructor(data?: IAnonymous3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): Anonymous3 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface IAnonymous3 {

    [key: string]: any;
}

export class Data implements IData {

    [key: string]: any;

    constructor(data?: IData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): Data {
        data = typeof data === 'object' ? data : {};
        let result = new Data();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface IData {

    [key: string]: any;
}

export class Anonymous5 implements IAnonymous5 {

    [key: string]: any;

    constructor(data?: IAnonymous5) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): Anonymous5 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous5();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface IAnonymous5 {

    [key: string]: any;
}

export class Anonymous6 implements IAnonymous6 {

    [key: string]: any;

    constructor(data?: IAnonymous6) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): Anonymous6 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous6();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface IAnonymous6 {

    [key: string]: any;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}